import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

/** An object that represents temporary credentials for accessing AWS resources */
export type AwsCredentials = {
  __typename?: 'AWSCredentials';
  /** AWS access key ID */
  accessKeyId: Scalars['String']['output'];
  /** Date when the credentials expire */
  expiresAt: Scalars['DateTime']['output'];
  /** AWS secret access key */
  secretAccessKey: Scalars['String']['output'];
  /** AWS session token */
  sessionToken: Scalars['String']['output'];
};

/** Amazon S3 parameters */
export type Awss3Params = {
  __typename?: 'AWSS3Params';
  /** AWS S3 bucket */
  bucket: Scalars['String']['output'];
  /** AWS S3 object key */
  key: Scalars['String']['output'];
  /** AWS region */
  region: Scalars['String']['output'];
};

/** self practice results of submission */
export type Articulation = {
  __typename?: 'Articulation';
  fillerWordScore?: Maybe<Scalars['Float']['output']>;
  fillerWords?: Maybe<Array<Scalars['String']['output']>>;
  fillerWordsCount?: Maybe<Scalars['Float']['output']>;
  keywordScore?: Maybe<Scalars['Float']['output']>;
  mediaLength?: Maybe<Scalars['Float']['output']>;
  overallScore?: Maybe<Scalars['Float']['output']>;
  wordsPerMinute?: Maybe<Scalars['Float']['output']>;
  wpmScore?: Maybe<Scalars['Float']['output']>;
};

export type AssignmentInput = {
  lpSectionExternalId: Scalars['String']['input'];
};

export type AssignmentLp = {
  __typename?: 'AssignmentLP';
  assignmentSkillCards: AssignmentSkillCardConnection;
  assignmentSkills: AssignmentSkillConnection;
  companyProfile: CompanyProfile;
  companyProfileId: Scalars['UUID']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isLocked: Scalars['Boolean']['output'];
  learningPlan: LearningPlan;
  learningPlanId: Scalars['String']['output'];
  orderAssignedAt: Scalars['DateTime']['output'];
  progress: Scalars['Float']['output'];
  repCount: Scalars['Int']['output'];
  skillCount: Scalars['Int']['output'];
};

export type AssignmentLpConditions = {
  learningPlanId?: InputMaybe<StringCondition>;
};

export type AssignmentLpPageInfo = {
  __typename?: 'AssignmentLPPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

export type AssignmentList = {
  __typename?: 'AssignmentList';
  nodes: Array<AssignmentLp>;
};

export type AssignmentSkill = {
  __typename?: 'AssignmentSkill';
  companyProfileSkill: CompanyProfileSkill;
  id: Scalars['UUID']['output'];
  isLocked: Scalars['Boolean']['output'];
  learningPlan: LearningPlan;
  learningPlanId: Scalars['UUID']['output'];
  points: Scalars['Int']['output'];
};

export type AssignmentSkillCard = AssignmentSkillCardBase & {
  __typename?: 'AssignmentSkillCard';
  companyId: Scalars['UUID']['output'];
  companyProfileSkillId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  countOfLearningCardsAssignmentCompletions: Scalars['Int']['output'];
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isLocked: Scalars['Boolean']['output'];
  learningPlan: LearningPlan;
  learningPlanId: Scalars['UUID']['output'];
  lpCompanySectionExternalId?: Maybe<Scalars['String']['output']>;
  points: Scalars['Int']['output'];
  pointsEarned: Scalars['Int']['output'];
  progress?: Maybe<Scalars['Float']['output']>;
  repAssignmentId?: Maybe<Scalars['UUID']['output']>;
  repAssignmentStatus?: Maybe<RepAssignmentStatus>;
  repLastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  repSubmissionCount?: Maybe<Scalars['Int']['output']>;
  skill: Skill;
  skillExternalId: Scalars['String']['output'];
  skillFlow: SkillFlow;
  skillId: Scalars['UUID']['output'];
  skillType: SkillType;
  type: Scalars['String']['output'];
};

export type AssignmentSkillCardBase = {
  companyId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  learningPlanId: Scalars['UUID']['output'];
  lpCompanySectionExternalId?: Maybe<Scalars['String']['output']>;
  repAssignmentId?: Maybe<Scalars['UUID']['output']>;
  skillId: Scalars['UUID']['output'];
};

export type AssignmentSkillCardConnection = {
  __typename?: 'AssignmentSkillCardConnection';
  nodes: Array<AssignmentSkillCard>;
};

export type AssignmentSkillCardGetNext = AssignmentSkillCardBase & {
  __typename?: 'AssignmentSkillCardGetNext';
  companyId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  learningPlan: LearningPlan;
  learningPlanId: Scalars['UUID']['output'];
  lpCompanySectionExternalId?: Maybe<Scalars['String']['output']>;
  repAssignmentId?: Maybe<Scalars['UUID']['output']>;
  skill: Skill;
  skillId: Scalars['UUID']['output'];
  status: AssignmentSkillCardGetNextStatus;
};

/** AssignmentSkillCardGetNextStatus type options */
export enum AssignmentSkillCardGetNextStatus {
  FirstSkill = 'FIRST_SKILL',
  SkillInProgress = 'SKILL_IN_PROGRESS',
  StartNewSkill = 'START_NEW_SKILL'
}

export type AssignmentSkillCardTodaysPractice = AssignmentSkillCardBase & {
  __typename?: 'AssignmentSkillCardTodaysPractice';
  companyId: Scalars['UUID']['output'];
  companyProfileSkillId: Scalars['ID']['output'];
  countOfLearningCards: Scalars['Int']['output'];
  countOfLearningCardsAssignmentCompletions: Scalars['Int']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  learningPlan: LearningPlan;
  learningPlanId: Scalars['UUID']['output'];
  lpCompanySectionExternalId?: Maybe<Scalars['String']['output']>;
  points: Scalars['Int']['output'];
  pointsEarned: Scalars['Int']['output'];
  progress?: Maybe<Scalars['Float']['output']>;
  repAssignmentId?: Maybe<Scalars['UUID']['output']>;
  repAssignmentStatus?: Maybe<RepAssignmentStatus>;
  skill: Skill;
  skillExternalId: Scalars['String']['output'];
  skillFlow: SkillFlow;
  skillId: Scalars['UUID']['output'];
  skillType: SkillType;
  type: Scalars['String']['output'];
};

export type AssignmentSkillCardTodaysPracticeList = {
  __typename?: 'AssignmentSkillCardTodaysPracticeList';
  nodes: Array<AssignmentSkillCardTodaysPractice>;
};

export type AssignmentSkillConnection = {
  __typename?: 'AssignmentSkillConnection';
  nodes: Array<AssignmentSkill>;
};

/** Authentication channel related metadata. Currently Local, SSO/IDP based authentication supported. */
export type AuthChannelResponse = {
  __typename?: 'AuthChannelResponse';
  /** Authentication channel for the company. If SSO is enabled, it takes priority */
  channelType?: Maybe<AuthenticationChannelType>;
  /** Company external identifier. */
  companyExtId?: Maybe<Scalars['String']['output']>;
  /** Company internal identifier. */
  companyId?: Maybe<Scalars['String']['output']>;
  /** Company profile identifier. */
  companyProfileId?: Maybe<Scalars['String']['output']>;
  /** Metadata for Local authentication channel */
  localChannel?: Maybe<LocalChannel>;
  /** Metadata for SSO type channel */
  ssoChannel?: Maybe<SsoChannel>;
};

/** A pair of JWT short-lived access token and a long-lived refresh tokens. Access token can be passed in subsequent requests via http header "Authentication: Bearer ACCESS_TOKEN". */
export type AuthSession = {
  __typename?: 'AuthSession';
  /** Bearer JWT token used to access the app via Authentication header. */
  accessToken: Scalars['String']['output'];
  /** Company External ID. */
  companyExternalId: Scalars['String']['output'];
  /** Company Profile ID. */
  companyProfileId: Scalars['String']['output'];
  /** company profile external ID. */
  profileExternalId: Scalars['String']['output'];
  /** JWT token used to request a new pair of access and refresh tokens. */
  refreshToken: Scalars['String']['output'];
};

/** Available authentication channels */
export enum AuthenticationChannelType {
  Local = 'LOCAL',
  Sso = 'SSO'
}

/** Available auhthentication sources. */
export enum AuthenticationSource {
  Admin = 'ADMIN',
  App = 'APP'
}

/** data for auto evaluation */
export type AutoEvaluationCriteria = {
  __typename?: 'AutoEvaluationCriteria';
  keywordCheck?: Maybe<AutoEvaluationCriteriaKeywordCheck>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
};

/** keywords for auto evaluation */
export type AutoEvaluationCriteriaKeywordCheck = {
  __typename?: 'AutoEvaluationCriteriaKeywordCheck';
  allowedKeywords?: Maybe<Array<Scalars['String']['output']>>;
  incorrectKeywords?: Maybe<Array<Scalars['String']['output']>>;
};

/** results of auto evaluation for submission */
export type AutoEvaluationKeywordCheck = {
  __typename?: 'AutoEvaluationKeywordCheck';
  allowedKeywordsFuzzyMatched?: Maybe<Array<FuzzyMatch>>;
  allowedKeywordsMatched?: Maybe<Array<Scalars['String']['output']>>;
  allowedKeywordsMatchedV2?: Maybe<Array<KeywordsMatch>>;
  allowedKeywordsNotMatched?: Maybe<Array<Scalars['String']['output']>>;
  incorrectKeywordsFuzzyMatched?: Maybe<Array<FuzzyMatch>>;
  incorrectKeywordsMatched?: Maybe<Array<Scalars['String']['output']>>;
  incorrectKeywordsMatchedV2?: Maybe<Array<KeywordsMatch>>;
  incorrectKeywordsNotMatched?: Maybe<Array<Scalars['String']['output']>>;
};

/** results of auto evaluation for submission */
export type AutoEvaluationOutcome = {
  __typename?: 'AutoEvaluationOutcome';
  articulation?: Maybe<Articulation>;
  contentScore?: Maybe<ContentScore>;
  conversationMetrics?: Maybe<ConversationMetrics>;
  isArticulationPass?: Maybe<Scalars['Boolean']['output']>;
  isKeywordPass?: Maybe<Scalars['Boolean']['output']>;
  keywordCheck?: Maybe<AutoEvaluationKeywordCheck>;
  languageCode?: Maybe<Scalars['String']['output']>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  sentiment?: Maybe<Scalars['Float']['output']>;
};

export type AwsOutcome = {
  __typename?: 'AwsOutcome';
  accountId?: Maybe<Scalars['String']['output']>;
  jobName?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Results>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Basic parameters to handle pagination. */
export type BaseClassicPaginate = {
  /** Starting pointer where to  collect objects from, similar to offset. Passing null will return the first <limit> objects. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of objects returned per page. */
  limit: Scalars['Int']['input'];
};

export type CertificatesCompanyProfile = {
  __typename?: 'CertificatesCompanyProfile';
  campaignName: Scalars['String']['output'];
  certPath?: Maybe<Scalars['String']['output']>;
  certUrl: Scalars['String']['output'];
  certificateId: Scalars['UUID']['output'];
  companyId: Scalars['UUID']['output'];
  companyProfileId: Scalars['UUID']['output'];
  issuedAt: Scalars['DateTime']['output'];
  learningPlanId: Scalars['UUID']['output'];
};

export type Choice = {
  __typename?: 'Choice';
  choiceLocalized?: Maybe<ChoiceLocalized>;
  id: Scalars['UUID']['output'];
  /** Return if the Choice is Correct or not. If it's 'null', it's because the server can not expose this info yet.  */
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  position: Scalars['Int']['output'];
  promptId: Scalars['UUID']['output'];
  type: ChoiceType;
};

export type ChoiceConnection = {
  __typename?: 'ChoiceConnection';
  nodes: Array<Choice>;
};

export type ChoiceLocalized = {
  __typename?: 'ChoiceLocalized';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  language: Language;
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['UUID']['output']>;
};

export type ChoiceTransactional = {
  __typename?: 'ChoiceTransactional';
  answer?: Maybe<Scalars['String']['output']>;
  choiceLocalized?: Maybe<ChoiceLocalized>;
  id: Scalars['UUID']['output'];
  /** Return if the Choice is Correct or not. If it's 'null', it's because the server can not expose this info yet.  */
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  /** Return if the Choice was submitted successfully or not. */
  isFailed?: Maybe<Scalars['Boolean']['output']>;
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  learningCardCompletionFormId?: Maybe<Scalars['UUID']['output']>;
  position: Scalars['Int']['output'];
  promptId: Scalars['UUID']['output'];
  type: ChoiceType;
};

export type ChoiceTransactionalConnection = {
  __typename?: 'ChoiceTransactionalConnection';
  nodes: Array<ChoiceTransactional>;
};

/** Form prompt choice type. */
export enum ChoiceType {
  Image = 'IMAGE',
  Input = 'INPUT',
  Text = 'TEXT'
}

/** Configuration for handling correct form prompt choices. */
export enum ChoicesCountConfig {
  CorrectChoicesCount = 'CORRECT_CHOICES_COUNT',
  MinMax = 'MIN_MAX'
}

/** Cohort member type options */
export enum CohortMemberType {
  Coach = 'COACH',
  Learner = 'LEARNER',
  Peer = 'PEER'
}

export type Company = {
  __typename?: 'Company';
  companyAuthentications: CompanyAuthenticationConnection;
  companyLanguages: CompanyLanguageConnection;
  defaultLanguage?: Maybe<Language>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoMedia?: Maybe<Media>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CompanyAuthentication = {
  __typename?: 'CompanyAuthentication';
  app: Scalars['String']['output'];
  authenticationType: Scalars['String']['output'];
  companyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type CompanyAuthenticationConnection = {
  __typename?: 'CompanyAuthenticationConnection';
  nodes: Array<CompanyAuthentication>;
};

export type CompanyCohort = {
  __typename?: 'CompanyCohort';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata: Scalars['JSONObject']['output'];
  name: Scalars['String']['output'];
};

export type CompanyCohortMember = {
  __typename?: 'CompanyCohortMember';
  companyCohort: CompanyCohort;
  id: Scalars['ID']['output'];
  type: CohortMemberType;
};

export type CompanyFindByEncExtIdResponse = {
  __typename?: 'CompanyFindByEncExtIdResponse';
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  signupMetadata?: Maybe<Scalars['JSON']['output']>;
};

export type CompanyLanguage = {
  __typename?: 'CompanyLanguage';
  company: Company;
  companyId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use company.default_language instead */
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  language: Language;
};

export type CompanyLanguageConnection = {
  __typename?: 'CompanyLanguageConnection';
  nodes: Array<CompanyLanguage>;
};

export type CompanyProfile = {
  __typename?: 'CompanyProfile';
  company: Company;
  companyCohortMembers: Array<CompanyCohortMember>;
  companyId: Scalars['UUID']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  excludeFromAnalytics: Scalars['Boolean']['output'];
  externalId: Scalars['String']['output'];
  hasCoachedReps: Scalars['Boolean']['output'];
  hasSocialReps: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isCoach: Scalars['Boolean']['output'];
  language?: Maybe<Language>;
  permissions: Array<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profile: Profile;
  /** @deprecated It has been replaced by "CompanyProfile.externalId". */
  profileExternalId: Scalars['String']['output'];
  profileId: Scalars['UUID']['output'];
  profileTags: ProfileTagConnection;
  score: Scalars['Int']['output'];
};

export type CompanyProfileConnection = {
  __typename?: 'CompanyProfileConnection';
  nodes: Array<CompanyProfile>;
};

export type CompanyProfileSearchFilteredByGroupConditions = {
  /** Filter by specific company profile ID. */
  id?: InputMaybe<UuidCondition>;
  /** Add filter for coached members */
  isCoached?: InputMaybe<Scalars['Boolean']['input']>;
  /** Add filter by profiles who have a Rep Assignment for the given Rep prompt ID. */
  repPromptId?: InputMaybe<UuidCondition>;
  /** Search terms. Will look in display name, preferred name, email address, phone number and external ID. */
  searchTerms?: InputMaybe<StringCondition>;
};

export type CompanyProfileSearchFilteredByGroupPageInfo = {
  __typename?: 'CompanyProfileSearchFilteredByGroupPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileSkill = {
  __typename?: 'CompanyProfileSkill';
  assignmentSkill?: Maybe<AssignmentSkill>;
  companyProfile?: Maybe<CompanyProfile>;
  companyProfileId: Scalars['UUID']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  feedback?: Maybe<Feedback>;
  id: Scalars['ID']['output'];
  learningCardAssignmentCompletions: LearningCardAssignmentCompletionConnection;
  pointsEarned: Scalars['Int']['output'];
  progress?: Maybe<Scalars['Float']['output']>;
  repAssignment?: Maybe<RepAssignment>;
  skill: Skill;
  skillId: Scalars['String']['output'];
  skillType: SkillType;
  triesCount?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
};

export type CompanyProfileSkillGetNext = {
  __typename?: 'CompanyProfileSkillGetNext';
  id: Scalars['ID']['output'];
  lpCompanySectionExternalId: Scalars['String']['output'];
  repAssignmentId?: Maybe<Scalars['ID']['output']>;
  repStatus?: Maybe<RepAssignmentStatus>;
  repType?: Maybe<RepType>;
  skillExternalId: Scalars['String']['output'];
  skillFlow: SkillFlow;
  skillId: Scalars['UUID']['output'];
  skillName: Scalars['String']['output'];
  skillType: SkillType;
};

export type ContentMetadata = {
  __typename?: 'ContentMetadata';
  acl1?: Maybe<Array<Scalars['String']['output']>>;
  acl2?: Maybe<Array<Scalars['String']['output']>>;
  acl3?: Maybe<Array<Scalars['String']['output']>>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyProfileId?: Maybe<Scalars['String']['output']>;
  masterMediaId?: Maybe<Scalars['String']['output']>;
  mediaId?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  s3Location?: Maybe<Scalars['String']['output']>;
  skillId?: Maybe<Scalars['String']['output']>;
  streamingUrl?: Maybe<Scalars['String']['output']>;
  submissionId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Scores for different aspects of the conversation content */
export type ContentScore = {
  __typename?: 'ContentScore';
  coherence: Scalars['Float']['output'];
  consistency: Scalars['Float']['output'];
  grammar: Scalars['Float']['output'];
  toneNstyle: Scalars['Float']['output'];
};

/** Metrics related to conversation analysis */
export type ConversationMetrics = {
  __typename?: 'ConversationMetrics';
  conversationType: Scalars['String']['output'];
  needsIdentificationScore: NeedsIdentificationScore;
  noOfSubmitterQuestions?: Maybe<Scalars['Int']['output']>;
  nonVerbalSkillScore: NonVerbalSkillScore;
  openEndedQuestions: Array<OpenEndedQuestion>;
  overallFeedback?: Maybe<Scalars['String']['output']>;
  questionRate: Scalars['Float']['output'];
  speakerLabels?: Maybe<Array<SpeakerLabel>>;
  stackedQuestions: Array<StackedQuestion>;
  thresholds: ConversationMetricsThresholds;
};

export type ConversationMetricsThresholds = {
  __typename?: 'ConversationMetricsThresholds';
  noOfSubmitterQuestions: Scalars['Float']['output'];
  pauseDuration: Array<Scalars['Float']['output']>;
  questionRate: Scalars['Float']['output'];
  stackedQuestionsCount: Scalars['Int']['output'];
  talkRatio: Scalars['Float']['output'];
};

/** Conversation roles */
export type ConversationRoles = {
  __typename?: 'ConversationRoles';
  audience: Scalars['String']['output'];
  submitter: Scalars['String']['output'];
};

/** ConversationType options */
export enum ConversationType {
  DiscoveryCall = 'DISCOVERY_CALL'
}

export type CreateUserResponse = {
  __typename?: 'CreateUserResponse';
  assignments?: Maybe<Array<AssignmentLp>>;
  companyProfile: CompanyProfile;
};

export type Device = {
  __typename?: 'Device';
  id: Scalars['ID']['output'];
  os: DeviceOs;
  profileId: Scalars['ID']['output'];
  token: Scalars['String']['output'];
};

/** Device OS options */
export enum DeviceOs {
  Android = 'ANDROID',
  Ios = 'IOS'
}

/** results of error status */
export type ErrorMsg = {
  __typename?: 'ErrorMsg';
  error?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['String']['output']>;
};

/** Feature flags */
export enum FeatureType {
  AnonymousUsers = 'ANONYMOUS_USERS',
  DashboardSkillsWithReps = 'DASHBOARD_SKILLS_WITH_REPS',
  DisableSkillToSkillAutoplay = 'DISABLE_SKILL_TO_SKILL_AUTOPLAY',
  Forms = 'FORMS',
  KeywordAnalysisOnPractices = 'KEYWORD_ANALYSIS_ON_PRACTICES',
  MediaCaptureTestPage = 'MEDIA_CAPTURE_TEST_PAGE',
  RepSkill = 'REP_SKILL',
  SkillSelfies = 'SKILL_SELFIES',
  SkillVideoS3Mux = 'SKILL_VIDEO_S3_MUX',
  TranscribeContent = 'TRANSCRIBE_CONTENT',
  VideoAutoPlay = 'VIDEO_AUTO_PLAY',
  WupAutoplay = 'WUP_AUTOPLAY'
}

export type Feedback = {
  __typename?: 'Feedback';
  id: Scalars['UUID']['output'];
  objectType: FeedbackObjectType;
  rating?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['String']['output']>;
};

/** Feedback object type options */
export enum FeedbackObjectType {
  LearningCard = 'LEARNING_CARD',
  Skill = 'SKILL'
}

/** Feedback rating type options */
export enum FeedbackRatingType {
  Freedom = 'FREEDOM',
  Stars = 'STARS',
  Thumbs = 'THUMBS'
}

export type FinalizeMultipartUploadPart = {
  /** Etag returned by S3 for the chuncked part uploaded. */
  eTag: Scalars['String']['input'];
  /** Number of url to upload a file chucked to S3. */
  partNumber: Scalars['Int']['input'];
};

/** Feature flag. */
export type Flag = {
  __typename?: 'Flag';
  /** Flag name, always lowercase. */
  name: Scalars['String']['output'];
  /** Flag value type. Possible values: boolean, string, number, array, object. */
  type: Scalars['String']['output'];
  /** Flag value. Numbers, booleans, and JSON are coerced into strings. Disabled flags or false booleans are not returned. */
  value: Scalars['String']['output'];
};

export type Form = {
  __typename?: 'Form';
  companyId: Scalars['UUID']['output'];
  formLocalized?: Maybe<FormLocalized>;
  id: Scalars['UUID']['output'];
  maxTries?: Maybe<Scalars['Int']['output']>;
  maxTriesPerPrompt?: Maybe<MaxTriesPerPrompt>;
  name: Scalars['String']['output'];
  passingThreshold?: Maybe<Scalars['Float']['output']>;
  prompts: PromptConnection;
  showCorrectChoicesAtTheEnd?: Maybe<Scalars['Boolean']['output']>;
  type: FormType;
};

export type FormLocalized = {
  __typename?: 'FormLocalized';
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  language: Language;
};

export type FormTransactional = {
  __typename?: 'FormTransactional';
  companyId: Scalars['UUID']['output'];
  formLocalized?: Maybe<FormLocalized>;
  id: Scalars['UUID']['output'];
  learningCardAssignmentCompletion?: Maybe<LearningCardAssignmentCompletion>;
  learningCardAssignmentCompletionId?: Maybe<Scalars['UUID']['output']>;
  maxTries?: Maybe<Scalars['Int']['output']>;
  maxTriesPerPrompt?: Maybe<MaxTriesPerPrompt>;
  name: Scalars['String']['output'];
  passingThreshold?: Maybe<Scalars['Float']['output']>;
  prompts: PromptTransactionalConnection;
  showCorrectChoicesAtTheEnd?: Maybe<Scalars['Boolean']['output']>;
  type: FormType;
};

/** Form type. */
export enum FormType {
  Quiz = 'QUIZ',
  Rubric = 'RUBRIC',
  Survey = 'SURVEY'
}

export type FunctionPageInfo = {
  __typename?: 'FunctionPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

/** probably matched keywords */
export type FuzzyMatch = {
  __typename?: 'FuzzyMatch';
  actualKeyword?: Maybe<Scalars['String']['output']>;
  expectedKeyword?: Maybe<Scalars['String']['output']>;
  fuzzyIndex?: Maybe<Scalars['Float']['output']>;
};

export type GetMultipartUploadDataPart = {
  __typename?: 'GetMultipartUploadDataPart';
  /** Number of url to upload a file chucked to S3. */
  partNumber: Scalars['Int']['output'];
  /** Signed url to upload a file to S3. */
  signedUrl: Scalars['String']['output'];
};

export type GetTranscriptionMediaObjectById = {
  __typename?: 'GetTranscriptionMediaObjectById';
  awsOutcome?: Maybe<AwsOutcome>;
  contentMetadata?: Maybe<ContentMetadata>;
  provider?: Maybe<Scalars['String']['output']>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
};

export type GroupLeaderBoard = {
  __typename?: 'GroupLeaderBoard';
  groupName: Scalars['String']['output'];
  groupScores: Array<GroupLeaderBoardItem>;
};

export type GroupLeaderBoardItem = {
  __typename?: 'GroupLeaderBoardItem';
  rowIconURL: Scalars['String']['output'];
  rowName: Scalars['String']['output'];
  rowScore: Scalars['Int']['output'];
};

export type Home = {
  __typename?: 'Home';
  /** First 3 most relevant Learning Plans to look into */
  assignments: HomeAssignmentLpConnection;
  coachRepAssignments?: Maybe<HomeCoachRepAssignment>;
  /** Which components should be rendered, also specifies order. */
  components: Array<Scalars['String']['output']>;
  /** The next Skill Card (Rep or Content) suggested to continue with */
  nextSkillCard?: Maybe<AssignmentSkillCard>;
  proScore?: Maybe<ProScoreV3>;
  socialReps?: Maybe<SocialReps>;
  topics?: Maybe<Topics>;
};

export type HomeAssignmentLpConnection = {
  __typename?: 'HomeAssignmentLPConnection';
  nodes: Array<AssignmentLp>;
};

export type HomeCoachRepAssignment = {
  __typename?: 'HomeCoachRepAssignment';
  nodes: Array<RepAssignment>;
  totalCount: Scalars['Int']['output'];
};

/** Image Size options. */
export enum ImageSize {
  L = 'L',
  M = 'M',
  Original = 'ORIGINAL',
  S = 'S'
}

/** probably matched description */
export type Interjection = {
  __typename?: 'Interjection';
  author?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Array<InterjectionMessage>>;
  start?: Maybe<Scalars['String']['output']>;
};

export type InterjectionMessage = {
  __typename?: 'InterjectionMessage';
  language: Language;
  translatedText?: Maybe<Scalars['String']['output']>;
};

/** Interjection */
export type InterjectionsHandling = {
  __typename?: 'InterjectionsHandling';
  interjections?: Maybe<Array<Interjection>>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
};

/** matched keywords */
export type KeywordsMatch = {
  __typename?: 'KeywordsMatch';
  actualKeyword?: Maybe<Scalars['String']['output']>;
  expectedKeyword?: Maybe<Scalars['String']['output']>;
};

export type LpCompanySection = {
  __typename?: 'LPCompanySection';
  externalId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
};

export type LpSection = {
  __typename?: 'LPSection';
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  learningPlan: LearningPlan;
  /** @deprecated This will be removed in favor of externalId in LPSection type. */
  lpCompanySection: LpCompanySection;
  lpSectionLocalized: LpSectionLocalized;
  lpSectionSkills: LpSectionSkillConnection;
  position: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LpSectionConnection = {
  __typename?: 'LPSectionConnection';
  nodes: Array<LpSection>;
};

export type LpSectionLocalized = {
  __typename?: 'LPSectionLocalized';
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  language: Language;
};

export type LpSectionSkill = {
  __typename?: 'LPSectionSkill';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lpSection: LpSection;
  points: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  skill: Skill;
  skillId: Scalars['String']['output'];
};

export type LpSectionSkillConnection = {
  __typename?: 'LPSectionSkillConnection';
  nodes: Array<LpSectionSkill>;
};

/** Language options */
export enum Language {
  Aa = 'aa',
  Ab = 'ab',
  Ae = 'ae',
  Af = 'af',
  Ak = 'ak',
  Am = 'am',
  An = 'an',
  Ar = 'ar',
  As = 'as',
  Av = 'av',
  Ay = 'ay',
  Az = 'az',
  Ba = 'ba',
  Be = 'be',
  Bg = 'bg',
  Bh = 'bh',
  Bi = 'bi',
  Bm = 'bm',
  Bn = 'bn',
  BnBd = 'bn_BD',
  Bo = 'bo',
  Br = 'br',
  Bs = 'bs',
  Ca = 'ca',
  Ce = 'ce',
  Ch = 'ch',
  Co = 'co',
  Cr = 'cr',
  Cs = 'cs',
  Cu = 'cu',
  Cv = 'cv',
  Cy = 'cy',
  Da = 'da',
  De = 'de',
  Dv = 'dv',
  Dz = 'dz',
  Ee = 'ee',
  El = 'el',
  En = 'en',
  Eo = 'eo',
  Es = 'es',
  Et = 'et',
  Eu = 'eu',
  Fa = 'fa',
  Ff = 'ff',
  Fi = 'fi',
  Fil = 'fil',
  Fj = 'fj',
  Fo = 'fo',
  Fr = 'fr',
  Fy = 'fy',
  Ga = 'ga',
  Gd = 'gd',
  Gl = 'gl',
  Gn = 'gn',
  Gu = 'gu',
  Gv = 'gv',
  Ha = 'ha',
  He = 'he',
  Hi = 'hi',
  Ho = 'ho',
  Hr = 'hr',
  Ht = 'ht',
  Hu = 'hu',
  Hy = 'hy',
  Hz = 'hz',
  Ia = 'ia',
  Id = 'id',
  Ie = 'ie',
  Ig = 'ig',
  Ii = 'ii',
  Ik = 'ik',
  Io = 'io',
  Is = 'is',
  It = 'it',
  Iu = 'iu',
  Ja = 'ja',
  Jv = 'jv',
  Ka = 'ka',
  Kg = 'kg',
  Ki = 'ki',
  Kj = 'kj',
  Kk = 'kk',
  Kl = 'kl',
  Km = 'km',
  Kn = 'kn',
  Ko = 'ko',
  Kr = 'kr',
  Ks = 'ks',
  Ku = 'ku',
  Kv = 'kv',
  Kw = 'kw',
  Ky = 'ky',
  La = 'la',
  Lb = 'lb',
  Lg = 'lg',
  Li = 'li',
  Ln = 'ln',
  Lo = 'lo',
  Lt = 'lt',
  Lu = 'lu',
  Lv = 'lv',
  Mg = 'mg',
  Mh = 'mh',
  Mi = 'mi',
  Mk = 'mk',
  Ml = 'ml',
  Mn = 'mn',
  Mr = 'mr',
  Ms = 'ms',
  Mt = 'mt',
  Na = 'na',
  Nb = 'nb',
  Nd = 'nd',
  Ne = 'ne',
  Ng = 'ng',
  Nl = 'nl',
  Nn = 'nn',
  No = 'no',
  Nr = 'nr',
  Nv = 'nv',
  Ny = 'ny',
  Oc = 'oc',
  Oj = 'oj',
  Om = 'om',
  Or = 'or',
  Os = 'os',
  Pa = 'pa',
  Pi = 'pi',
  Pl = 'pl',
  Ps = 'ps',
  Pt = 'pt',
  PtBr = 'pt_BR',
  Qu = 'qu',
  Rm = 'rm',
  Rn = 'rn',
  Ro = 'ro',
  Ru = 'ru',
  Rw = 'rw',
  Sa = 'sa',
  Sc = 'sc',
  Sd = 'sd',
  Se = 'se',
  Sg = 'sg',
  Si = 'si',
  Sk = 'sk',
  Sl = 'sl',
  Sm = 'sm',
  Sn = 'sn',
  So = 'so',
  Sq = 'sq',
  Sr = 'sr',
  Ss = 'ss',
  St = 'st',
  Su = 'su',
  Sv = 'sv',
  Sw = 'sw',
  Ta = 'ta',
  Te = 'te',
  Tg = 'tg',
  Th = 'th',
  Ti = 'ti',
  Tk = 'tk',
  Tn = 'tn',
  To = 'to',
  Tr = 'tr',
  Ts = 'ts',
  Tt = 'tt',
  Tw = 'tw',
  Ty = 'ty',
  Ug = 'ug',
  Uk = 'uk',
  Ur = 'ur',
  Uz = 'uz',
  Ve = 've',
  ViVn = 'vi_VN',
  Vo = 'vo',
  Wa = 'wa',
  Wo = 'wo',
  Xh = 'xh',
  Yi = 'yi',
  Yo = 'yo',
  Za = 'za',
  Zh = 'zh',
  ZhCn = 'zh_CN',
  ZhHk = 'zh_HK',
  ZhTw = 'zh_TW',
  Zu = 'zu'
}

export type Leaderboard = {
  __typename?: 'Leaderboard';
  completedAssignments: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  scores: Array<Scalars['Int']['output']>;
  totalAssignments: Scalars['Int']['output'];
};

export type LeaderboardV2 = {
  __typename?: 'LeaderboardV2';
  leaderBoards: Array<GroupLeaderBoard>;
};

export type LeaderboardV3 = {
  __typename?: 'LeaderboardV3';
  leaderBoard?: Maybe<SocialGroupLeaderBoard>;
};

export type LearningCard = {
  __typename?: 'LearningCard';
  experimentConfig?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['UUID']['output'];
  learningCardLocalized: LearningCardUnion;
  position: Scalars['Int']['output'];
  resetLpIfFail: Scalars['Boolean']['output'];
  type: LearningCardType;
};

export type LearningCardAssignmentCompletion = {
  __typename?: 'LearningCardAssignmentCompletion';
  companyProfileId: Scalars['UUID']['output'];
  companyProfileSkill?: Maybe<CompanyProfileSkill>;
  companyProfileSkillId: Scalars['UUID']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  feedback?: Maybe<Feedback>;
  formTransactional?: Maybe<FormTransactional>;
  id: Scalars['UUID']['output'];
  learningCardCompletionFormSummary?: Maybe<LearningCardCompletionFormConnection>;
  learningCardId: Scalars['UUID']['output'];
  pointsEarned: Scalars['Int']['output'];
  progress: Scalars['Float']['output'];
  skillCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt: Scalars['DateTime']['output'];
  triesCount: Scalars['Int']['output'];
  type: LearningCardType;
};

export type LearningCardAssignmentCompletionConnection = {
  __typename?: 'LearningCardAssignmentCompletionConnection';
  nodes: Array<LearningCardAssignmentCompletion>;
};

export type LearningCardCompletionForm = {
  __typename?: 'LearningCardCompletionForm';
  /** This is only available if form.showCorrectChoicesAtTheEnd = true and learningCardCompletionForm.isCompleted = true. */
  correctChoices?: Maybe<ChoiceConnection>;
  id: Scalars['UUID']['output'];
  isCompleted: Scalars['Boolean']['output'];
  isFailed: Scalars['Boolean']['output'];
  learningCardAssignmentCompletion: LearningCardAssignmentCompletion;
  learningCardAssignmentCompletionId: Scalars['UUID']['output'];
  learningCardCompletionFormAnswers: LearningCardCompletionFormAnswerConnection;
  learningCardCompletionFormAnswersSummary: LearningCardCompletionFormAnswerSummaryConnection;
  promptId: Scalars['UUID']['output'];
  submittedAt: Scalars['DateTime']['output'];
};

export type LearningCardCompletionFormAnswer = {
  __typename?: 'LearningCardCompletionFormAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  choiceId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  learningCardCompletionFormId: Scalars['UUID']['output'];
};

export type LearningCardCompletionFormAnswerArg = {
  answer?: InputMaybe<Scalars['String']['input']>;
  choiceId?: InputMaybe<Scalars['UUID']['input']>;
};

export type LearningCardCompletionFormAnswerConnection = {
  __typename?: 'LearningCardCompletionFormAnswerConnection';
  nodes: Array<LearningCardCompletionFormAnswer>;
};

export type LearningCardCompletionFormAnswerSummary = {
  __typename?: 'LearningCardCompletionFormAnswerSummary';
  answer?: Maybe<Scalars['String']['output']>;
  choiceId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  isFailed: Scalars['Boolean']['output'];
  learningCardCompletionFormId?: Maybe<Scalars['UUID']['output']>;
};

export type LearningCardCompletionFormAnswerSummaryConnection = {
  __typename?: 'LearningCardCompletionFormAnswerSummaryConnection';
  nodes: Array<LearningCardCompletionFormAnswerSummary>;
};

export type LearningCardCompletionFormConnection = {
  __typename?: 'LearningCardCompletionFormConnection';
  nodes: Array<LearningCardCompletionForm>;
};

export type LearningCardConnection = {
  __typename?: 'LearningCardConnection';
  nodes: Array<LearningCard>;
};

export type LearningCardForm = {
  __typename?: 'LearningCardForm';
  form: Form;
  formId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  learningCardId: Scalars['UUID']['output'];
  type: LearningCardType;
};

export type LearningCardLocalizedFile = {
  __typename?: 'LearningCardLocalizedFile';
  id: Scalars['UUID']['output'];
  language: Language;
  learningCardId: Scalars['UUID']['output'];
  media?: Maybe<Media>;
  mediaId: Scalars['UUID']['output'];
  /** @deprecated moved to media table */
  mimetype?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** @deprecated not in use anymore */
  transformedMediaUrl?: Maybe<Scalars['String']['output']>;
  type: LearningCardType;
  url?: Maybe<Scalars['String']['output']>;
};

export type LearningCardLocalizedFlashCard = {
  __typename?: 'LearningCardLocalizedFlashCard';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  language: Language;
  learningCardId: Scalars['UUID']['output'];
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['UUID']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /**
   * Get media full url. Media can be requested with specific transformations, which are Cloudinary-compatible.
   * @deprecated Deprecated in favor of LearningCardLocalizedFlashCard.media
   */
  transformedMediaUrl?: Maybe<Scalars['String']['output']>;
  type: LearningCardType;
};


export type LearningCardLocalizedFlashCardTransformedMediaUrlArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  transformations?: InputMaybe<Scalars['JSON']['input']>;
};

export type LearningCardLocalizedLinkout = {
  __typename?: 'LearningCardLocalizedLinkout';
  ctaTitle?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  learningCardId: Scalars['UUID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: LearningCardType;
  url?: Maybe<Scalars['String']['output']>;
};

export type LearningCardLocalizedVideo = {
  __typename?: 'LearningCardLocalizedVideo';
  brightcoveAccountId?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  language: Language;
  learningCardId: Scalars['UUID']['output'];
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['UUID']['output']>;
  posterMedia?: Maybe<Media>;
  posterMediaId?: Maybe<Scalars['UUID']['output']>;
  posterUrl?: Maybe<Scalars['String']['output']>;
  streamMedia?: Maybe<Media>;
  streamMediaId?: Maybe<Scalars['UUID']['output']>;
  textTrackMedia?: Maybe<Media>;
  textTrackMediaId?: Maybe<Scalars['UUID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: LearningCardType;
  videoId?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type LearningCardRep = {
  __typename?: 'LearningCardRep';
  id: Scalars['UUID']['output'];
  learningCardId: Scalars['UUID']['output'];
  repPrompt: RepPrompt;
  repPromptId: Scalars['UUID']['output'];
  type: LearningCardType;
};

/** Learning Card types */
export enum LearningCardType {
  File = 'FILE',
  FlashCard = 'FLASH_CARD',
  Form = 'FORM',
  Linkout = 'LINKOUT',
  Quiz = 'QUIZ',
  Rep = 'REP',
  Video = 'VIDEO'
}

export type LearningCardUnion = LearningCardForm | LearningCardLocalizedFile | LearningCardLocalizedFlashCard | LearningCardLocalizedLinkout | LearningCardLocalizedVideo | LearningCardRep;

export type LearningPlan = {
  __typename?: 'LearningPlan';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueSoon?: Maybe<Scalars['Boolean']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  learningPlanFolderId?: Maybe<Scalars['UUID']['output']>;
  learningPlanLocalized: LearningPlanLocalized;
  lpSections: LpSectionConnection;
  mandatory?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  /** Get media full url. Media can be requested with specific transformations, which are Cloudinary-compatible. */
  transformedMediaUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type LearningPlanTransformedMediaUrlArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  transformations?: InputMaybe<Scalars['JSON']['input']>;
};

export type LearningPlanAssignmentDetail = {
  __typename?: 'LearningPlanAssignmentDetail';
  details?: Maybe<Scalars['String']['output']>;
  lpSectionExternalId: Scalars['String']['output'];
  skillExternalId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type LearningPlanAssignmentResponse = {
  __typename?: 'LearningPlanAssignmentResponse';
  details: Array<LearningPlanAssignmentDetail>;
  success: Scalars['Boolean']['output'];
};

export type LearningPlanLocalized = {
  __typename?: 'LearningPlanLocalized';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  language: Language;
  learningPlanFolderName?: Maybe<Scalars['String']['output']>;
  learningPlanId: Scalars['UUID']['output'];
};

/** Metadata for Local authentication channel */
export type LocalChannel = {
  __typename?: 'LocalChannel';
  /** List of local authentication types supported e.g. EMAIL | PHONE | URL */
  supportedTypes?: Maybe<Array<Scalars['String']['output']>>;
};

export type LogoutInput = {
  /** Application from where the mutation is called. */
  source?: InputMaybe<AuthenticationSource>;
};

/** Maximum number of tries per form prompt. */
export enum MaxTriesPerPrompt {
  One = 'ONE',
  Unlimited = 'UNLIMITED'
}

/** An object that represents a media like photo, video, pdf or others. The client is responsible for uploading the asset to a supported source (i.e. Cloudinary, S3) and then use the mediaCreate mutation to register it in the system. */
export type Media = {
  __typename?: 'Media';
  createdAt: Scalars['DateTime']['output'];
  /** Media processing error. */
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** The service where the media is stored. */
  location: MediaLocation;
  /** Simplified Media type to avoid using regex on mime type. */
  mediaType: MediaType;
  /**
   * Get media full url. Media can be requested with specific transformations, which are Cloudinary-compatible.
   * @deprecated Deprecated in favor of Media.mediaUrlV2.
   */
  mediaUrl?: Maybe<Scalars['String']['output']>;
  /** Get media full url. */
  mediaUrlV2?: Maybe<Scalars['String']['output']>;
  /** Full mime type */
  mimeType: Scalars['String']['output'];
  /** Path where the raw media is located. For Cloudinary media, this path could be private. */
  path: Scalars['String']['output'];
  /** Media processing status. */
  status: MediaStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** An object that represents a media like photo, video, pdf or others. The client is responsible for uploading the asset to a supported source (i.e. Cloudinary, S3) and then use the mediaCreate mutation to register it in the system. */
export type MediaMediaUrlArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  transformations?: InputMaybe<Scalars['JSON']['input']>;
};


/** An object that represents a media like photo, video, pdf or others. The client is responsible for uploading the asset to a supported source (i.e. Cloudinary, S3) and then use the mediaCreate mutation to register it in the system. */
export type MediaMediaUrlV2Args = {
  imageSize?: InputMaybe<ImageSize>;
};

/** The service where the media is stored. */
export enum MediaLocation {
  Cloudinary = 'CLOUDINARY',
  Mux = 'MUX',
  S3 = 'S3'
}

/** Media status */
export enum MediaStatus {
  Aborted = 'ABORTED',
  Completed = 'COMPLETED',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  New = 'NEW'
}

/** Simplified Media type to avoid using regex on mime type. */
export enum MediaType {
  Audio = 'AUDIO',
  Csv = 'CSV',
  Image = 'IMAGE',
  Other = 'OTHER',
  Pdf = 'PDF',
  Video = 'VIDEO',
  Vtt = 'VTT'
}

export type Mention = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  mentionedCompanyProfileId: Scalars['UUID']['input'];
};

export type MentionConnection = {
  __typename?: 'MentionConnection';
  nodes: Array<CompanyProfile>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptLegal: Profile;
  authByURL: AuthSession;
  authInit: Scalars['String']['output'];
  authInitV2: Scalars['String']['output'];
  authLogout: Scalars['Boolean']['output'];
  authOverride: AuthSession;
  authOverrideLogout: Scalars['Boolean']['output'];
  authRefresh: AuthSession;
  authVerify: AuthSession;
  /** @deprecated It has been replaced by 'companyProfileChangeLanguage' mutation. */
  changeLanguage: Profile;
  companyProfileChangeLanguage: CompanyProfile;
  completeLearningCardV2: LearningCardAssignmentCompletion;
  createOrReturnUser: CreateUserResponse;
  createReaction: Reaction;
  deleteSkillProgress: AssignmentList;
  failCompanyProfileSkill: CompanyProfileSkill;
  googleAuthVerify: SocialAuthSession;
  learningCardCompletionFormCreate: LearningCardCompletionForm;
  learningCardCompletionRetry: LearningCardAssignmentCompletion;
  learningPlanAssignment: LearningPlanAssignmentResponse;
  /** Update a profile. */
  profilePhotoEdit: Profile;
  registerDevice: Device;
  removeReaction: Reaction;
  /** @deprecated This Mutation is using 'content' which is deprecated. Please use 'repSubmissionCreateV2' instead. */
  repSubmissionCreate: RepSubmission;
  repSubmissionCreateV2: RepSubmission;
  repSubmissionFeedbackCreate: RepSubmissionFeedback;
  repSubmissionFinalizeMultipartUpload: Media;
  repSubmissionGetMultipartUploadData: RepSubmissionGetMultipartUploadData;
  repSubmissionGetUploadProvision: RepSubmissionGetUploadProvision;
  repSubmissionSubmitToCoach: RepSubmission;
  resetLearningPlanProgress: AssignmentLp;
  socialRepSubmissionContentEdit: RepSubmission;
  socialRepSubmissionDelete: RepAssignment;
  updateOrCreateFeedback: Feedback;
};


export type MutationAuthByUrlArgs = {
  companyExternalId: Scalars['String']['input'];
  profileExternalId: Scalars['String']['input'];
};


export type MutationAuthInitArgs = {
  profileIdentifier: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationAuthInitV2Args = {
  companyId: Scalars['UUID']['input'];
  profileIdentifier: Scalars['String']['input'];
};


export type MutationAuthLogoutArgs = {
  logoutInput?: InputMaybe<LogoutInput>;
};


export type MutationAuthOverrideArgs = {
  app?: InputMaybe<AuthenticationSource>;
  profileIdentifier: Scalars['String']['input'];
};


export type MutationAuthRefreshArgs = {
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<AuthenticationSource>;
};


export type MutationAuthVerifyArgs = {
  authInitId: Scalars['String']['input'];
  code: Scalars['String']['input'];
};


export type MutationChangeLanguageArgs = {
  language: Language;
};


export type MutationCompanyProfileChangeLanguageArgs = {
  language: Language;
};


export type MutationCompleteLearningCardV2Args = {
  learningCardId: Scalars['UUID']['input'];
  skillId: Scalars['UUID']['input'];
};


export type MutationCreateOrReturnUserArgs = {
  companyExternalId: Scalars['String']['input'];
  fullName?: InputMaybe<Scalars['String']['input']>;
  groupExternalId?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  learningPlanId?: InputMaybe<Scalars['UUID']['input']>;
  memberType?: InputMaybe<Scalars['String']['input']>;
  profileEmailAddress?: InputMaybe<Scalars['String']['input']>;
  profileExternalId: Scalars['String']['input'];
  profilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateReactionArgs = {
  objectId: Scalars['UUID']['input'];
  objectType: ReactionObjectType;
  type: ReactionType;
};


export type MutationDeleteSkillProgressArgs = {
  profileExternalId: Scalars['String']['input'];
  skillExternalId: Scalars['String']['input'];
};


export type MutationFailCompanyProfileSkillArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationGoogleAuthVerifyArgs = {
  source?: InputMaybe<AuthenticationSource>;
  token: Scalars['String']['input'];
};


export type MutationLearningCardCompletionFormCreateArgs = {
  answers: Array<LearningCardCompletionFormAnswerArg>;
  learningCardId: Scalars['UUID']['input'];
  promptId: Scalars['UUID']['input'];
};


export type MutationLearningCardCompletionRetryArgs = {
  learningCardId: Scalars['UUID']['input'];
};


export type MutationLearningPlanAssignmentArgs = {
  companyExternalId: Scalars['String']['input'];
  learningPlanExternalId: Scalars['String']['input'];
  profileEmailAddress?: InputMaybe<Scalars['String']['input']>;
  profileExternalId: Scalars['String']['input'];
  profilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProfilePhotoEditArgs = {
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  socialPhotoUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterDeviceArgs = {
  os: DeviceOs;
  token: Scalars['String']['input'];
};


export type MutationRemoveReactionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRepSubmissionCreateArgs = {
  caption?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  repAssignmentId: Scalars['UUID']['input'];
  responseType: Scalars['String']['input'];
  skillId?: InputMaybe<Array<Scalars['UUID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRepSubmissionCreateV2Args = {
  content?: InputMaybe<Scalars['String']['input']>;
  masterMediaId?: InputMaybe<Scalars['UUID']['input']>;
  repAssignmentId: Scalars['UUID']['input'];
  responseType: Scalars['String']['input'];
};


export type MutationRepSubmissionFeedbackCreateArgs = {
  addSkillId?: InputMaybe<Array<Scalars['UUID']['input']>>;
  caption?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  feedbackType: RepFeedbackType;
  mentions?: InputMaybe<Array<Mention>>;
  removeSkillId?: InputMaybe<Array<Scalars['UUID']['input']>>;
  repSubmissionId: Scalars['UUID']['input'];
  responseType: RepResponseKind;
  reviewerRole: Scalars['String']['input'];
  rubricForm?: InputMaybe<RubricFormV1>;
  tempContentWithoutTags?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRepSubmissionFinalizeMultipartUploadArgs = {
  fileId: Scalars['String']['input'];
  fileKey: Scalars['String']['input'];
  mediaId: Scalars['UUID']['input'];
  parts: Array<FinalizeMultipartUploadPart>;
};


export type MutationRepSubmissionGetMultipartUploadDataArgs = {
  fileSize: Scalars['Int']['input'];
  mediaType: MediaType;
  mimeType: Scalars['String']['input'];
  numberOfParts: Scalars['Int']['input'];
};


export type MutationRepSubmissionGetUploadProvisionArgs = {
  mediaId?: InputMaybe<Scalars['String']['input']>;
  mediaType: MediaType;
  mimeType: Scalars['String']['input'];
};


export type MutationRepSubmissionSubmitToCoachArgs = {
  repSubmissionId: Scalars['UUID']['input'];
};


export type MutationResetLearningPlanProgressArgs = {
  resetLearningPlanProgressInput: ResetLearningPlanProgressInput;
};


export type MutationSocialRepSubmissionContentEditArgs = {
  content: Scalars['String']['input'];
  repSubmissionId: Scalars['UUID']['input'];
};


export type MutationSocialRepSubmissionDeleteArgs = {
  repSubmissionId: Scalars['UUID']['input'];
};


export type MutationUpdateOrCreateFeedbackArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  objectId: Scalars['UUID']['input'];
  objectType: FeedbackObjectType;
  rating?: InputMaybe<Scalars['Int']['input']>;
  ratingType: FeedbackRatingType;
  response?: InputMaybe<Scalars['String']['input']>;
};

/** Scores related to need articulation */
export type NeedsIdentificationScore = {
  __typename?: 'NeedsIdentificationScore';
  identificationScore: Scalars['Float']['output'];
  needCaptured: Scalars['Boolean']['output'];
  needExpressed: Scalars['Boolean']['output'];
  problemClarity: Scalars['Float']['output'];
};

/** NonVerbalSkillScore for different aspects of the conversation content */
export type NonVerbalSkillScore = {
  __typename?: 'NonVerbalSkillScore';
  confidence: Scalars['Float']['output'];
  listening: Scalars['Float']['output'];
  patience: Scalars['Float']['output'];
  pauseDuration: Scalars['Float']['output'];
};

/** Details of an open-ended question in the conversation */
export type OpenEndedQuestion = {
  __typename?: 'OpenEndedQuestion';
  question: Scalars['String']['output'];
  speaker: Scalars['String']['output'];
  startTime: Scalars['Float']['output'];
};

export type PaginatedAssignmentLp = {
  __typename?: 'PaginatedAssignmentLP';
  /** List of objects in current page. */
  nodes: Array<AssignmentLp>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: AssignmentLpPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A paginated list of Company Profiles. */
export type PaginatedCompanyProfileSearchFilteredByGroupResponse = {
  __typename?: 'PaginatedCompanyProfileSearchFilteredByGroupResponse';
  /** List of objects in current page. */
  nodes: Array<CompanyProfile>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: CompanyProfileSearchFilteredByGroupPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedRepAssignmentResponse = {
  __typename?: 'PaginatedRepAssignmentResponse';
  /** List of objects in current page. */
  nodes: Array<RepAssignment>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: RepAssignmentPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedRepPromptSearchFilteredByCoachRepAssignmentsResponse = {
  __typename?: 'PaginatedRepPromptSearchFilteredByCoachRepAssignmentsResponse';
  /** List of objects in current page. */
  nodes: Array<RepPromptSearch>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: RepPromptSearchPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedRepPromptSearchWithoutFilterResponse = {
  __typename?: 'PaginatedRepPromptSearchWithoutFilterResponse';
  /** List of objects in current page. */
  nodes: Array<RepPromptSearch>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: RepPromptSearchWithoutFilterPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedRepSubmissionResponse = {
  __typename?: 'PaginatedRepSubmissionResponse';
  /** List of objects in current page. */
  nodes: Array<RepSubmission>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: FunctionPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedSocialRepAssignmentByPromptResponse = {
  __typename?: 'PaginatedSocialRepAssignmentByPromptResponse';
  /** List of objects in current page. */
  nodes: Array<SocialRepPrompt>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: SocialRepPromptPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedSocialRepAssignmentResponse = {
  __typename?: 'PaginatedSocialRepAssignmentResponse';
  /** List of objects in current page. */
  nodes: Array<RepAssignment>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: SocialRepAssignmentPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedTopic = {
  __typename?: 'PaginatedTopic';
  /** List of objects in current page. */
  nodes: Array<Topic>;
  /** Contains details to move forward and backwards from the collection. */
  pageInfo: TopicPageInfo;
  /** Total number of objects in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProScoreOverTimeResponse = {
  __typename?: 'ProScoreOverTimeResponse';
  date: Scalars['DateTime']['output'];
  proScore?: Maybe<Scalars['Float']['output']>;
  xlabel: Scalars['String']['output'];
};

export type ProScoreV2 = {
  __typename?: 'ProScoreV2';
  id: Scalars['ID']['output'];
  proScore: Scalars['Float']['output'];
  repsCompletedCount: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  skillsAssignedCount: Scalars['Int']['output'];
  skillsCompletedCount: Scalars['Int']['output'];
};

export type ProScoreV3 = {
  __typename?: 'ProScoreV3';
  id: Scalars['ID']['output'];
  proScore: Scalars['Float']['output'];
  repsAssignedCount: Scalars['Int']['output'];
  repsCompletedCount: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  skillsAssignedCount: Scalars['Int']['output'];
  skillsCompletedCount: Scalars['Int']['output'];
};

export type Profile = {
  __typename?: 'Profile';
  acceptedLegal: Scalars['Boolean']['output'];
  companyProfile: CompanyProfile;
  companyProfiles: CompanyProfileConnection;
  createdAt: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  /** @deprecated It has been replaced by 'CompanyProfile.emailAddress'. */
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `flags` instead. */
  enabledFeatures: Array<FeatureType>;
  /** @deprecated It has been replaced by 'CompanyProfile.externalId'. */
  externalId: Scalars['String']['output'];
  flags: Array<Flag>;
  /** @deprecated It has been replaced by CompanyProfile.hasCoachedReps in meV2 */
  hasCoachedReps: Scalars['Boolean']['output'];
  hasRole: Scalars['Boolean']['output'];
  /** @deprecated It has been replaced by CompanyProfile.hasSocialReps in meV2 */
  hasSocialReps: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isSuperuser: Scalars['Boolean']['output'];
  /** @deprecated It has been replaced by 'CompanyProfile.language'. */
  language?: Maybe<Language>;
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['UUID']['output']>;
  /** @deprecated It has been replaced by 'CompanyProfile.phoneNumber'. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  /** @deprecated It has been replaced by 'CompanyProfile.score'. */
  score: Scalars['Int']['output'];
  /**
   * Get media full url. Media can be requested with specific transformations, which are Cloudinary-compatible.
   * @deprecated Deprecated in favor of Profile.media
   */
  transformedMediaUrl?: Maybe<Scalars['String']['output']>;
  workspaces: WorkspaceConnection;
};


export type ProfileFlagsArgs = {
  appName?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  browserName?: InputMaybe<Scalars['String']['input']>;
  browserVersion?: InputMaybe<Scalars['String']['input']>;
  osName?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  platformModel?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  platformVendor?: InputMaybe<Scalars['String']['input']>;
};


export type ProfileHasRoleArgs = {
  roleName: Scalars['String']['input'];
};


export type ProfileTransformedMediaUrlArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  transformations?: InputMaybe<Scalars['JSON']['input']>;
};

export type ProfileTag = {
  __typename?: 'ProfileTag';
  id: Scalars['ID']['output'];
  metadata: Scalars['JSONObject']['output'];
  name: Scalars['String']['output'];
};

export type ProfileTagConnection = {
  __typename?: 'ProfileTagConnection';
  nodes: Array<ProfileTag>;
};

export type Prompt = {
  __typename?: 'Prompt';
  choices: ChoiceConnection;
  choicesCountConfig: ChoicesCountConfig;
  formId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  isMultiple: Scalars['Boolean']['output'];
  isRubric: Scalars['Boolean']['output'];
  maxChoicesCountRequired: Scalars['Int']['output'];
  minChoicesCountRequired: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  promptLocalized?: Maybe<PromptLocalized>;
};

export type PromptConnection = {
  __typename?: 'PromptConnection';
  nodes: Array<Prompt>;
};

export type PromptLocalized = {
  __typename?: 'PromptLocalized';
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  language: Language;
};

export type PromptTransactional = {
  __typename?: 'PromptTransactional';
  choices?: Maybe<ChoiceTransactionalConnection>;
  choicesCountConfig: ChoicesCountConfig;
  formId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  isFailed?: Maybe<Scalars['Boolean']['output']>;
  isMultiple: Scalars['Boolean']['output'];
  learningCardAssignmentCompletionId?: Maybe<Scalars['UUID']['output']>;
  maxChoicesCountRequired: Scalars['Int']['output'];
  minChoicesCountRequired: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  promptLocalized?: Maybe<PromptLocalized>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PromptTransactionalConnection = {
  __typename?: 'PromptTransactionalConnection';
  nodes: Array<PromptTransactional>;
};

export type Query = {
  __typename?: 'Query';
  assignment: AssignmentLp;
  assignmentSkillGetNext?: Maybe<AssignmentSkillCardGetNext>;
  assignments: AssignmentList;
  assignmentsPaginated: PaginatedAssignmentLp;
  authChannel: AuthChannelResponse;
  coachRepAssignment?: Maybe<RepAssignment>;
  coachRepAssignments: PaginatedRepAssignmentResponse;
  companyProfileSkill: CompanyProfileSkill;
  companyProfileSkillGetNext?: Maybe<CompanyProfileSkillGetNext>;
  errorV1: Scalars['String']['output'];
  /** Finds a company by encrypted company id */
  findByEncExternalId: CompanyFindByEncExtIdResponse;
  formTransactionalGet?: Maybe<FormTransactional>;
  /** Returns a list of certificates for the given user */
  getCertificates: Array<CertificatesCompanyProfile>;
  getProScoreStats?: Maybe<Array<ProScoreOverTimeResponse>>;
  getTranscriptionMediaObjectById: GetTranscriptionMediaObjectById;
  home: Home;
  /** Return a new auth feature for email. */
  isNewAuth: Scalars['Boolean']['output'];
  leaderboard: Leaderboard;
  leaderboardV2: LeaderboardV2;
  leaderboardV3: LeaderboardV3;
  learningCardAssignmentCompletionGet?: Maybe<LearningCardAssignmentCompletion>;
  /** @deprecated This will be removed in favor of meV2 */
  me: Profile;
  meV2: CompanyProfile;
  proScoreGetV2?: Maybe<ProScoreV2>;
  proScoreGetV3?: Maybe<ProScoreV3>;
  /** Returns a list of profiles already filtered by the groups the current logged user belongs to and any other given condition. */
  profileSearchFilteredByGroup: PaginatedCompanyProfileSearchFilteredByGroupResponse;
  repAssignment?: Maybe<RepAssignment>;
  repAssignments: PaginatedRepAssignmentResponse;
  /** Returns a list of paginated RepPrompt entities already filtered by Coach Rep assignments and any given extra condition. */
  repPromptSearchFilteredByCoachRepAssignments: PaginatedRepPromptSearchFilteredByCoachRepAssignmentsResponse;
  /** Returns a list of paginated RepPrompt entities with any given extra condition. */
  repPromptSearchSocial: PaginatedRepPromptSearchWithoutFilterResponse;
  skill: Skill;
  socialRepAssignment?: Maybe<RepAssignment>;
  socialRepAssignments: PaginatedSocialRepAssignmentResponse;
  socialReps: PaginatedSocialRepAssignmentResponse;
  socialRepsByPrompt: PaginatedSocialRepAssignmentByPromptResponse;
  toDoRepAssignmentCount: Scalars['Float']['output'];
  todaysPractice: AssignmentSkillCardTodaysPracticeList;
  topicsPaginated: PaginatedTopic;
};


export type QueryAssignmentArgs = {
  assignmentInput: AssignmentInput;
};


export type QueryAssignmentsPaginatedArgs = {
  conditions?: InputMaybe<AssignmentLpConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
};


export type QueryAuthChannelArgs = {
  profileIdentifier: Scalars['String']['input'];
};


export type QueryCoachRepAssignmentArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCoachRepAssignmentsArgs = {
  conditions?: InputMaybe<RepAssignmentConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<RepAssignmentSort>>;
};


export type QueryCompanyProfileSkillArgs = {
  skillExternalId: Scalars['String']['input'];
};


export type QueryCompanyProfileSkillGetNextArgs = {
  skillExternalId: Scalars['String']['input'];
};


export type QueryFindByEncExternalIdArgs = {
  encExternalId: Scalars['String']['input'];
};


export type QueryFormTransactionalGetArgs = {
  learningCardId: Scalars['UUID']['input'];
};


export type QueryGetTranscriptionMediaObjectByIdArgs = {
  mediaId: Scalars['String']['input'];
};


export type QueryIsNewAuthArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLearningCardAssignmentCompletionGetArgs = {
  learningCardId: Scalars['UUID']['input'];
};


export type QueryProfileSearchFilteredByGroupArgs = {
  conditions?: InputMaybe<CompanyProfileSearchFilteredByGroupConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
};


export type QueryRepAssignmentArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryRepAssignmentsArgs = {
  conditions?: InputMaybe<RepAssignmentConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<RepAssignmentSort>>;
};


export type QueryRepPromptSearchFilteredByCoachRepAssignmentsArgs = {
  conditions?: InputMaybe<RepPromptSearchFilteredByCoachRepAssignmentsConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
};


export type QueryRepPromptSearchSocialArgs = {
  conditions?: InputMaybe<RepPromptSearchWithoutFilterCondition>;
  paginate?: InputMaybe<BaseClassicPaginate>;
};


export type QuerySkillArgs = {
  skillExternalId: Scalars['String']['input'];
};


export type QuerySocialRepAssignmentArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySocialRepAssignmentsArgs = {
  conditions?: InputMaybe<RepAssignmentListConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<RepAssignmentSort>>;
};


export type QuerySocialRepsArgs = {
  conditions?: InputMaybe<SocialRepAssignmentConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<RepAssignmentSort>>;
};


export type QuerySocialRepsByPromptArgs = {
  conditions?: InputMaybe<SocialRepAssignmentByPromptConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<RepAssignmentSort>>;
};


export type QueryTopicsPaginatedArgs = {
  conditions?: InputMaybe<TopicConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
};

export type Reaction = {
  __typename?: 'Reaction';
  companyProfileId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  type: ReactionType;
};

/** Reaction Object type. */
export enum ReactionObjectType {
  RepSubmission = 'REP_SUBMISSION',
  RepSubmissionFeedback = 'REP_SUBMISSION_FEEDBACK'
}

/** Reaction type. */
export enum ReactionType {
  Claps = 'CLAPS',
  Heart = 'HEART',
  Like = 'LIKE',
  Tada = 'TADA'
}

export type ReactionsConnection = {
  __typename?: 'ReactionsConnection';
  nodes: Array<Reaction>;
};

export type RepAssignment = {
  __typename?: 'RepAssignment';
  assignorCompanyProfile?: Maybe<CompanyProfile>;
  assignorCompanyProfileId?: Maybe<Scalars['UUID']['output']>;
  companyProfileId: Scalars['UUID']['output'];
  companyProfileSkill: CompanyProfileSkill;
  companyProfileSkillId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  learnerCompanyProfile: CompanyProfile;
  points: Scalars['Int']['output'];
  repAssignmentStatus: RepAssignmentStatus;
  repPrompt?: Maybe<RepPrompt>;
  repPromptId?: Maybe<Scalars['UUID']['output']>;
  repSubmissionCount: Scalars['Int']['output'];
  repSubmissions: RepSubmissionConnection;
  repSubmissionsPaginated: PaginatedRepSubmissionResponse;
  skill: Skill;
};


export type RepAssignmentRepSubmissionsPaginatedArgs = {
  paginate?: InputMaybe<BaseClassicPaginate>;
};

export type RepAssignmentConditions = {
  /** Filter Rep assignments by company profile ID */
  companyProfileId?: InputMaybe<StringCondition>;
  /** Filter Rep assignments by Rep prompt ID */
  promptId?: InputMaybe<StringCondition>;
  repAssignmentStatus?: InputMaybe<RepAssignmentStatusCondition>;
};

export type RepAssignmentListConditions = {
  /** Filter Rep assignments by company profile ID */
  companyProfileId?: InputMaybe<StringCondition>;
  /** Filter Rep assignments by Rep prompt ID */
  promptId?: InputMaybe<StringCondition>;
};

export type RepAssignmentPageInfo = {
  __typename?: 'RepAssignmentPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

/** RepAssignmentSort options */
export enum RepAssignmentSort {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  LastActivityAtAsc = 'LAST_ACTIVITY_AT_ASC',
  LastActivityAtDesc = 'LAST_ACTIVITY_AT_DESC',
  LearnerNameAsc = 'LEARNER_NAME_ASC',
  LearnerNameDesc = 'LEARNER_NAME_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** RepAssignmentStatus options */
export enum RepAssignmentStatus {
  Approved = 'APPROVED',
  Done = 'DONE',
  Locked = 'LOCKED',
  New = 'NEW',
  Practiced = 'PRACTICED',
  Reviewed = 'REVIEWED',
  Submitted = 'SUBMITTED'
}

export type RepAssignmentStatusCondition = {
  equals?: InputMaybe<RepAssignmentStatus>;
  iLike?: InputMaybe<RepAssignmentStatus>;
  in?: InputMaybe<Array<RepAssignmentStatus>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<RepAssignmentStatus>;
  notEqualsTo?: InputMaybe<RepAssignmentStatus>;
  notIn?: InputMaybe<Array<RepAssignmentStatus>>;
};

/** RepFeedbackType options */
export enum RepFeedbackType {
  Approval = 'APPROVAL',
  Comment = 'COMMENT',
  Feedback = 'FEEDBACK'
}

export type RepPrompt = {
  __typename?: 'RepPrompt';
  allResponseTypeEnabled: Scalars['Boolean']['output'];
  autoEvaluationCriteria?: Maybe<AutoEvaluationCriteria>;
  companyId?: Maybe<Scalars['UUID']['output']>;
  conversationRoles?: Maybe<ConversationRoles>;
  conversationType?: Maybe<ConversationType>;
  formConfig?: Maybe<Form>;
  id: Scalars['UUID']['output'];
  interjectionsHandling?: Maybe<InterjectionsHandling>;
  isCoached: Scalars['Boolean']['output'];
  isRepeatable: Scalars['Boolean']['output'];
  keywordAnalysisEnabled: Scalars['Boolean']['output'];
  repPromptLocalized: RepPromptLocalized;
  repPromptResponseTypes: RepPromptResponseTypeConnection;
  repType: RepType;
  selfPracticeEnabled: Scalars['Boolean']['output'];
  skill: Skill;
};

export type RepPromptLocalized = {
  __typename?: 'RepPromptLocalized';
  autoEvaluationCriteria?: Maybe<AutoEvaluationCriteria>;
  caption?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  language: Language;
  promptType: RepResponseKind;
  repPromptId: Scalars['UUID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type RepPromptResponseType = {
  __typename?: 'RepPromptResponseType';
  id: Scalars['UUID']['output'];
  repPromptId: Scalars['UUID']['output'];
  responseType?: Maybe<RepResponseKind>;
};

export type RepPromptResponseTypeConnection = {
  __typename?: 'RepPromptResponseTypeConnection';
  nodes: Array<RepPromptResponseType>;
};

export type RepPromptSearch = {
  __typename?: 'RepPromptSearch';
  id: Scalars['String']['output'];
  skillLocalizedName?: Maybe<Scalars['String']['output']>;
  skillName: Scalars['String']['output'];
};

export type RepPromptSearchFilteredByCoachRepAssignmentsConditions = {
  /** Filter by the given Rep Prompt ID. */
  id?: InputMaybe<UuidCondition>;
  /** Search terms. Will look for Skill localized name. */
  searchTerms?: InputMaybe<StringCondition>;
};

export type RepPromptSearchPageInfo = {
  __typename?: 'RepPromptSearchPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

export type RepPromptSearchWithoutFilterCondition = {
  /** Filter by the given Rep Prompt ID. */
  id?: InputMaybe<UuidCondition>;
  /** Search terms. Will look for Skill localized name. */
  searchTerms?: InputMaybe<StringCondition>;
};

export type RepPromptSearchWithoutFilterPageInfo = {
  __typename?: 'RepPromptSearchWithoutFilterPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

/** RepResponseKind options */
export enum RepResponseKind {
  Audio = 'AUDIO',
  Conversation = 'CONVERSATION',
  Image = 'IMAGE',
  Pdf = 'PDF',
  Text = 'TEXT',
  Video = 'VIDEO'
}

export type RepSubmission = {
  __typename?: 'RepSubmission';
  aiReviewStatus?: Maybe<ReviewStatus>;
  autoEvaluationAt?: Maybe<Scalars['DateTime']['output']>;
  autoEvaluationOutcome?: Maybe<AutoEvaluationOutcome>;
  caption?: Maybe<Scalars['String']['output']>;
  coachReviewStatus?: Maybe<ReviewStatus>;
  /** It returns only text submissions. */
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<ErrorMsg>;
  id: Scalars['UUID']['output'];
  /** It returns only image/file submissions */
  media?: Maybe<Media>;
  posterMedia?: Maybe<Media>;
  reactions: ReactionsConnection;
  repAssignmentId?: Maybe<Scalars['UUID']['output']>;
  repSubmissionFeedbacks: RepSubmissionFeedbackConnection;
  responseType: RepResponseKind;
  /** It returns only video submissions */
  streamMedia?: Maybe<Media>;
  title?: Maybe<Scalars['String']['output']>;
  transcriptionMedia?: Maybe<Media>;
  /** Get media full url. Media can be requested with specific transformations, which are Cloudinary-compatible. */
  transformedMediaUrl?: Maybe<Scalars['String']['output']>;
};


export type RepSubmissionRepSubmissionFeedbacksArgs = {
  forceMentions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RepSubmissionTransformedMediaUrlArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  transformations?: InputMaybe<Scalars['JSON']['input']>;
};

export type RepSubmissionConnection = {
  __typename?: 'RepSubmissionConnection';
  nodes: Array<RepSubmission>;
};

export type RepSubmissionFeedback = {
  __typename?: 'RepSubmissionFeedback';
  autoEvaluationOutcome?: Maybe<AutoEvaluationOutcome>;
  caption?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  feedbackType: RepFeedbackType;
  formTransactional?: Maybe<FormTransactional>;
  id: Scalars['UUID']['output'];
  mentions?: Maybe<MentionConnection>;
  repSubmissionId?: Maybe<Scalars['UUID']['output']>;
  responseType: RepResponseKind;
  reviewerCompanyProfile?: Maybe<CompanyProfile>;
  reviewerCompanyProfileId?: Maybe<Scalars['UUID']['output']>;
  reviewerRole: ReviewerRoleType;
  /** Get media full url. Media can be requested with specific transformations, which are Cloudinary-compatible. */
  transformedMediaUrl?: Maybe<Scalars['String']['output']>;
};


export type RepSubmissionFeedbackTransformedMediaUrlArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  transformations?: InputMaybe<Scalars['JSON']['input']>;
};

export type RepSubmissionFeedbackConnection = {
  __typename?: 'RepSubmissionFeedbackConnection';
  nodes: Array<RepSubmissionFeedback>;
};

export type RepSubmissionGetMultipartUploadData = {
  __typename?: 'RepSubmissionGetMultipartUploadData';
  /** Cursor to upload file chunks to S3. */
  fileId: Scalars['String']['output'];
  /** File name of the file to upload to S3. */
  fileKey: Scalars['String']['output'];
  /** Media Id of the file to mark as completed. */
  mediaId: Scalars['UUID']['output'];
  parts: Array<GetMultipartUploadDataPart>;
};

/** An object that represents temporary credentials and upload details for Amazon S3 */
export type RepSubmissionGetUploadProvision = {
  __typename?: 'RepSubmissionGetUploadProvision';
  /** Temporary credentials for AWS S3 */
  credentials: AwsCredentials;
  media: Media;
  s3: Awss3Params;
};

/** RepType options */
export enum RepType {
  Coached = 'COACHED',
  Selfcoached = 'SELFCOACHED',
  Social = 'SOCIAL'
}

export type ResetLearningPlanProgressInput = {
  /** The learning plan ID to be reset. */
  id: Scalars['UUID']['input'];
  /** The learning card ID that triggered the learning plan reset. */
  learningCardId: Scalars['UUID']['input'];
};

export type Results = {
  __typename?: 'Results';
  speakerLabels?: Maybe<Array<SpeakerLabel>>;
  timeline?: Maybe<Array<Timeline>>;
  transcripts?: Maybe<Array<Transcript>>;
};

/** ReviewStatus options */
export enum ReviewStatus {
  Complete = 'COMPLETE',
  Error = 'ERROR',
  Pending = 'PENDING'
}

/** ReviewerRoleType options */
export enum ReviewerRoleType {
  AiCoach = 'AI_COACH',
  Coach = 'COACH',
  Peer = 'PEER',
  Self = 'SELF'
}

export type RubricAnswerV1 = {
  answer?: InputMaybe<Scalars['String']['input']>;
  choiceId?: InputMaybe<Scalars['UUID']['input']>;
};

export type RubricFormV1 = {
  formId: Scalars['UUID']['input'];
  prompts: Array<RubricPromptV1>;
};

export type RubricPromptV1 = {
  answers: Array<RubricAnswerV1>;
  promptId: Scalars['UUID']['input'];
};

export type Skill = {
  __typename?: 'Skill';
  active: Scalars['Boolean']['output'];
  /** @deprecated Replace this function with "transformedMediaUrl". */
  cloudinaryPhotoUrl?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  flow: SkillFlow;
  freestylePoints?: Maybe<Scalars['Float']['output']>;
  id: Scalars['UUID']['output'];
  learningCards: LearningCardConnection;
  lpSectionSkill: LpSectionSkill;
  media?: Maybe<Media>;
  mediaId?: Maybe<Scalars['UUID']['output']>;
  name: Scalars['String']['output'];
  photoUrl: Scalars['String']['output'];
  repPoints?: Maybe<Scalars['Int']['output']>;
  repType?: Maybe<RepType>;
  skillLocalized?: Maybe<SkillLocalized>;
  /** @deprecated SkillSkillSectionConnection is only here to use LearningCards. Consume LearningCards directly. */
  skillSkillSection: SkillSkillSectionConnection;
  /**
   * Get media full url. Media can be requested with specific transformations, which are Cloudinary-compatible.
   * @deprecated Deprecated in favor of Skill.media
   */
  transformedMediaUrl?: Maybe<Scalars['String']['output']>;
  type: SkillType;
  updatedAt: Scalars['DateTime']['output'];
};


export type SkillCloudinaryPhotoUrlArgs = {
  transformations?: InputMaybe<Scalars['JSON']['input']>;
};


export type SkillLpSectionSkillArgs = {
  lpCompanySectionExternalId: Scalars['String']['input'];
};


export type SkillTransformedMediaUrlArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  transformations?: InputMaybe<Scalars['JSON']['input']>;
};

/** Skill flow configuration. */
export enum SkillFlow {
  Rep = 'REP',
  Stack = 'STACK',
  Wup = 'WUP'
}

export type SkillLocalized = {
  __typename?: 'SkillLocalized';
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  language: Language;
};

export type SkillSection = {
  __typename?: 'SkillSection';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  skillSectionLocalized: SkillSectionLocalized;
};

export type SkillSectionLocalized = {
  __typename?: 'SkillSectionLocalized';
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  language: Language;
};

export type SkillSkillSection = {
  __typename?: 'SkillSkillSection';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  learningCards: LearningCardConnection;
  position: Scalars['Int']['output'];
  skillId: Scalars['UUID']['output'];
  skillSection: SkillSection;
  skillSectionId: Scalars['UUID']['output'];
};

export type SkillSkillSectionConnection = {
  __typename?: 'SkillSkillSectionConnection';
  nodes: Array<SkillSkillSection>;
};

/** Available types for a Skill. */
export enum SkillType {
  Content = 'CONTENT',
  Rep = 'REP'
}

/** A pair of JWT short-lived access token and a long-lived refresh tokens along with social profile picture update status. Access token can be passed in subsequent requests via http header "Authentication: Bearer ACCESS_TOKEN". */
export type SocialAuthSession = {
  __typename?: 'SocialAuthSession';
  /** Bearer JWT token used to access the app via Authentication header. */
  accessToken: Scalars['String']['output'];
  /** Company External ID. */
  companyExternalId: Scalars['String']['output'];
  /** Company Profile ID. */
  companyProfileId: Scalars['String']['output'];
  /** JWT token used to request a new pair of access and refresh tokens. */
  refreshToken: Scalars['String']['output'];
  /** Social photo update error message if any */
  socialPhotoUpdateErrorMessage?: Maybe<Scalars['String']['output']>;
  /** Social photo update status. Valid values are "success", "skipped", "error" */
  socialPhotoUpdateStatus?: Maybe<Scalars['String']['output']>;
};

export type SocialGroupLeaderBoard = {
  __typename?: 'SocialGroupLeaderBoard';
  groupScores: Array<GroupLeaderBoardItem>;
  iconURL: Scalars['String']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
};

export type SocialRepAssignmentByPromptConditions = {
  /** Filter Rep assignments by company profile ID */
  companyProfileId?: InputMaybe<StringCondition>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** Filter Rep assignments by Rep prompt ID */
  promptId?: InputMaybe<StringCondition>;
};

export type SocialRepAssignmentByPromptListArgs = {
  conditions?: InputMaybe<SocialRepAssignmentByPromptConditions>;
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<RepAssignmentSort>>;
};

export type SocialRepAssignmentConditions = {
  companyProfileId?: InputMaybe<StringCondition>;
};

export type SocialRepAssignmentPageInfo = {
  __typename?: 'SocialRepAssignmentPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

export type SocialRepPrompt = {
  __typename?: 'SocialRepPrompt';
  allResponseTypeEnabled: Scalars['Boolean']['output'];
  autoEvaluationCriteria?: Maybe<AutoEvaluationCriteria>;
  companyId?: Maybe<Scalars['UUID']['output']>;
  conversationRoles?: Maybe<ConversationRoles>;
  conversationType?: Maybe<ConversationType>;
  formConfig?: Maybe<Form>;
  id: Scalars['UUID']['output'];
  interjectionsHandling?: Maybe<InterjectionsHandling>;
  isCoached: Scalars['Boolean']['output'];
  isRepeatable: Scalars['Boolean']['output'];
  keywordAnalysisEnabled: Scalars['Boolean']['output'];
  paginatedAssignments: PaginatedSocialRepAssignmentResponse;
  repAssignmentId?: Maybe<Scalars['String']['output']>;
  repPromptLocalized: RepPromptLocalized;
  repPromptResponseTypes: RepPromptResponseTypeConnection;
  repType: RepType;
  selfPracticeEnabled: Scalars['Boolean']['output'];
  skill: Skill;
};


export type SocialRepPromptPaginatedAssignmentsArgs = {
  paginates: Array<SocialRepAssignmentByPromptListArgs>;
};

export type SocialRepPromptPageInfo = {
  __typename?: 'SocialRepPromptPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

export type SocialReps = {
  __typename?: 'SocialReps';
  nodes: Array<RepAssignment>;
  totalCount: Scalars['Int']['output'];
};

export type SpeakerLabel = {
  __typename?: 'SpeakerLabel';
  isPresenter?: Maybe<Scalars['Boolean']['output']>;
  speakerId?: Maybe<Scalars['String']['output']>;
  speakerLabel?: Maybe<Scalars['String']['output']>;
  speakerName?: Maybe<Scalars['String']['output']>;
  speakerRole?: Maybe<Scalars['String']['output']>;
  speakerRoleDisplayed?: Maybe<Scalars['String']['output']>;
  talkRatio?: Maybe<Scalars['Float']['output']>;
};

/** Metadata for SSO type authentication channel */
export type SsoChannel = {
  __typename?: 'SsoChannel';
  /** The IDP X509 certificate path */
  certPath?: Maybe<Scalars['String']['output']>;
  /** The base URL for the endpoint where request has to be forwarded for external authentication. Usually the backend URL */
  idpProxyBaseUrl?: Maybe<Scalars['String']['output']>;
  /** The path fragment for the endpoint where request has to be forwarded for external authentication */
  idpProxyPath?: Maybe<Scalars['String']['output']>;
};

/** Details of stacked questions in the conversation */
export type StackedQuestion = {
  __typename?: 'StackedQuestion';
  questions: Array<Scalars['String']['output']>;
  speaker: Scalars['String']['output'];
  startTime: Scalars['Float']['output'];
};

export type StringCondition = {
  equals?: InputMaybe<Scalars['String']['input']>;
  iLike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  notEqualsTo?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Timeline = {
  __typename?: 'Timeline';
  end_time?: Maybe<Scalars['String']['output']>;
  sentence?: Maybe<Scalars['String']['output']>;
  speaker?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
};

export type Topic = {
  __typename?: 'Topic';
  assignmentSkillCards: AssignmentSkillCardConnection;
  companyId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  media?: Maybe<Media>;
  name: Scalars['String']['output'];
  repCount: Scalars['Int']['output'];
  skillCount: Scalars['Int']['output'];
  topicLocalized?: Maybe<TopicLocalized>;
  /**
   * Get media full url. Media can be requested with specific transformations, which are Cloudinary-compatible.
   * @deprecated Deprecated in favor of Topic.media
   */
  transformedMediaUrl?: Maybe<Scalars['String']['output']>;
};


export type TopicTransformedMediaUrlArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  transformations?: InputMaybe<Scalars['JSON']['input']>;
};

export type TopicConditions = {
  topicId?: InputMaybe<StringCondition>;
};

export type TopicLocalized = {
  __typename?: 'TopicLocalized';
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  language: Language;
};

export type TopicPageInfo = {
  __typename?: 'TopicPageInfo';
  /** Pointer to the next page. When null, it means you are in the last page. */
  afterCursor?: Maybe<Scalars['String']['output']>;
  /** Pointer to the previous page. When null, it means you are in the first page. */
  beforeCursor?: Maybe<Scalars['String']['output']>;
};

export type Topics = {
  __typename?: 'Topics';
  nodes: Array<Topic>;
  totalCount: Scalars['Int']['output'];
};

export type Transcript = {
  __typename?: 'Transcript';
  language?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Scalars['String']['output']>;
};

export type UuidCondition = {
  equals?: InputMaybe<Scalars['UUID']['input']>;
  iLike?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['UUID']['input']>;
  notEqualsTo?: InputMaybe<Scalars['UUID']['input']>;
  notIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type Workspace = {
  __typename?: 'Workspace';
  companyExternalId: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  companyInternalName: Scalars['String']['output'];
  companyLogo?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type WorkspaceConnection = {
  __typename?: 'WorkspaceConnection';
  nodes: Array<Workspace>;
};

export type AcceptLegalMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptLegalMutation = { __typename?: 'Mutation', acceptLegal: { __typename?: 'Profile', id: string, acceptedLegal: boolean } };

export type AssignmentQueryVariables = Exact<{
  assignmentInput: AssignmentInput;
}>;


export type AssignmentQuery = { __typename?: 'Query', assignment: { __typename?: 'AssignmentLP', id: string, learningPlan: { __typename?: 'LearningPlan', learningPlanLocalized: { __typename?: 'LearningPlanLocalized', description?: string | null } }, assignmentSkillCards: { __typename?: 'AssignmentSkillCardConnection', nodes: Array<{ __typename?: 'AssignmentSkillCard', id: any, repAssignmentId?: any | null, repAssignmentStatus?: RepAssignmentStatus | null, isLocked: boolean, completedAt?: any | null, lpCompanySectionExternalId?: string | null, progress?: number | null, points: number, pointsEarned: number, failedAt?: any | null, skill: { __typename?: 'Skill', id: any, type: SkillType, repType?: RepType | null, externalId: string, skillLocalized?: { __typename?: 'SkillLocalized', id: any, description: string } | null } }> } } };

export type AuthByUrlMutationVariables = Exact<{
  profileExternalId: Scalars['String']['input'];
  companyExternalId: Scalars['String']['input'];
}>;


export type AuthByUrlMutation = { __typename?: 'Mutation', authByURL: { __typename?: 'AuthSession', accessToken: string, refreshToken: string, companyProfileId: string, companyExternalId: string } };

export type AuthChannelQueryVariables = Exact<{
  profileIdentifier: Scalars['String']['input'];
}>;


export type AuthChannelQuery = { __typename?: 'Query', authChannel: { __typename?: 'AuthChannelResponse', companyId?: string | null, companyExtId?: string | null, companyProfileId?: string | null, channelType?: AuthenticationChannelType | null, ssoChannel?: { __typename?: 'SsoChannel', idpProxyBaseUrl?: string | null, idpProxyPath?: string | null, certPath?: string | null } | null, localChannel?: { __typename?: 'LocalChannel', supportedTypes?: Array<string> | null } | null } };

export type AuthInitMutationVariables = Exact<{
  profileIdentifier: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type AuthInitMutation = { __typename?: 'Mutation', authInit: string };

export type AuthInitV2MutationVariables = Exact<{
  profileIdentifier: Scalars['String']['input'];
  companyId: Scalars['UUID']['input'];
}>;


export type AuthInitV2Mutation = { __typename?: 'Mutation', authInitV2: string };

export type AuthLogoutMutationVariables = Exact<{
  logoutInput?: InputMaybe<LogoutInput>;
}>;


export type AuthLogoutMutation = { __typename?: 'Mutation', authLogout: boolean };

export type AuthOverrideMutationVariables = Exact<{
  profileIdentifier: Scalars['String']['input'];
  source?: InputMaybe<AuthenticationSource>;
}>;


export type AuthOverrideMutation = { __typename?: 'Mutation', authOverride: { __typename?: 'AuthSession', accessToken: string, refreshToken: string, companyProfileId: string, companyExternalId: string } };

export type AuthOverrideLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type AuthOverrideLogoutMutation = { __typename?: 'Mutation', authOverrideLogout: boolean };

export type AuthRefreshMutationVariables = Exact<{
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<AuthenticationSource>;
}>;


export type AuthRefreshMutation = { __typename?: 'Mutation', authRefresh: { __typename?: 'AuthSession', accessToken: string, refreshToken: string } };

export type AuthVerifyMutationVariables = Exact<{
  authInitId: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type AuthVerifyMutation = { __typename?: 'Mutation', authVerify: { __typename?: 'AuthSession', accessToken: string, refreshToken: string, companyProfileId: string, companyExternalId: string, profileExternalId: string } };

export type ChangeLanguageMutationVariables = Exact<{
  language: Language;
}>;


export type ChangeLanguageMutation = { __typename?: 'Mutation', companyProfileChangeLanguage: { __typename?: 'CompanyProfile', id: any, language?: Language | null } };

export type CompleteLearningCardV2MutationVariables = Exact<{
  learningCardId: Scalars['UUID']['input'];
  skillId: Scalars['UUID']['input'];
}>;


export type CompleteLearningCardV2Mutation = { __typename?: 'Mutation', completeLearningCardV2: { __typename?: 'LearningCardAssignmentCompletion', skillCompletedAt?: any | null, pointsEarned: number, id: any, companyProfileSkillId: any, learningCardId: any, companyProfileId: any, progress: number, createdAt: any, startedAt: any, failedAt?: any | null, completedAt?: any | null, triesCount: number, learningCardCompletionFormSummary?: { __typename?: 'LearningCardCompletionFormConnection', nodes: Array<{ __typename?: 'LearningCardCompletionForm', id: any, promptId: any, isFailed: boolean, submittedAt: any, learningCardCompletionFormAnswersSummary: { __typename?: 'LearningCardCompletionFormAnswerSummaryConnection', nodes: Array<{ __typename?: 'LearningCardCompletionFormAnswerSummary', id: any, learningCardCompletionFormId?: any | null, isFailed: boolean, choiceId: any, answer?: string | null }> } }> } | null } };

export type CreateLccFormMutationVariables = Exact<{
  learningCardId: Scalars['UUID']['input'];
  promptId: Scalars['UUID']['input'];
  answers: Array<LearningCardCompletionFormAnswerArg> | LearningCardCompletionFormAnswerArg;
}>;


export type CreateLccFormMutation = { __typename?: 'Mutation', learningCardCompletionFormCreate: { __typename?: 'LearningCardCompletionForm', id: any, learningCardAssignmentCompletionId: any, promptId: any, isFailed: boolean, learningCardAssignmentCompletion: { __typename?: 'LearningCardAssignmentCompletion', id: any, companyProfileSkillId: any, learningCardId: any, progress: number, failedAt?: any | null, completedAt?: any | null, triesCount: number, formTransactional?: { __typename?: 'FormTransactional', id: any, type: FormType, passingThreshold?: number | null, maxTries?: number | null, maxTriesPerPrompt?: MaxTriesPerPrompt | null, showCorrectChoicesAtTheEnd?: boolean | null, learningCardAssignmentCompletionId?: any | null, formLocalized?: { __typename?: 'FormLocalized', description: string, id: any, language: Language } | null, learningCardAssignmentCompletion?: { __typename?: 'LearningCardAssignmentCompletion', startedAt: any, failedAt?: any | null, completedAt?: any | null } | null, prompts: { __typename?: 'PromptTransactionalConnection', nodes: Array<{ __typename?: 'PromptTransactional', id: any, formId: any, position: number, choicesCountConfig: ChoicesCountConfig, minChoicesCountRequired: number, maxChoicesCountRequired: number, isMultiple: boolean, isFailed?: boolean | null, isCompleted?: boolean | null, promptLocalized?: { __typename?: 'PromptLocalized', id: any, description: string } | null, choices?: { __typename?: 'ChoiceTransactionalConnection', nodes: Array<{ __typename?: 'ChoiceTransactional', id: any, promptId: any, type: ChoiceType, isFailed?: boolean | null, isCorrect?: boolean | null, isSelected?: boolean | null, answer?: string | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, language: Language, description?: string | null, media?: { __typename?: 'Media', mediaUrl?: string | null } | null } | null }> } | null }> } } | null } } };

export type CreateReactionMutationVariables = Exact<{
  objectType: ReactionObjectType;
  objectId: Scalars['UUID']['input'];
  type: ReactionType;
}>;


export type CreateReactionMutation = { __typename?: 'Mutation', createReaction: { __typename?: 'Reaction', id: any, type: ReactionType, companyProfileId: any } };

export type DashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardQuery = { __typename?: 'Query', assignments: { __typename?: 'AssignmentList', nodes: Array<{ __typename?: 'AssignmentLP', id: string, dueDate?: any | null, orderAssignedAt: any, learningPlan: { __typename?: 'LearningPlan', id: any, externalId: string, mandatory?: boolean | null, dueSoon?: boolean | null, learningPlanLocalized: { __typename?: 'LearningPlanLocalized', id: any, description?: string | null, learningPlanFolderName?: string | null } }, assignmentSkillCards: { __typename?: 'AssignmentSkillCardConnection', nodes: Array<{ __typename?: 'AssignmentSkillCard', id: any, lpCompanySectionExternalId?: string | null, skillExternalId: string, companyProfileSkillId: string, isLocked: boolean, points: number, progress?: number | null, skillId: any, skillFlow: SkillFlow, pointsEarned: number, completedAt?: any | null, failedAt?: any | null, repAssignmentId?: any | null, repAssignmentStatus?: RepAssignmentStatus | null, repLastActivityAt?: any | null, skill: { __typename?: 'Skill', id: any, name: string, externalId: string, type: SkillType, repType?: RepType | null, duration?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', id: any, language: Language, description: string } | null } }> } }> } };

export type RemoveReactionMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RemoveReactionMutation = { __typename?: 'Mutation', removeReaction: { __typename?: 'Reaction', id: any, type: ReactionType, companyProfileId: any } };

export type RemoveSkillProgressMutationVariables = Exact<{
  skillExternalId: Scalars['String']['input'];
  profileExternalId: Scalars['String']['input'];
}>;


export type RemoveSkillProgressMutation = { __typename?: 'Mutation', deleteSkillProgress: { __typename?: 'AssignmentList', nodes: Array<{ __typename?: 'AssignmentLP', id: string }> } };

export type EmbeddedContextMutationVariables = Exact<{
  groupExternalId: Scalars['String']['input'];
  profileExternalId: Scalars['String']['input'];
  companyExternalId: Scalars['String']['input'];
  profileEmailAddress?: InputMaybe<Scalars['String']['input']>;
  profilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  memberType?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
}>;


export type EmbeddedContextMutation = { __typename?: 'Mutation', createOrReturnUser: { __typename?: 'CreateUserResponse', assignments?: Array<{ __typename?: 'AssignmentLP', assignmentSkillCards: { __typename?: 'AssignmentSkillCardConnection', nodes: Array<{ __typename?: 'AssignmentSkillCard', repAssignmentId?: any | null, skill: { __typename?: 'Skill', id: any, externalId: string, type: SkillType } }> }, learningPlan: { __typename?: 'LearningPlan', id: any, lpSections: { __typename?: 'LPSectionConnection', nodes: Array<{ __typename?: 'LPSection', externalId: string }> } } }> | null } };

export type FailCompanyProfileSkillMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FailCompanyProfileSkillMutation = { __typename?: 'Mutation', failCompanyProfileSkill: { __typename?: 'CompanyProfileSkill', id: string, failedAt?: any | null } };

export type FormTransactionalQueryVariables = Exact<{
  learningCardId: Scalars['UUID']['input'];
}>;


export type FormTransactionalQuery = { __typename?: 'Query', formTransactionalGet?: { __typename?: 'FormTransactional', id: any, type: FormType, passingThreshold?: number | null, maxTries?: number | null, maxTriesPerPrompt?: MaxTriesPerPrompt | null, showCorrectChoicesAtTheEnd?: boolean | null, learningCardAssignmentCompletionId?: any | null, formLocalized?: { __typename?: 'FormLocalized', description: string, id: any, language: Language } | null, learningCardAssignmentCompletion?: { __typename?: 'LearningCardAssignmentCompletion', startedAt: any, failedAt?: any | null, completedAt?: any | null } | null, prompts: { __typename?: 'PromptTransactionalConnection', nodes: Array<{ __typename?: 'PromptTransactional', id: any, formId: any, position: number, choicesCountConfig: ChoicesCountConfig, minChoicesCountRequired: number, maxChoicesCountRequired: number, isMultiple: boolean, isFailed?: boolean | null, isCompleted?: boolean | null, promptLocalized?: { __typename?: 'PromptLocalized', id: any, description: string } | null, choices?: { __typename?: 'ChoiceTransactionalConnection', nodes: Array<{ __typename?: 'ChoiceTransactional', id: any, promptId: any, type: ChoiceType, isFailed?: boolean | null, isCorrect?: boolean | null, isSelected?: boolean | null, answer?: string | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, language: Language, description?: string | null, media?: { __typename?: 'Media', mediaUrl?: string | null } | null } | null }> } | null }> } } | null };

export type GetNextSkillV2QueryVariables = Exact<{
  skillExternalId: Scalars['String']['input'];
}>;


export type GetNextSkillV2Query = { __typename?: 'Query', companyProfileSkillGetNext?: { __typename?: 'CompanyProfileSkillGetNext', id: string, lpCompanySectionExternalId: string, skillId: any, skillName: string, skillExternalId: string, skillType: SkillType, skillFlow: SkillFlow, repAssignmentId?: string | null, repType?: RepType | null } | null };

export type GetNextSkillV3QueryVariables = Exact<{ [key: string]: never; }>;


export type GetNextSkillV3Query = { __typename?: 'Query', assignmentSkillGetNext?: { __typename?: 'AssignmentSkillCardGetNext', id: any, companyId: any, lpCompanySectionExternalId?: string | null, repAssignmentId?: any | null, status: AssignmentSkillCardGetNextStatus, skill: { __typename?: 'Skill', id: any, externalId: string, type: SkillType, repType?: RepType | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', id: any, description: string } | null }, learningPlan: { __typename?: 'LearningPlan', id: any, learningPlanLocalized: { __typename?: 'LearningPlanLocalized', id: any, description?: string | null } } } | null };

export type GetTranscriptionMediaObjectByIdQueryVariables = Exact<{
  mediaId: Scalars['String']['input'];
}>;


export type GetTranscriptionMediaObjectByIdQuery = { __typename?: 'Query', getTranscriptionMediaObjectById: { __typename?: 'GetTranscriptionMediaObjectById', awsOutcome?: { __typename?: 'AwsOutcome', jobName?: string | null, accountId?: string | null, status?: string | null, results?: { __typename?: 'Results', transcripts?: Array<{ __typename?: 'Transcript', transcript?: string | null, language?: string | null }> | null, timeline?: Array<{ __typename?: 'Timeline', sentence?: string | null, speaker?: string | null, start_time?: string | null, end_time?: string | null }> | null, speakerLabels?: Array<{ __typename?: 'SpeakerLabel', speakerId?: string | null, speakerLabel?: string | null, speakerName?: string | null, speakerRole?: string | null, speakerRoleDisplayed?: string | null, talkRatio?: number | null, isPresenter?: boolean | null }> | null } | null } | null } };

export type GoogleAuthVerifyMutationVariables = Exact<{
  idToken: Scalars['String']['input'];
  source?: InputMaybe<AuthenticationSource>;
}>;


export type GoogleAuthVerifyMutation = { __typename?: 'Mutation', googleAuthVerify: { __typename?: 'SocialAuthSession', accessToken: string, refreshToken: string, companyProfileId: string, companyExternalId: string, socialPhotoUpdateStatus?: string | null, socialPhotoUpdateErrorMessage?: string | null } };

export type IsNewAuthQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type IsNewAuthQuery = { __typename?: 'Query', isNewAuth: boolean };

export type LeaderboardQueryVariables = Exact<{ [key: string]: never; }>;


export type LeaderboardQuery = { __typename?: 'Query', leaderboard: { __typename?: 'Leaderboard', totalAssignments: number, completedAssignments: number, score: number, position: number, scores: Array<number> } };

export type LeaderboardV2QueryVariables = Exact<{ [key: string]: never; }>;


export type LeaderboardV2Query = { __typename?: 'Query', leaderboardV2: { __typename?: 'LeaderboardV2', leaderBoards: Array<{ __typename?: 'GroupLeaderBoard', groupName: string, groupScores: Array<{ __typename?: 'GroupLeaderBoardItem', rowIconURL: string, rowName: string, rowScore: number }> }> } };

export type LeaderboardV3QueryVariables = Exact<{ [key: string]: never; }>;


export type LeaderboardV3Query = { __typename?: 'Query', leaderboardV3: { __typename?: 'LeaderboardV3', leaderBoard?: { __typename?: 'SocialGroupLeaderBoard', name: string, iconURL: string, position: number, score: number, groupScores: Array<{ __typename?: 'GroupLeaderBoardItem', rowIconURL: string, rowName: string, rowScore: number }> } | null } };

export type LearningPlanAssignmentMutationVariables = Exact<{
  profileExternalId: Scalars['String']['input'];
  companyExternalId: Scalars['String']['input'];
  learningPlanExternalId: Scalars['String']['input'];
  profileEmailAddress?: InputMaybe<Scalars['String']['input']>;
  profilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type LearningPlanAssignmentMutation = { __typename?: 'Mutation', learningPlanAssignment: { __typename?: 'LearningPlanAssignmentResponse', success: boolean, details: Array<{ __typename?: 'LearningPlanAssignmentDetail', skillExternalId: string, success: boolean, details?: string | null }> } };

export type MeQueryVariables = Exact<{
  appName?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  browserName?: InputMaybe<Scalars['String']['input']>;
  browserVersion?: InputMaybe<Scalars['String']['input']>;
  osName?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  platformVendor?: InputMaybe<Scalars['String']['input']>;
  platformModel?: InputMaybe<Scalars['String']['input']>;
}>;


export type MeQuery = { __typename?: 'Query', meV2: { __typename?: 'CompanyProfile', id: any, externalId: string, companyId: any, isCoach: boolean, language?: Language | null, emailAddress?: string | null, phoneNumber?: string | null, score: number, excludeFromAnalytics: boolean, hasCoachedReps: boolean, hasSocialReps: boolean, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, createdAt: any, acceptedLegal: boolean, enabledFeatures: Array<FeatureType>, isSuperuser: boolean, flags: Array<{ __typename?: 'Flag', name: string, value: string }>, workspaces: { __typename?: 'WorkspaceConnection', nodes: Array<{ __typename?: 'Workspace', id: string, externalId: string, companyId: string, companyName: string, companyExternalId: string, companyInternalName: string, companyLogo?: string | null }> }, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }, company: { __typename?: 'Company', id: string, externalId?: string | null, defaultLanguage?: Language | null, displayName?: string | null, name?: string | null, logoMedia?: { __typename?: 'Media', id: any, path?: string | null } | null, companyLanguages: { __typename?: 'CompanyLanguageConnection', nodes: Array<{ __typename?: 'CompanyLanguage', id: string, language: Language }> } } } };

export type ProScoreQueryVariables = Exact<{ [key: string]: never; }>;


export type ProScoreQuery = { __typename?: 'Query', proScoreGetV3?: { __typename?: 'ProScoreV3', id: string, skillsAssignedCount: number, skillsCompletedCount: number, repsCompletedCount: number, repsAssignedCount: number, score: number, proScore: number } | null };

export type ProfilePhotoEditMutationVariables = Exact<{
  photoUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfilePhotoEditMutation = { __typename?: 'Mutation', profilePhotoEdit: { __typename?: 'Profile', id: string, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } };

export type ProfileSearchFilteredByGroupQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  conditions?: InputMaybe<CompanyProfileSearchFilteredByGroupConditions>;
}>;


export type ProfileSearchFilteredByGroupQuery = { __typename?: 'Query', profileSearchFilteredByGroup: { __typename?: 'PaginatedCompanyProfileSearchFilteredByGroupResponse', nodes: Array<{ __typename?: 'CompanyProfile', id: any, emailAddress?: string | null, phoneNumber?: string | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, preferredName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }> } };

export type RepPromptSearchWithoutFilterQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  conditions?: InputMaybe<RepPromptSearchWithoutFilterCondition>;
}>;


export type RepPromptSearchWithoutFilterQuery = { __typename?: 'Query', repPromptSearchSocial: { __typename?: 'PaginatedRepPromptSearchWithoutFilterResponse', nodes: Array<{ __typename?: 'RepPromptSearch', id: string, skillName: string, skillLocalizedName?: string | null }> } };

export type RepPromptSearchFilteredByCoachRepAssignmentsQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  conditions?: InputMaybe<RepPromptSearchFilteredByCoachRepAssignmentsConditions>;
}>;


export type RepPromptSearchFilteredByCoachRepAssignmentsQuery = { __typename?: 'Query', repPromptSearchFilteredByCoachRepAssignments: { __typename?: 'PaginatedRepPromptSearchFilteredByCoachRepAssignmentsResponse', nodes: Array<{ __typename?: 'RepPromptSearch', id: string, skillName: string, skillLocalizedName?: string | null }> } };

export type RepSubmissionFinalizeMultipartUploadMutationVariables = Exact<{
  mediaId: Scalars['UUID']['input'];
  fileId: Scalars['String']['input'];
  fileKey: Scalars['String']['input'];
  parts: Array<FinalizeMultipartUploadPart> | FinalizeMultipartUploadPart;
}>;


export type RepSubmissionFinalizeMultipartUploadMutation = { __typename?: 'Mutation', repSubmissionFinalizeMultipartUpload: { __typename?: 'Media', id: any, mimeType: string, location: MediaLocation, playbackId: string, mediaUrl?: string | null } };

export type RepSubmissionGetMultipartUploadDataMutationVariables = Exact<{
  mimeType: Scalars['String']['input'];
  mediaType: MediaType;
  fileSize: Scalars['Int']['input'];
  numberOfParts: Scalars['Int']['input'];
}>;


export type RepSubmissionGetMultipartUploadDataMutation = { __typename?: 'Mutation', repSubmissionGetMultipartUploadData: { __typename?: 'RepSubmissionGetMultipartUploadData', mediaId: any, fileId: string, fileKey: string, parts: Array<{ __typename?: 'GetMultipartUploadDataPart', partNumber: number, signedUrl: string }> } };

export type ResetLearningPlanProgressMutationVariables = Exact<{
  resetLearningPlanProgressInput: ResetLearningPlanProgressInput;
}>;


export type ResetLearningPlanProgressMutation = { __typename?: 'Mutation', resetLearningPlanProgress: { __typename?: 'AssignmentLP', id: string, assignmentSkillCards: { __typename?: 'AssignmentSkillCardConnection', nodes: Array<{ __typename?: 'AssignmentSkillCard', repAssignmentId?: any | null, skill: { __typename?: 'Skill', externalId: string, id: any, type: SkillType } }> } } };

export type RetryLccFormMutationVariables = Exact<{
  learningCardId: Scalars['UUID']['input'];
}>;


export type RetryLccFormMutation = { __typename?: 'Mutation', learningCardCompletionRetry: { __typename?: 'LearningCardAssignmentCompletion', id: any, learningCardId: any, progress: number, createdAt: any, startedAt: any, failedAt?: any | null, completedAt?: any | null, learningCardCompletionFormSummary?: { __typename?: 'LearningCardCompletionFormConnection', nodes: Array<{ __typename?: 'LearningCardCompletionForm', id: any, promptId: any, isFailed: boolean, submittedAt: any, learningCardCompletionFormAnswersSummary: { __typename?: 'LearningCardCompletionFormAnswerSummaryConnection', nodes: Array<{ __typename?: 'LearningCardCompletionFormAnswerSummary', id: any, learningCardCompletionFormId?: any | null, isFailed: boolean, choiceId: any, answer?: string | null }> } }> } | null } };

export type SearchQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchQuery = { __typename?: 'Query', assignments: { __typename?: 'AssignmentList', nodes: Array<{ __typename?: 'AssignmentLP', id: string, learningPlan: { __typename?: 'LearningPlan', lpSections: { __typename?: 'LPSectionConnection', nodes: Array<{ __typename?: 'LPSection', externalId: string, lpSectionSkills: { __typename?: 'LPSectionSkillConnection', nodes: Array<{ __typename?: 'LPSectionSkill', skill: { __typename?: 'Skill', type: SkillType, id: any, name: string, externalId: string, skillLocalized?: { __typename?: 'SkillLocalized', id: any, description: string } | null, skillSkillSection: { __typename?: 'SkillSkillSectionConnection', nodes: Array<{ __typename?: 'SkillSkillSection', learningCards: { __typename?: 'LearningCardConnection', nodes: Array<{ __typename?: 'LearningCard', id: any, learningCardLocalized: { __typename?: 'LearningCardForm', id: any } | { __typename?: 'LearningCardLocalizedFile', id: any, title?: string | null } | { __typename?: 'LearningCardLocalizedFlashCard', id: any, title?: string | null } | { __typename?: 'LearningCardLocalizedLinkout', id: any, title?: string | null, description?: string | null } | { __typename?: 'LearningCardLocalizedVideo', id: any, title?: string | null } | { __typename?: 'LearningCardRep' } }> } }> } } }> } }> } } }> }, transactional: { __typename?: 'AssignmentList', nodes: Array<{ __typename?: 'AssignmentLP', id: string, isLocked: boolean, assignmentSkills: { __typename?: 'AssignmentSkillConnection', nodes: Array<{ __typename?: 'AssignmentSkill', id: any, isLocked: boolean, companyProfileSkill: { __typename?: 'CompanyProfileSkill', skillId: string } }> } }> } };

export type SkillConfigQueryVariables = Exact<{
  skillExternalId: Scalars['String']['input'];
  lpCompanySectionExternalId: Scalars['String']['input'];
}>;


export type SkillConfigQuery = { __typename?: 'Query', skill: { __typename?: 'Skill', id: any, name: string, flow: SkillFlow, externalId: string, photoUrl: string, duration?: string | null, skillLocalized?: { __typename?: 'SkillLocalized', id: any, description: string } | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillSkillSection: { __typename?: 'SkillSkillSectionConnection', nodes: Array<{ __typename?: 'SkillSkillSection', id: any, skillId: any, skillSectionId: any, position: number, skillSection: { __typename?: 'SkillSection', id: any, name: string, skillSectionLocalized: { __typename?: 'SkillSectionLocalized', id: any, description: string, language: Language } }, learningCards: { __typename?: 'LearningCardConnection', nodes: Array<{ __typename?: 'LearningCard', id: any, position: number, experimentConfig?: any | null, resetLpIfFail: boolean, learningCardLocalized: { __typename?: 'LearningCardForm', id: any, type: LearningCardType, formId: any, form: { __typename?: 'Form', id: any, maxTries?: number | null } } | { __typename?: 'LearningCardLocalizedFile', id: any, type: LearningCardType, language: Language, title?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } | { __typename?: 'LearningCardLocalizedFlashCard', id: any, type: LearningCardType, title?: string | null, description?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } | { __typename?: 'LearningCardLocalizedLinkout', id: any, type: LearningCardType, title?: string | null, url?: string | null, description?: string | null, ctaTitle?: string | null } | { __typename?: 'LearningCardLocalizedVideo', id: any, type: LearningCardType, language: Language, title?: string | null, media?: { __typename?: 'Media', id: any, mimeType: string, location: MediaLocation, playbackId: string, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, textTrackMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } | { __typename?: 'LearningCardRep' } }> } }> }, lpSectionSkill: { __typename?: 'LPSectionSkill', id: any, points: number, lpSection: { __typename?: 'LPSection', id: any, learningPlan: { __typename?: 'LearningPlan', id: any, learningPlanLocalized: { __typename?: 'LearningPlanLocalized', id: any, description?: string | null } } } } } };

export type LearningCardFragment = { __typename?: 'LearningCard', id: any, position: number, experimentConfig?: any | null, resetLpIfFail: boolean, learningCardLocalized: { __typename?: 'LearningCardForm', id: any, type: LearningCardType, formId: any, form: { __typename?: 'Form', id: any, maxTries?: number | null } } | { __typename?: 'LearningCardLocalizedFile', id: any, type: LearningCardType, language: Language, title?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } | { __typename?: 'LearningCardLocalizedFlashCard', id: any, type: LearningCardType, title?: string | null, description?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } | { __typename?: 'LearningCardLocalizedLinkout', id: any, type: LearningCardType, title?: string | null, url?: string | null, description?: string | null, ctaTitle?: string | null } | { __typename?: 'LearningCardLocalizedVideo', id: any, type: LearningCardType, language: Language, title?: string | null, media?: { __typename?: 'Media', id: any, mimeType: string, location: MediaLocation, playbackId: string, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, textTrackMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } | { __typename?: 'LearningCardRep' } };

export type SkillTransactionalQueryVariables = Exact<{
  skillExternalId: Scalars['String']['input'];
}>;


export type SkillTransactionalQuery = { __typename?: 'Query', companyProfileSkill: { __typename?: 'CompanyProfileSkill', id: string, skillId: string, companyProfileId: any, type: string, completedAt?: any | null, failedAt?: any | null, pointsEarned: number, progress?: number | null, companyProfile?: { __typename?: 'CompanyProfile', externalId: string } | null, feedback?: { __typename?: 'Feedback', id: any, rating?: number | null } | null, repAssignment?: { __typename?: 'RepAssignment', id: any, repPromptId?: any | null } | null, learningCardAssignmentCompletions: { __typename?: 'LearningCardAssignmentCompletionConnection', nodes: Array<{ __typename?: 'LearningCardAssignmentCompletion', id: any, companyProfileSkillId: any, learningCardId: any, companyProfileId: any, progress: number, createdAt: any, startedAt: any, failedAt?: any | null, completedAt?: any | null, triesCount: number, feedback?: { __typename?: 'Feedback', id: any, rating?: number | null } | null, learningCardCompletionFormSummary?: { __typename?: 'LearningCardCompletionFormConnection', nodes: Array<{ __typename?: 'LearningCardCompletionForm', id: any, promptId: any, isFailed: boolean, submittedAt: any, learningCardCompletionFormAnswersSummary: { __typename?: 'LearningCardCompletionFormAnswerSummaryConnection', nodes: Array<{ __typename?: 'LearningCardCompletionFormAnswerSummary', id: any, learningCardCompletionFormId?: any | null, isFailed: boolean, choiceId: any, answer?: string | null }> } }> } | null }> } } };

export type FeedbackFragment = { __typename?: 'Feedback', id: any, rating?: number | null };

export type SocialRepSubmissionContentEditMutationVariables = Exact<{
  repSubmissionId: Scalars['UUID']['input'];
  content: Scalars['String']['input'];
}>;


export type SocialRepSubmissionContentEditMutation = { __typename?: 'Mutation', socialRepSubmissionContentEdit: { __typename?: 'RepSubmission', title?: string | null, id: any, createdAt?: any | null, content: string, caption?: string | null, transformedMediaUrl?: string | null, repAssignmentId?: any | null } };

export type SocialRepSubmissionDeleteMutationVariables = Exact<{
  repSubmissionId: Scalars['UUID']['input'];
}>;


export type SocialRepSubmissionDeleteMutation = { __typename?: 'Mutation', socialRepSubmissionDelete: { __typename?: 'RepAssignment', id: any, repAssignmentStatus: RepAssignmentStatus } };

export type RepSubmissionSubmitToCoachMutationVariables = Exact<{
  repSubmissionId: Scalars['UUID']['input'];
}>;


export type RepSubmissionSubmitToCoachMutation = { __typename?: 'Mutation', repSubmissionSubmitToCoach: { __typename?: 'RepSubmission', id: any } };

export type TodaysPracticeQueryVariables = Exact<{ [key: string]: never; }>;


export type TodaysPracticeQuery = { __typename?: 'Query', todaysPractice: { __typename?: 'AssignmentSkillCardTodaysPracticeList', nodes: Array<{ __typename?: 'AssignmentSkillCardTodaysPractice', id: any, dueDate?: any | null, lpCompanySectionExternalId?: string | null, skillExternalId: string, companyProfileSkillId: string, points: number, progress?: number | null, skillId: any, skillFlow: SkillFlow, pointsEarned: number, repAssignmentId?: any | null, repAssignmentStatus?: RepAssignmentStatus | null, countOfLearningCards: number, countOfLearningCardsAssignmentCompletions: number, learningPlan: { __typename?: 'LearningPlan', name: string, mandatory?: boolean | null, learningPlanLocalized: { __typename?: 'LearningPlanLocalized', learningPlanFolderName?: string | null, description?: string | null } }, skill: { __typename?: 'Skill', id: any, name: string, externalId: string, type: SkillType, repType?: RepType | null, media?: { __typename?: 'Media', mediaUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', language: Language, description: string } | null } }> } };

export type TopicDetailsQueryVariables = Exact<{
  conditions?: InputMaybe<TopicConditions>;
}>;


export type TopicDetailsQuery = { __typename?: 'Query', topicsPaginated: { __typename?: 'PaginatedTopic', nodes: Array<{ __typename?: 'Topic', id: any, name: string, skillCount: number, repCount: number, assignmentSkillCards: { __typename: 'AssignmentSkillCardConnection', nodes: Array<{ __typename?: 'AssignmentSkillCard', id: any, repSubmissionCount?: number | null, lpCompanySectionExternalId?: string | null, skillExternalId: string, companyProfileSkillId: string, isLocked: boolean, points: number, progress?: number | null, skillFlow: SkillFlow, repAssignmentId?: any | null, repAssignmentStatus?: RepAssignmentStatus | null, completedAt?: any | null, failedAt?: any | null, pointsEarned: number, skill: { __typename?: 'Skill', id: any, name: string, externalId: string, type: SkillType, duration?: string | null, repType?: RepType | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null, thumbnailUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', description: string } | null } }> }, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null, thumbnailUrl?: string | null } | null, topicLocalized?: { __typename?: 'TopicLocalized', id: any, description: string, language: Language } | null }> } };

export type TopicsListQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
}>;


export type TopicsListQuery = { __typename?: 'Query', topicsPaginated: { __typename?: 'PaginatedTopic', totalCount?: number | null, nodes: Array<{ __typename?: 'Topic', id: any, name: string, skillCount: number, repCount: number, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null, thumbnailUrl?: string | null } | null, topicLocalized?: { __typename?: 'TopicLocalized', id: any, description: string, language: Language } | null }>, pageInfo: { __typename?: 'TopicPageInfo', afterCursor?: string | null, beforeCursor?: string | null } } };

export type UpdateOrCreateFeedbackMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
  objectType: FeedbackObjectType;
  objectId: Scalars['UUID']['input'];
  ratingType: FeedbackRatingType;
  rating?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrCreateFeedbackMutation = { __typename?: 'Mutation', updateOrCreateFeedback: { __typename?: 'Feedback', id: any, rating?: number | null, response?: string | null, objectType: FeedbackObjectType } };

export type AssignmentFragment = { __typename?: 'AssignmentLP', id: string, isLocked: boolean, completedAt?: any | null, skillCount: number, repCount: number, progress: number, learningPlan: { __typename?: 'LearningPlan', id: any, externalId: string, photoUrl?: string | null, learningPlanLocalized: { __typename?: 'LearningPlanLocalized', description?: string | null } } };

export type AssignmentSkillCardFragment = { __typename?: 'AssignmentSkillCard', id: any, repSubmissionCount?: number | null, lpCompanySectionExternalId?: string | null, skillExternalId: string, companyProfileSkillId: string, isLocked: boolean, points: number, progress?: number | null, skillFlow: SkillFlow, repAssignmentId?: any | null, repAssignmentStatus?: RepAssignmentStatus | null, completedAt?: any | null, failedAt?: any | null, pointsEarned: number, skill: { __typename?: 'Skill', id: any, name: string, externalId: string, type: SkillType, duration?: string | null, repType?: RepType | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null, thumbnailUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', description: string } | null } };

export type CoachRepAssignmentFragment = { __typename?: 'RepAssignment', id: any, companyProfileId: any, repAssignmentStatus: RepAssignmentStatus, lastActivityAt?: any | null, points: number, learnerCompanyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }, skill: { __typename?: 'Skill', id: any, name: string, externalId: string, type: SkillType, duration?: string | null, repType?: RepType | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null, thumbnailUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', description: string } | null }, repPrompt?: { __typename?: 'RepPrompt', id: any, repPromptLocalized: { __typename?: 'RepPromptLocalized', id: any, content: string, language: Language } } | null, repSubmissions: { __typename?: 'RepSubmissionConnection', nodes: Array<{ __typename?: 'RepSubmission', id: any, title?: string | null, caption?: string | null, repAssignmentId?: any | null, content: string, responseType: RepResponseKind, createdAt?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> } };

export type FormTransactionalFragment = { __typename?: 'FormTransactional', id: any, type: FormType, passingThreshold?: number | null, maxTries?: number | null, maxTriesPerPrompt?: MaxTriesPerPrompt | null, showCorrectChoicesAtTheEnd?: boolean | null, learningCardAssignmentCompletionId?: any | null, formLocalized?: { __typename?: 'FormLocalized', description: string, id: any, language: Language } | null, learningCardAssignmentCompletion?: { __typename?: 'LearningCardAssignmentCompletion', startedAt: any, failedAt?: any | null, completedAt?: any | null } | null, prompts: { __typename?: 'PromptTransactionalConnection', nodes: Array<{ __typename?: 'PromptTransactional', id: any, formId: any, position: number, choicesCountConfig: ChoicesCountConfig, minChoicesCountRequired: number, maxChoicesCountRequired: number, isMultiple: boolean, isFailed?: boolean | null, isCompleted?: boolean | null, promptLocalized?: { __typename?: 'PromptLocalized', id: any, description: string } | null, choices?: { __typename?: 'ChoiceTransactionalConnection', nodes: Array<{ __typename?: 'ChoiceTransactional', id: any, promptId: any, type: ChoiceType, isFailed?: boolean | null, isCorrect?: boolean | null, isSelected?: boolean | null, answer?: string | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, language: Language, description?: string | null, media?: { __typename?: 'Media', mediaUrl?: string | null } | null } | null }> } | null }> } };

export type LearningCardAssignmentCompletionsFragment = { __typename?: 'LearningCardAssignmentCompletion', id: any, companyProfileSkillId: any, learningCardId: any, companyProfileId: any, progress: number, createdAt: any, startedAt: any, failedAt?: any | null, completedAt?: any | null, triesCount: number, learningCardCompletionFormSummary?: { __typename?: 'LearningCardCompletionFormConnection', nodes: Array<{ __typename?: 'LearningCardCompletionForm', id: any, promptId: any, isFailed: boolean, submittedAt: any, learningCardCompletionFormAnswersSummary: { __typename?: 'LearningCardCompletionFormAnswerSummaryConnection', nodes: Array<{ __typename?: 'LearningCardCompletionFormAnswerSummary', id: any, learningCardCompletionFormId?: any | null, isFailed: boolean, choiceId: any, answer?: string | null }> } }> } | null };

export type LearningPlanFragment = { __typename?: 'LearningPlan', id: any, externalId: string, photoUrl?: string | null, learningPlanLocalized: { __typename?: 'LearningPlanLocalized', description?: string | null } };

export type ProScoreFragment = { __typename?: 'ProScoreV3', id: string, skillsAssignedCount: number, skillsCompletedCount: number, repsCompletedCount: number, repsAssignedCount: number, score: number, proScore: number };

export type ProfileFragment = { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, createdAt: any, acceptedLegal: boolean, enabledFeatures: Array<FeatureType>, isSuperuser: boolean, hasCoachedReps: boolean, hasSocialReps: boolean, flags: Array<{ __typename?: 'Flag', name: string, value: string }>, companyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, companyId: any, isCoach: boolean, language?: Language | null, emailAddress?: string | null, phoneNumber?: string | null, score: number, excludeFromAnalytics: boolean, company: { __typename?: 'Company', id: string, externalId?: string | null, defaultLanguage?: Language | null, displayName?: string | null, name?: string | null, companyLanguages: { __typename?: 'CompanyLanguageConnection', nodes: Array<{ __typename?: 'CompanyLanguage', id: string, language: Language }> } } }, workspaces: { __typename?: 'WorkspaceConnection', nodes: Array<{ __typename?: 'Workspace', id: string, externalId: string, companyId: string, companyName: string, companyExternalId: string, companyInternalName: string, companyLogo?: string | null }> }, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null };

export type ProfilePhotoFragment = { __typename?: 'Profile', media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null };

export type ReactionFragment = { __typename?: 'Reaction', id: any, type: ReactionType, companyProfileId: any };

export type RepAssignmentFragment = { __typename?: 'RepAssignment', id: any, repSubmissionCount: number, repAssignmentStatus: RepAssignmentStatus, points: number, lastActivityAt?: any | null, createdAt: any, learnerCompanyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }, assignorCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } | null, skill: { __typename?: 'Skill', id: any, externalId: string, name: string, updatedAt: any, repPoints?: number | null, freestylePoints?: number | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', language: Language, description: string } | null }, repPrompt?: { __typename?: 'RepPrompt', id: any, selfPracticeEnabled: boolean, keywordAnalysisEnabled: boolean, allResponseTypeEnabled: boolean, isCoached: boolean, repType: RepType, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteria', keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', incorrectKeywords?: Array<string> | null, allowedKeywords?: Array<string> | null } | null } | null, interjectionsHandling?: { __typename?: 'InterjectionsHandling', interjections?: Array<{ __typename?: 'Interjection', index?: string | null, start?: string | null, duration?: string | null, author?: string | null, message?: Array<{ __typename?: 'InterjectionMessage', translatedText?: string | null, language: Language }> | null }> | null } | null, formConfig?: { __typename?: 'Form', id: any, type: FormType, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, isRubric: boolean, isMultiple: boolean, promptLocalized?: { __typename?: 'PromptLocalized', id: any, description: string } | null, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, isCorrect?: boolean | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, description?: string | null } | null }> } }> } } | null, repPromptLocalized: { __typename?: 'RepPromptLocalized', id: any, language: Language, promptType: RepResponseKind, title?: string | null, content: string, caption?: string | null }, repPromptResponseTypes: { __typename?: 'RepPromptResponseTypeConnection', nodes: Array<{ __typename?: 'RepPromptResponseType', responseType?: RepResponseKind | null }> } } | null, repSubmissions: { __typename?: 'RepSubmissionConnection', nodes: Array<{ __typename?: 'RepSubmission', id: any, repAssignmentId?: any | null, title?: string | null, content: string, caption?: string | null, responseType: RepResponseKind, createdAt?: any | null, aiReviewStatus?: ReviewStatus | null, coachReviewStatus?: ReviewStatus | null, error?: { __typename?: 'ErrorMsg', error?: string | null, statusCode?: string | null } | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, streamMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, transcriptionMedia?: { __typename?: 'Media', id: any, status: MediaStatus, error?: string | null } | null, reactions: { __typename?: 'ReactionsConnection', nodes: Array<{ __typename?: 'Reaction', id: any, type: ReactionType, companyProfileId: any }> }, repSubmissionFeedbacks: { __typename?: 'RepSubmissionFeedbackConnection', nodes: Array<{ __typename?: 'RepSubmissionFeedback', id: any, createdAt?: any | null, feedbackType: RepFeedbackType, responseType: RepResponseKind, content?: string | null, caption?: string | null, reviewerRole: ReviewerRoleType, previewUrl?: string | null, mediaUrl?: string | null, rawMediaUrl?: string | null, autoEvaluationOutcome?: { __typename?: 'AutoEvaluationOutcome', isArticulationPass?: boolean | null, isKeywordPass?: boolean | null, sentiment?: number | null, conversationMetrics?: { __typename?: 'ConversationMetrics', conversationType: string, noOfSubmitterQuestions?: number | null, overallFeedback?: string | null, questionRate: number, thresholds: { __typename?: 'ConversationMetricsThresholds', stackedQuestionsCount: number, talkRatio: number, questionRate: number, pauseDuration: Array<number>, noOfSubmitterQuestions: number }, needsIdentificationScore: { __typename?: 'NeedsIdentificationScore', identificationScore: number, needCaptured: boolean, needExpressed: boolean, problemClarity: number }, nonVerbalSkillScore: { __typename?: 'NonVerbalSkillScore', confidence: number, listening: number, patience: number, pauseDuration: number }, openEndedQuestions: Array<{ __typename?: 'OpenEndedQuestion', question: string, speaker: string, startTime: number }>, speakerLabels?: Array<{ __typename?: 'SpeakerLabel', speakerId?: string | null, speakerLabel?: string | null, speakerName?: string | null, speakerRole?: string | null, speakerRoleDisplayed?: string | null, talkRatio?: number | null, isPresenter?: boolean | null }> | null, stackedQuestions: Array<{ __typename?: 'StackedQuestion', questions: Array<string>, speaker: string, startTime: number }> } | null, articulation?: { __typename?: 'Articulation', fillerWords?: Array<string> | null, fillerWordsCount?: number | null, keywordScore?: number | null, mediaLength?: number | null, overallScore?: number | null, wordsPerMinute?: number | null } | null, contentScore?: { __typename?: 'ContentScore', consistency: number, coherence: number, grammar: number, toneNstyle: number } | null, keywordCheck?: { __typename?: 'AutoEvaluationKeywordCheck', allowedKeywordsMatched?: Array<string> | null, allowedKeywordsNotMatched?: Array<string> | null, incorrectKeywordsMatched?: Array<string> | null, incorrectKeywordsNotMatched?: Array<string> | null, allowedKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, allowedKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null, incorrectKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, incorrectKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null } | null } | null, reviewerCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } | null, mentions?: { __typename?: 'MentionConnection', nodes: Array<{ __typename?: 'CompanyProfile', id: any, externalId: string, emailAddress?: string | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, preferredName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }> } | null, formTransactional?: { __typename?: 'FormTransactional', id: any, prompts: { __typename?: 'PromptTransactionalConnection', nodes: Array<{ __typename?: 'PromptTransactional', id: any, choices?: { __typename?: 'ChoiceTransactionalConnection', nodes: Array<{ __typename?: 'ChoiceTransactional', id: any, isSelected?: boolean | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, description?: string | null } | null }> } | null }> } } | null }> } }> }, companyProfileSkill: { __typename?: 'CompanyProfileSkill', id: string, assignmentSkill?: { __typename?: 'AssignmentSkill', id: any, learningPlan: { __typename?: 'LearningPlan', name: string, learningPlanFolderId?: any | null, learningPlanLocalized: { __typename?: 'LearningPlanLocalized', description?: string | null, learningPlanFolderName?: string | null } } } | null } };

export type _RepAssignmentSummaryFragment = { __typename?: 'RepAssignment', id: any, repSubmissionCount: number, repAssignmentStatus: RepAssignmentStatus, createdAt: any, learnerCompanyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }, assignorCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } | null, skill: { __typename?: 'Skill', id: any, externalId: string, name: string, updatedAt: any, repPoints?: number | null, freestylePoints?: number | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', language: Language, description: string } | null }, repPrompt?: { __typename?: 'RepPrompt', id: any, allResponseTypeEnabled: boolean, isCoached: boolean, repPromptLocalized: { __typename?: 'RepPromptLocalized', id: any, language: Language, promptType: RepResponseKind, title?: string | null, content: string, caption?: string | null }, repPromptResponseTypes: { __typename?: 'RepPromptResponseTypeConnection', nodes: Array<{ __typename?: 'RepPromptResponseType', responseType?: RepResponseKind | null }> } } | null };

export type _RepPromptLocalizedFragment = { __typename?: 'RepPromptLocalized', id: any, language: Language, promptType: RepResponseKind, title?: string | null, content: string, caption?: string | null };

export type _RepSkillFragment = { __typename?: 'Skill', id: any, externalId: string, name: string, updatedAt: any, repPoints?: number | null, freestylePoints?: number | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', language: Language, description: string } | null };

export type _RepSubmissionFeedbackFragment = { __typename?: 'RepSubmissionFeedback', id: any, createdAt?: any | null, feedbackType: RepFeedbackType, responseType: RepResponseKind, content?: string | null, caption?: string | null, reviewerRole: ReviewerRoleType, previewUrl?: string | null, mediaUrl?: string | null, rawMediaUrl?: string | null, autoEvaluationOutcome?: { __typename?: 'AutoEvaluationOutcome', isArticulationPass?: boolean | null, isKeywordPass?: boolean | null, sentiment?: number | null, conversationMetrics?: { __typename?: 'ConversationMetrics', conversationType: string, noOfSubmitterQuestions?: number | null, overallFeedback?: string | null, questionRate: number, thresholds: { __typename?: 'ConversationMetricsThresholds', stackedQuestionsCount: number, talkRatio: number, questionRate: number, pauseDuration: Array<number>, noOfSubmitterQuestions: number }, needsIdentificationScore: { __typename?: 'NeedsIdentificationScore', identificationScore: number, needCaptured: boolean, needExpressed: boolean, problemClarity: number }, nonVerbalSkillScore: { __typename?: 'NonVerbalSkillScore', confidence: number, listening: number, patience: number, pauseDuration: number }, openEndedQuestions: Array<{ __typename?: 'OpenEndedQuestion', question: string, speaker: string, startTime: number }>, speakerLabels?: Array<{ __typename?: 'SpeakerLabel', speakerId?: string | null, speakerLabel?: string | null, speakerName?: string | null, speakerRole?: string | null, speakerRoleDisplayed?: string | null, talkRatio?: number | null, isPresenter?: boolean | null }> | null, stackedQuestions: Array<{ __typename?: 'StackedQuestion', questions: Array<string>, speaker: string, startTime: number }> } | null, articulation?: { __typename?: 'Articulation', fillerWords?: Array<string> | null, fillerWordsCount?: number | null, keywordScore?: number | null, mediaLength?: number | null, overallScore?: number | null, wordsPerMinute?: number | null } | null, contentScore?: { __typename?: 'ContentScore', consistency: number, coherence: number, grammar: number, toneNstyle: number } | null, keywordCheck?: { __typename?: 'AutoEvaluationKeywordCheck', allowedKeywordsMatched?: Array<string> | null, allowedKeywordsNotMatched?: Array<string> | null, incorrectKeywordsMatched?: Array<string> | null, incorrectKeywordsNotMatched?: Array<string> | null, allowedKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, allowedKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null, incorrectKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, incorrectKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null } | null } | null, reviewerCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } | null, mentions?: { __typename?: 'MentionConnection', nodes: Array<{ __typename?: 'CompanyProfile', id: any, externalId: string, emailAddress?: string | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, preferredName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }> } | null, formTransactional?: { __typename?: 'FormTransactional', id: any, prompts: { __typename?: 'PromptTransactionalConnection', nodes: Array<{ __typename?: 'PromptTransactional', id: any, choices?: { __typename?: 'ChoiceTransactionalConnection', nodes: Array<{ __typename?: 'ChoiceTransactional', id: any, isSelected?: boolean | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, description?: string | null } | null }> } | null }> } } | null };

export type _RepSubmissionFragment = { __typename?: 'RepSubmission', id: any, repAssignmentId?: any | null, title?: string | null, content: string, caption?: string | null, responseType: RepResponseKind, createdAt?: any | null, aiReviewStatus?: ReviewStatus | null, coachReviewStatus?: ReviewStatus | null, error?: { __typename?: 'ErrorMsg', error?: string | null, statusCode?: string | null } | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, streamMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, transcriptionMedia?: { __typename?: 'Media', id: any, status: MediaStatus, error?: string | null } | null, reactions: { __typename?: 'ReactionsConnection', nodes: Array<{ __typename?: 'Reaction', id: any, type: ReactionType, companyProfileId: any }> }, repSubmissionFeedbacks: { __typename?: 'RepSubmissionFeedbackConnection', nodes: Array<{ __typename?: 'RepSubmissionFeedback', id: any, createdAt?: any | null, feedbackType: RepFeedbackType, responseType: RepResponseKind, content?: string | null, caption?: string | null, reviewerRole: ReviewerRoleType, previewUrl?: string | null, mediaUrl?: string | null, rawMediaUrl?: string | null, autoEvaluationOutcome?: { __typename?: 'AutoEvaluationOutcome', isArticulationPass?: boolean | null, isKeywordPass?: boolean | null, sentiment?: number | null, conversationMetrics?: { __typename?: 'ConversationMetrics', conversationType: string, noOfSubmitterQuestions?: number | null, overallFeedback?: string | null, questionRate: number, thresholds: { __typename?: 'ConversationMetricsThresholds', stackedQuestionsCount: number, talkRatio: number, questionRate: number, pauseDuration: Array<number>, noOfSubmitterQuestions: number }, needsIdentificationScore: { __typename?: 'NeedsIdentificationScore', identificationScore: number, needCaptured: boolean, needExpressed: boolean, problemClarity: number }, nonVerbalSkillScore: { __typename?: 'NonVerbalSkillScore', confidence: number, listening: number, patience: number, pauseDuration: number }, openEndedQuestions: Array<{ __typename?: 'OpenEndedQuestion', question: string, speaker: string, startTime: number }>, speakerLabels?: Array<{ __typename?: 'SpeakerLabel', speakerId?: string | null, speakerLabel?: string | null, speakerName?: string | null, speakerRole?: string | null, speakerRoleDisplayed?: string | null, talkRatio?: number | null, isPresenter?: boolean | null }> | null, stackedQuestions: Array<{ __typename?: 'StackedQuestion', questions: Array<string>, speaker: string, startTime: number }> } | null, articulation?: { __typename?: 'Articulation', fillerWords?: Array<string> | null, fillerWordsCount?: number | null, keywordScore?: number | null, mediaLength?: number | null, overallScore?: number | null, wordsPerMinute?: number | null } | null, contentScore?: { __typename?: 'ContentScore', consistency: number, coherence: number, grammar: number, toneNstyle: number } | null, keywordCheck?: { __typename?: 'AutoEvaluationKeywordCheck', allowedKeywordsMatched?: Array<string> | null, allowedKeywordsNotMatched?: Array<string> | null, incorrectKeywordsMatched?: Array<string> | null, incorrectKeywordsNotMatched?: Array<string> | null, allowedKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, allowedKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null, incorrectKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, incorrectKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null } | null } | null, reviewerCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } | null, mentions?: { __typename?: 'MentionConnection', nodes: Array<{ __typename?: 'CompanyProfile', id: any, externalId: string, emailAddress?: string | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, preferredName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }> } | null, formTransactional?: { __typename?: 'FormTransactional', id: any, prompts: { __typename?: 'PromptTransactionalConnection', nodes: Array<{ __typename?: 'PromptTransactional', id: any, choices?: { __typename?: 'ChoiceTransactionalConnection', nodes: Array<{ __typename?: 'ChoiceTransactional', id: any, isSelected?: boolean | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, description?: string | null } | null }> } | null }> } } | null }> } };

export type RepUserFragment = { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } };

export type SkillFragment = { __typename?: 'Skill', id: any, name: string, externalId: string, type: SkillType, duration?: string | null, repType?: RepType | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null, thumbnailUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', description: string } | null };

export type SocialRepAssignmentFragment = { __typename?: 'RepAssignment', id: any, repAssignmentStatus: RepAssignmentStatus, points: number, lastActivityAt?: any | null, createdAt: any, learnerCompanyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }, skill: { __typename?: 'Skill', id: any, externalId: string, name: string, updatedAt: any, repPoints?: number | null, freestylePoints?: number | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', language: Language, description: string } | null }, repPrompt?: { __typename?: 'RepPrompt', id: any, repPromptLocalized: { __typename?: 'RepPromptLocalized', id: any, language: Language, promptType: RepResponseKind, title?: string | null, content: string, caption?: string | null } } | null, repSubmissions: { __typename?: 'RepSubmissionConnection', nodes: Array<{ __typename?: 'RepSubmission', id: any, title?: string | null, content: string, responseType: RepResponseKind, coachReviewStatus?: ReviewStatus | null, error?: { __typename?: 'ErrorMsg', error?: string | null, statusCode?: string | null } | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> } };

export type TopicFragment = { __typename?: 'Topic', id: any, name: string, skillCount: number, repCount: number, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null, thumbnailUrl?: string | null } | null, topicLocalized?: { __typename?: 'TopicLocalized', id: any, description: string, language: Language } | null };

export type WorkspaceFragment = { __typename?: 'Workspace', id: string, externalId: string, companyId: string, companyName: string, companyExternalId: string, companyInternalName: string, companyLogo?: string | null };

export type CoachRepAssignmentQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CoachRepAssignmentQuery = { __typename?: 'Query', coachRepAssignment?: { __typename?: 'RepAssignment', id: any, repSubmissionCount: number, repAssignmentStatus: RepAssignmentStatus, points: number, lastActivityAt?: any | null, createdAt: any, learnerCompanyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }, assignorCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } | null, skill: { __typename?: 'Skill', id: any, externalId: string, name: string, updatedAt: any, repPoints?: number | null, freestylePoints?: number | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', language: Language, description: string } | null }, repPrompt?: { __typename?: 'RepPrompt', id: any, selfPracticeEnabled: boolean, keywordAnalysisEnabled: boolean, allResponseTypeEnabled: boolean, isCoached: boolean, repType: RepType, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteria', keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', incorrectKeywords?: Array<string> | null, allowedKeywords?: Array<string> | null } | null } | null, interjectionsHandling?: { __typename?: 'InterjectionsHandling', interjections?: Array<{ __typename?: 'Interjection', index?: string | null, start?: string | null, duration?: string | null, author?: string | null, message?: Array<{ __typename?: 'InterjectionMessage', translatedText?: string | null, language: Language }> | null }> | null } | null, formConfig?: { __typename?: 'Form', id: any, type: FormType, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, isRubric: boolean, isMultiple: boolean, promptLocalized?: { __typename?: 'PromptLocalized', id: any, description: string } | null, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, isCorrect?: boolean | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, description?: string | null } | null }> } }> } } | null, repPromptLocalized: { __typename?: 'RepPromptLocalized', id: any, language: Language, promptType: RepResponseKind, title?: string | null, content: string, caption?: string | null }, repPromptResponseTypes: { __typename?: 'RepPromptResponseTypeConnection', nodes: Array<{ __typename?: 'RepPromptResponseType', responseType?: RepResponseKind | null }> } } | null, repSubmissions: { __typename?: 'RepSubmissionConnection', nodes: Array<{ __typename?: 'RepSubmission', id: any, repAssignmentId?: any | null, title?: string | null, content: string, caption?: string | null, responseType: RepResponseKind, createdAt?: any | null, aiReviewStatus?: ReviewStatus | null, coachReviewStatus?: ReviewStatus | null, error?: { __typename?: 'ErrorMsg', error?: string | null, statusCode?: string | null } | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, streamMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, transcriptionMedia?: { __typename?: 'Media', id: any, status: MediaStatus, error?: string | null } | null, reactions: { __typename?: 'ReactionsConnection', nodes: Array<{ __typename?: 'Reaction', id: any, type: ReactionType, companyProfileId: any }> }, repSubmissionFeedbacks: { __typename?: 'RepSubmissionFeedbackConnection', nodes: Array<{ __typename?: 'RepSubmissionFeedback', id: any, createdAt?: any | null, feedbackType: RepFeedbackType, responseType: RepResponseKind, content?: string | null, caption?: string | null, reviewerRole: ReviewerRoleType, previewUrl?: string | null, mediaUrl?: string | null, rawMediaUrl?: string | null, autoEvaluationOutcome?: { __typename?: 'AutoEvaluationOutcome', isArticulationPass?: boolean | null, isKeywordPass?: boolean | null, sentiment?: number | null, conversationMetrics?: { __typename?: 'ConversationMetrics', conversationType: string, noOfSubmitterQuestions?: number | null, overallFeedback?: string | null, questionRate: number, thresholds: { __typename?: 'ConversationMetricsThresholds', stackedQuestionsCount: number, talkRatio: number, questionRate: number, pauseDuration: Array<number>, noOfSubmitterQuestions: number }, needsIdentificationScore: { __typename?: 'NeedsIdentificationScore', identificationScore: number, needCaptured: boolean, needExpressed: boolean, problemClarity: number }, nonVerbalSkillScore: { __typename?: 'NonVerbalSkillScore', confidence: number, listening: number, patience: number, pauseDuration: number }, openEndedQuestions: Array<{ __typename?: 'OpenEndedQuestion', question: string, speaker: string, startTime: number }>, speakerLabels?: Array<{ __typename?: 'SpeakerLabel', speakerId?: string | null, speakerLabel?: string | null, speakerName?: string | null, speakerRole?: string | null, speakerRoleDisplayed?: string | null, talkRatio?: number | null, isPresenter?: boolean | null }> | null, stackedQuestions: Array<{ __typename?: 'StackedQuestion', questions: Array<string>, speaker: string, startTime: number }> } | null, articulation?: { __typename?: 'Articulation', fillerWords?: Array<string> | null, fillerWordsCount?: number | null, keywordScore?: number | null, mediaLength?: number | null, overallScore?: number | null, wordsPerMinute?: number | null } | null, contentScore?: { __typename?: 'ContentScore', consistency: number, coherence: number, grammar: number, toneNstyle: number } | null, keywordCheck?: { __typename?: 'AutoEvaluationKeywordCheck', allowedKeywordsMatched?: Array<string> | null, allowedKeywordsNotMatched?: Array<string> | null, incorrectKeywordsMatched?: Array<string> | null, incorrectKeywordsNotMatched?: Array<string> | null, allowedKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, allowedKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null, incorrectKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, incorrectKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null } | null } | null, reviewerCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } | null, mentions?: { __typename?: 'MentionConnection', nodes: Array<{ __typename?: 'CompanyProfile', id: any, externalId: string, emailAddress?: string | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, preferredName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }> } | null, formTransactional?: { __typename?: 'FormTransactional', id: any, prompts: { __typename?: 'PromptTransactionalConnection', nodes: Array<{ __typename?: 'PromptTransactional', id: any, choices?: { __typename?: 'ChoiceTransactionalConnection', nodes: Array<{ __typename?: 'ChoiceTransactional', id: any, isSelected?: boolean | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, description?: string | null } | null }> } | null }> } } | null }> } }> }, companyProfileSkill: { __typename?: 'CompanyProfileSkill', id: string, assignmentSkill?: { __typename?: 'AssignmentSkill', id: any, learningPlan: { __typename?: 'LearningPlan', name: string, learningPlanFolderId?: any | null, learningPlanLocalized: { __typename?: 'LearningPlanLocalized', description?: string | null, learningPlanFolderName?: string | null } } } | null } } | null };

export type CoachRepAssignmentsQueryVariables = Exact<{
  paginate?: InputMaybe<BaseClassicPaginate>;
  sorts?: InputMaybe<Array<RepAssignmentSort> | RepAssignmentSort>;
  conditions?: InputMaybe<RepAssignmentConditions>;
}>;


export type CoachRepAssignmentsQuery = { __typename?: 'Query', coachRepAssignments: { __typename?: 'PaginatedRepAssignmentResponse', totalCount?: number | null, pageInfo: { __typename?: 'RepAssignmentPageInfo', afterCursor?: string | null, beforeCursor?: string | null }, nodes: Array<{ __typename?: 'RepAssignment', id: any, companyProfileId: any, repAssignmentStatus: RepAssignmentStatus, lastActivityAt?: any | null, points: number, learnerCompanyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }, skill: { __typename?: 'Skill', id: any, name: string, externalId: string, type: SkillType, duration?: string | null, repType?: RepType | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null, thumbnailUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', description: string } | null }, repPrompt?: { __typename?: 'RepPrompt', id: any, repPromptLocalized: { __typename?: 'RepPromptLocalized', id: any, content: string, language: Language } } | null, repSubmissions: { __typename?: 'RepSubmissionConnection', nodes: Array<{ __typename?: 'RepSubmission', id: any, title?: string | null, caption?: string | null, repAssignmentId?: any | null, content: string, responseType: RepResponseKind, createdAt?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> } }> } };

export type RepAssignmentQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RepAssignmentQuery = { __typename?: 'Query', repAssignment?: { __typename?: 'RepAssignment', id: any, repSubmissionCount: number, repAssignmentStatus: RepAssignmentStatus, points: number, lastActivityAt?: any | null, createdAt: any, learnerCompanyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }, assignorCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } | null, skill: { __typename?: 'Skill', id: any, externalId: string, name: string, updatedAt: any, repPoints?: number | null, freestylePoints?: number | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', language: Language, description: string } | null }, repPrompt?: { __typename?: 'RepPrompt', id: any, selfPracticeEnabled: boolean, keywordAnalysisEnabled: boolean, allResponseTypeEnabled: boolean, isCoached: boolean, repType: RepType, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteria', keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', incorrectKeywords?: Array<string> | null, allowedKeywords?: Array<string> | null } | null } | null, interjectionsHandling?: { __typename?: 'InterjectionsHandling', interjections?: Array<{ __typename?: 'Interjection', index?: string | null, start?: string | null, duration?: string | null, author?: string | null, message?: Array<{ __typename?: 'InterjectionMessage', translatedText?: string | null, language: Language }> | null }> | null } | null, formConfig?: { __typename?: 'Form', id: any, type: FormType, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, isRubric: boolean, isMultiple: boolean, promptLocalized?: { __typename?: 'PromptLocalized', id: any, description: string } | null, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, isCorrect?: boolean | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, description?: string | null } | null }> } }> } } | null, repPromptLocalized: { __typename?: 'RepPromptLocalized', id: any, language: Language, promptType: RepResponseKind, title?: string | null, content: string, caption?: string | null }, repPromptResponseTypes: { __typename?: 'RepPromptResponseTypeConnection', nodes: Array<{ __typename?: 'RepPromptResponseType', responseType?: RepResponseKind | null }> } } | null, repSubmissions: { __typename?: 'RepSubmissionConnection', nodes: Array<{ __typename?: 'RepSubmission', id: any, repAssignmentId?: any | null, title?: string | null, content: string, caption?: string | null, responseType: RepResponseKind, createdAt?: any | null, aiReviewStatus?: ReviewStatus | null, coachReviewStatus?: ReviewStatus | null, error?: { __typename?: 'ErrorMsg', error?: string | null, statusCode?: string | null } | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, streamMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, transcriptionMedia?: { __typename?: 'Media', id: any, status: MediaStatus, error?: string | null } | null, reactions: { __typename?: 'ReactionsConnection', nodes: Array<{ __typename?: 'Reaction', id: any, type: ReactionType, companyProfileId: any }> }, repSubmissionFeedbacks: { __typename?: 'RepSubmissionFeedbackConnection', nodes: Array<{ __typename?: 'RepSubmissionFeedback', id: any, createdAt?: any | null, feedbackType: RepFeedbackType, responseType: RepResponseKind, content?: string | null, caption?: string | null, reviewerRole: ReviewerRoleType, previewUrl?: string | null, mediaUrl?: string | null, rawMediaUrl?: string | null, autoEvaluationOutcome?: { __typename?: 'AutoEvaluationOutcome', isArticulationPass?: boolean | null, isKeywordPass?: boolean | null, sentiment?: number | null, conversationMetrics?: { __typename?: 'ConversationMetrics', conversationType: string, noOfSubmitterQuestions?: number | null, overallFeedback?: string | null, questionRate: number, thresholds: { __typename?: 'ConversationMetricsThresholds', stackedQuestionsCount: number, talkRatio: number, questionRate: number, pauseDuration: Array<number>, noOfSubmitterQuestions: number }, needsIdentificationScore: { __typename?: 'NeedsIdentificationScore', identificationScore: number, needCaptured: boolean, needExpressed: boolean, problemClarity: number }, nonVerbalSkillScore: { __typename?: 'NonVerbalSkillScore', confidence: number, listening: number, patience: number, pauseDuration: number }, openEndedQuestions: Array<{ __typename?: 'OpenEndedQuestion', question: string, speaker: string, startTime: number }>, speakerLabels?: Array<{ __typename?: 'SpeakerLabel', speakerId?: string | null, speakerLabel?: string | null, speakerName?: string | null, speakerRole?: string | null, speakerRoleDisplayed?: string | null, talkRatio?: number | null, isPresenter?: boolean | null }> | null, stackedQuestions: Array<{ __typename?: 'StackedQuestion', questions: Array<string>, speaker: string, startTime: number }> } | null, articulation?: { __typename?: 'Articulation', fillerWords?: Array<string> | null, fillerWordsCount?: number | null, keywordScore?: number | null, mediaLength?: number | null, overallScore?: number | null, wordsPerMinute?: number | null } | null, contentScore?: { __typename?: 'ContentScore', consistency: number, coherence: number, grammar: number, toneNstyle: number } | null, keywordCheck?: { __typename?: 'AutoEvaluationKeywordCheck', allowedKeywordsMatched?: Array<string> | null, allowedKeywordsNotMatched?: Array<string> | null, incorrectKeywordsMatched?: Array<string> | null, incorrectKeywordsNotMatched?: Array<string> | null, allowedKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, allowedKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null, incorrectKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, incorrectKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null } | null } | null, reviewerCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } | null, mentions?: { __typename?: 'MentionConnection', nodes: Array<{ __typename?: 'CompanyProfile', id: any, externalId: string, emailAddress?: string | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, preferredName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }> } | null, formTransactional?: { __typename?: 'FormTransactional', id: any, prompts: { __typename?: 'PromptTransactionalConnection', nodes: Array<{ __typename?: 'PromptTransactional', id: any, choices?: { __typename?: 'ChoiceTransactionalConnection', nodes: Array<{ __typename?: 'ChoiceTransactional', id: any, isSelected?: boolean | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, description?: string | null } | null }> } | null }> } } | null }> } }> }, companyProfileSkill: { __typename?: 'CompanyProfileSkill', id: string, assignmentSkill?: { __typename?: 'AssignmentSkill', id: any, learningPlan: { __typename?: 'LearningPlan', name: string, learningPlanFolderId?: any | null, learningPlanLocalized: { __typename?: 'LearningPlanLocalized', description?: string | null, learningPlanFolderName?: string | null } } } | null } } | null };

export type RepAssignmentSummariesQueryVariables = Exact<{
  statuses?: InputMaybe<Array<RepAssignmentStatus> | RepAssignmentStatus>;
  limit: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<Array<RepAssignmentSort> | RepAssignmentSort>;
}>;


export type RepAssignmentSummariesQuery = { __typename?: 'Query', repAssignments: { __typename?: 'PaginatedRepAssignmentResponse', totalCount?: number | null, pageInfo: { __typename?: 'RepAssignmentPageInfo', afterCursor?: string | null, beforeCursor?: string | null }, nodes: Array<{ __typename?: 'RepAssignment', id: any, repSubmissionCount: number, repAssignmentStatus: RepAssignmentStatus, createdAt: any, learnerCompanyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }, assignorCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } | null, skill: { __typename?: 'Skill', id: any, externalId: string, name: string, updatedAt: any, repPoints?: number | null, freestylePoints?: number | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', language: Language, description: string } | null }, repPrompt?: { __typename?: 'RepPrompt', id: any, allResponseTypeEnabled: boolean, isCoached: boolean, repPromptLocalized: { __typename?: 'RepPromptLocalized', id: any, language: Language, promptType: RepResponseKind, title?: string | null, content: string, caption?: string | null }, repPromptResponseTypes: { __typename?: 'RepPromptResponseTypeConnection', nodes: Array<{ __typename?: 'RepPromptResponseType', responseType?: RepResponseKind | null }> } } | null }> } };

export type RepAssignmentsQueryVariables = Exact<{
  statuses?: InputMaybe<Array<RepAssignmentStatus> | RepAssignmentStatus>;
  limit: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<Array<RepAssignmentSort> | RepAssignmentSort>;
}>;


export type RepAssignmentsQuery = { __typename?: 'Query', repAssignments: { __typename?: 'PaginatedRepAssignmentResponse', totalCount?: number | null, pageInfo: { __typename?: 'RepAssignmentPageInfo', afterCursor?: string | null, beforeCursor?: string | null }, nodes: Array<{ __typename?: 'RepAssignment', id: any, repSubmissionCount: number, repAssignmentStatus: RepAssignmentStatus, points: number, lastActivityAt?: any | null, createdAt: any, learnerCompanyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }, assignorCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } | null, skill: { __typename?: 'Skill', id: any, externalId: string, name: string, updatedAt: any, repPoints?: number | null, freestylePoints?: number | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', language: Language, description: string } | null }, repPrompt?: { __typename?: 'RepPrompt', id: any, selfPracticeEnabled: boolean, keywordAnalysisEnabled: boolean, allResponseTypeEnabled: boolean, isCoached: boolean, repType: RepType, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteria', keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', incorrectKeywords?: Array<string> | null, allowedKeywords?: Array<string> | null } | null } | null, interjectionsHandling?: { __typename?: 'InterjectionsHandling', interjections?: Array<{ __typename?: 'Interjection', index?: string | null, start?: string | null, duration?: string | null, author?: string | null, message?: Array<{ __typename?: 'InterjectionMessage', translatedText?: string | null, language: Language }> | null }> | null } | null, formConfig?: { __typename?: 'Form', id: any, type: FormType, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, isRubric: boolean, isMultiple: boolean, promptLocalized?: { __typename?: 'PromptLocalized', id: any, description: string } | null, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, isCorrect?: boolean | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, description?: string | null } | null }> } }> } } | null, repPromptLocalized: { __typename?: 'RepPromptLocalized', id: any, language: Language, promptType: RepResponseKind, title?: string | null, content: string, caption?: string | null }, repPromptResponseTypes: { __typename?: 'RepPromptResponseTypeConnection', nodes: Array<{ __typename?: 'RepPromptResponseType', responseType?: RepResponseKind | null }> } } | null, repSubmissions: { __typename?: 'RepSubmissionConnection', nodes: Array<{ __typename?: 'RepSubmission', id: any, repAssignmentId?: any | null, title?: string | null, content: string, caption?: string | null, responseType: RepResponseKind, createdAt?: any | null, aiReviewStatus?: ReviewStatus | null, coachReviewStatus?: ReviewStatus | null, error?: { __typename?: 'ErrorMsg', error?: string | null, statusCode?: string | null } | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, streamMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, transcriptionMedia?: { __typename?: 'Media', id: any, status: MediaStatus, error?: string | null } | null, reactions: { __typename?: 'ReactionsConnection', nodes: Array<{ __typename?: 'Reaction', id: any, type: ReactionType, companyProfileId: any }> }, repSubmissionFeedbacks: { __typename?: 'RepSubmissionFeedbackConnection', nodes: Array<{ __typename?: 'RepSubmissionFeedback', id: any, createdAt?: any | null, feedbackType: RepFeedbackType, responseType: RepResponseKind, content?: string | null, caption?: string | null, reviewerRole: ReviewerRoleType, previewUrl?: string | null, mediaUrl?: string | null, rawMediaUrl?: string | null, autoEvaluationOutcome?: { __typename?: 'AutoEvaluationOutcome', isArticulationPass?: boolean | null, isKeywordPass?: boolean | null, sentiment?: number | null, conversationMetrics?: { __typename?: 'ConversationMetrics', conversationType: string, noOfSubmitterQuestions?: number | null, overallFeedback?: string | null, questionRate: number, thresholds: { __typename?: 'ConversationMetricsThresholds', stackedQuestionsCount: number, talkRatio: number, questionRate: number, pauseDuration: Array<number>, noOfSubmitterQuestions: number }, needsIdentificationScore: { __typename?: 'NeedsIdentificationScore', identificationScore: number, needCaptured: boolean, needExpressed: boolean, problemClarity: number }, nonVerbalSkillScore: { __typename?: 'NonVerbalSkillScore', confidence: number, listening: number, patience: number, pauseDuration: number }, openEndedQuestions: Array<{ __typename?: 'OpenEndedQuestion', question: string, speaker: string, startTime: number }>, speakerLabels?: Array<{ __typename?: 'SpeakerLabel', speakerId?: string | null, speakerLabel?: string | null, speakerName?: string | null, speakerRole?: string | null, speakerRoleDisplayed?: string | null, talkRatio?: number | null, isPresenter?: boolean | null }> | null, stackedQuestions: Array<{ __typename?: 'StackedQuestion', questions: Array<string>, speaker: string, startTime: number }> } | null, articulation?: { __typename?: 'Articulation', fillerWords?: Array<string> | null, fillerWordsCount?: number | null, keywordScore?: number | null, mediaLength?: number | null, overallScore?: number | null, wordsPerMinute?: number | null } | null, contentScore?: { __typename?: 'ContentScore', consistency: number, coherence: number, grammar: number, toneNstyle: number } | null, keywordCheck?: { __typename?: 'AutoEvaluationKeywordCheck', allowedKeywordsMatched?: Array<string> | null, allowedKeywordsNotMatched?: Array<string> | null, incorrectKeywordsMatched?: Array<string> | null, incorrectKeywordsNotMatched?: Array<string> | null, allowedKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, allowedKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null, incorrectKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, incorrectKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null } | null } | null, reviewerCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } | null, mentions?: { __typename?: 'MentionConnection', nodes: Array<{ __typename?: 'CompanyProfile', id: any, externalId: string, emailAddress?: string | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, preferredName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }> } | null, formTransactional?: { __typename?: 'FormTransactional', id: any, prompts: { __typename?: 'PromptTransactionalConnection', nodes: Array<{ __typename?: 'PromptTransactional', id: any, choices?: { __typename?: 'ChoiceTransactionalConnection', nodes: Array<{ __typename?: 'ChoiceTransactional', id: any, isSelected?: boolean | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, description?: string | null } | null }> } | null }> } } | null }> } }> }, companyProfileSkill: { __typename?: 'CompanyProfileSkill', id: string, assignmentSkill?: { __typename?: 'AssignmentSkill', id: any, learningPlan: { __typename?: 'LearningPlan', name: string, learningPlanFolderId?: any | null, learningPlanLocalized: { __typename?: 'LearningPlanLocalized', description?: string | null, learningPlanFolderName?: string | null } } } | null } }> } };

export type RepSubmissionCreateV2MutationVariables = Exact<{
  repAssignmentId: Scalars['UUID']['input'];
  responseType: Scalars['String']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  masterMediaId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type RepSubmissionCreateV2Mutation = { __typename?: 'Mutation', repSubmissionCreateV2: { __typename?: 'RepSubmission', id: any, repAssignmentId?: any | null, title?: string | null, content: string, caption?: string | null, responseType: RepResponseKind, createdAt?: any | null, aiReviewStatus?: ReviewStatus | null, coachReviewStatus?: ReviewStatus | null, error?: { __typename?: 'ErrorMsg', error?: string | null, statusCode?: string | null } | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, streamMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, transcriptionMedia?: { __typename?: 'Media', id: any, status: MediaStatus, error?: string | null } | null, reactions: { __typename?: 'ReactionsConnection', nodes: Array<{ __typename?: 'Reaction', id: any, type: ReactionType, companyProfileId: any }> }, repSubmissionFeedbacks: { __typename?: 'RepSubmissionFeedbackConnection', nodes: Array<{ __typename?: 'RepSubmissionFeedback', id: any, createdAt?: any | null, feedbackType: RepFeedbackType, responseType: RepResponseKind, content?: string | null, caption?: string | null, reviewerRole: ReviewerRoleType, previewUrl?: string | null, mediaUrl?: string | null, rawMediaUrl?: string | null, autoEvaluationOutcome?: { __typename?: 'AutoEvaluationOutcome', isArticulationPass?: boolean | null, isKeywordPass?: boolean | null, sentiment?: number | null, conversationMetrics?: { __typename?: 'ConversationMetrics', conversationType: string, noOfSubmitterQuestions?: number | null, overallFeedback?: string | null, questionRate: number, thresholds: { __typename?: 'ConversationMetricsThresholds', stackedQuestionsCount: number, talkRatio: number, questionRate: number, pauseDuration: Array<number>, noOfSubmitterQuestions: number }, needsIdentificationScore: { __typename?: 'NeedsIdentificationScore', identificationScore: number, needCaptured: boolean, needExpressed: boolean, problemClarity: number }, nonVerbalSkillScore: { __typename?: 'NonVerbalSkillScore', confidence: number, listening: number, patience: number, pauseDuration: number }, openEndedQuestions: Array<{ __typename?: 'OpenEndedQuestion', question: string, speaker: string, startTime: number }>, speakerLabels?: Array<{ __typename?: 'SpeakerLabel', speakerId?: string | null, speakerLabel?: string | null, speakerName?: string | null, speakerRole?: string | null, speakerRoleDisplayed?: string | null, talkRatio?: number | null, isPresenter?: boolean | null }> | null, stackedQuestions: Array<{ __typename?: 'StackedQuestion', questions: Array<string>, speaker: string, startTime: number }> } | null, articulation?: { __typename?: 'Articulation', fillerWords?: Array<string> | null, fillerWordsCount?: number | null, keywordScore?: number | null, mediaLength?: number | null, overallScore?: number | null, wordsPerMinute?: number | null } | null, contentScore?: { __typename?: 'ContentScore', consistency: number, coherence: number, grammar: number, toneNstyle: number } | null, keywordCheck?: { __typename?: 'AutoEvaluationKeywordCheck', allowedKeywordsMatched?: Array<string> | null, allowedKeywordsNotMatched?: Array<string> | null, incorrectKeywordsMatched?: Array<string> | null, incorrectKeywordsNotMatched?: Array<string> | null, allowedKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, allowedKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null, incorrectKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, incorrectKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null } | null } | null, reviewerCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } | null, mentions?: { __typename?: 'MentionConnection', nodes: Array<{ __typename?: 'CompanyProfile', id: any, externalId: string, emailAddress?: string | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, preferredName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }> } | null, formTransactional?: { __typename?: 'FormTransactional', id: any, prompts: { __typename?: 'PromptTransactionalConnection', nodes: Array<{ __typename?: 'PromptTransactional', id: any, choices?: { __typename?: 'ChoiceTransactionalConnection', nodes: Array<{ __typename?: 'ChoiceTransactional', id: any, isSelected?: boolean | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, description?: string | null } | null }> } | null }> } } | null }> } } };

export type RepSubmissionFeedbackCreateMutationVariables = Exact<{
  repSubmissionId: Scalars['UUID']['input'];
  responseType: RepResponseKind;
  reviewerRole: Scalars['String']['input'];
  feedbackType: RepFeedbackType;
  content: Scalars['String']['input'];
  tempContentWithoutTags?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  mentions?: InputMaybe<Array<Mention> | Mention>;
  rubricForm?: InputMaybe<RubricFormV1>;
}>;


export type RepSubmissionFeedbackCreateMutation = { __typename?: 'Mutation', repSubmissionFeedbackCreate: { __typename?: 'RepSubmissionFeedback', id: any, createdAt?: any | null, feedbackType: RepFeedbackType, responseType: RepResponseKind, content?: string | null, caption?: string | null, reviewerRole: ReviewerRoleType, previewUrl?: string | null, mediaUrl?: string | null, rawMediaUrl?: string | null, autoEvaluationOutcome?: { __typename?: 'AutoEvaluationOutcome', isArticulationPass?: boolean | null, isKeywordPass?: boolean | null, sentiment?: number | null, conversationMetrics?: { __typename?: 'ConversationMetrics', conversationType: string, noOfSubmitterQuestions?: number | null, overallFeedback?: string | null, questionRate: number, thresholds: { __typename?: 'ConversationMetricsThresholds', stackedQuestionsCount: number, talkRatio: number, questionRate: number, pauseDuration: Array<number>, noOfSubmitterQuestions: number }, needsIdentificationScore: { __typename?: 'NeedsIdentificationScore', identificationScore: number, needCaptured: boolean, needExpressed: boolean, problemClarity: number }, nonVerbalSkillScore: { __typename?: 'NonVerbalSkillScore', confidence: number, listening: number, patience: number, pauseDuration: number }, openEndedQuestions: Array<{ __typename?: 'OpenEndedQuestion', question: string, speaker: string, startTime: number }>, speakerLabels?: Array<{ __typename?: 'SpeakerLabel', speakerId?: string | null, speakerLabel?: string | null, speakerName?: string | null, speakerRole?: string | null, speakerRoleDisplayed?: string | null, talkRatio?: number | null, isPresenter?: boolean | null }> | null, stackedQuestions: Array<{ __typename?: 'StackedQuestion', questions: Array<string>, speaker: string, startTime: number }> } | null, articulation?: { __typename?: 'Articulation', fillerWords?: Array<string> | null, fillerWordsCount?: number | null, keywordScore?: number | null, mediaLength?: number | null, overallScore?: number | null, wordsPerMinute?: number | null } | null, contentScore?: { __typename?: 'ContentScore', consistency: number, coherence: number, grammar: number, toneNstyle: number } | null, keywordCheck?: { __typename?: 'AutoEvaluationKeywordCheck', allowedKeywordsMatched?: Array<string> | null, allowedKeywordsNotMatched?: Array<string> | null, incorrectKeywordsMatched?: Array<string> | null, incorrectKeywordsNotMatched?: Array<string> | null, allowedKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, allowedKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null, incorrectKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, incorrectKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null } | null } | null, reviewerCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } | null, mentions?: { __typename?: 'MentionConnection', nodes: Array<{ __typename?: 'CompanyProfile', id: any, externalId: string, emailAddress?: string | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, preferredName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }> } | null, formTransactional?: { __typename?: 'FormTransactional', id: any, prompts: { __typename?: 'PromptTransactionalConnection', nodes: Array<{ __typename?: 'PromptTransactional', id: any, choices?: { __typename?: 'ChoiceTransactionalConnection', nodes: Array<{ __typename?: 'ChoiceTransactional', id: any, isSelected?: boolean | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, description?: string | null } | null }> } | null }> } } | null } };

export type SocialRepAssignmentQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SocialRepAssignmentQuery = { __typename?: 'Query', socialRepAssignment?: { __typename?: 'RepAssignment', id: any, repSubmissionCount: number, repAssignmentStatus: RepAssignmentStatus, points: number, lastActivityAt?: any | null, createdAt: any, learnerCompanyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }, assignorCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } | null, skill: { __typename?: 'Skill', id: any, externalId: string, name: string, updatedAt: any, repPoints?: number | null, freestylePoints?: number | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', language: Language, description: string } | null }, repPrompt?: { __typename?: 'RepPrompt', id: any, selfPracticeEnabled: boolean, keywordAnalysisEnabled: boolean, allResponseTypeEnabled: boolean, isCoached: boolean, repType: RepType, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteria', keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', incorrectKeywords?: Array<string> | null, allowedKeywords?: Array<string> | null } | null } | null, interjectionsHandling?: { __typename?: 'InterjectionsHandling', interjections?: Array<{ __typename?: 'Interjection', index?: string | null, start?: string | null, duration?: string | null, author?: string | null, message?: Array<{ __typename?: 'InterjectionMessage', translatedText?: string | null, language: Language }> | null }> | null } | null, formConfig?: { __typename?: 'Form', id: any, type: FormType, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, isRubric: boolean, isMultiple: boolean, promptLocalized?: { __typename?: 'PromptLocalized', id: any, description: string } | null, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, isCorrect?: boolean | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, description?: string | null } | null }> } }> } } | null, repPromptLocalized: { __typename?: 'RepPromptLocalized', id: any, language: Language, promptType: RepResponseKind, title?: string | null, content: string, caption?: string | null }, repPromptResponseTypes: { __typename?: 'RepPromptResponseTypeConnection', nodes: Array<{ __typename?: 'RepPromptResponseType', responseType?: RepResponseKind | null }> } } | null, repSubmissions: { __typename?: 'RepSubmissionConnection', nodes: Array<{ __typename?: 'RepSubmission', id: any, repAssignmentId?: any | null, title?: string | null, content: string, caption?: string | null, responseType: RepResponseKind, createdAt?: any | null, aiReviewStatus?: ReviewStatus | null, coachReviewStatus?: ReviewStatus | null, error?: { __typename?: 'ErrorMsg', error?: string | null, statusCode?: string | null } | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, streamMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, transcriptionMedia?: { __typename?: 'Media', id: any, status: MediaStatus, error?: string | null } | null, reactions: { __typename?: 'ReactionsConnection', nodes: Array<{ __typename?: 'Reaction', id: any, type: ReactionType, companyProfileId: any }> }, repSubmissionFeedbacks: { __typename?: 'RepSubmissionFeedbackConnection', nodes: Array<{ __typename?: 'RepSubmissionFeedback', id: any, createdAt?: any | null, feedbackType: RepFeedbackType, responseType: RepResponseKind, content?: string | null, caption?: string | null, reviewerRole: ReviewerRoleType, previewUrl?: string | null, mediaUrl?: string | null, rawMediaUrl?: string | null, autoEvaluationOutcome?: { __typename?: 'AutoEvaluationOutcome', isArticulationPass?: boolean | null, isKeywordPass?: boolean | null, sentiment?: number | null, conversationMetrics?: { __typename?: 'ConversationMetrics', conversationType: string, noOfSubmitterQuestions?: number | null, overallFeedback?: string | null, questionRate: number, thresholds: { __typename?: 'ConversationMetricsThresholds', stackedQuestionsCount: number, talkRatio: number, questionRate: number, pauseDuration: Array<number>, noOfSubmitterQuestions: number }, needsIdentificationScore: { __typename?: 'NeedsIdentificationScore', identificationScore: number, needCaptured: boolean, needExpressed: boolean, problemClarity: number }, nonVerbalSkillScore: { __typename?: 'NonVerbalSkillScore', confidence: number, listening: number, patience: number, pauseDuration: number }, openEndedQuestions: Array<{ __typename?: 'OpenEndedQuestion', question: string, speaker: string, startTime: number }>, speakerLabels?: Array<{ __typename?: 'SpeakerLabel', speakerId?: string | null, speakerLabel?: string | null, speakerName?: string | null, speakerRole?: string | null, speakerRoleDisplayed?: string | null, talkRatio?: number | null, isPresenter?: boolean | null }> | null, stackedQuestions: Array<{ __typename?: 'StackedQuestion', questions: Array<string>, speaker: string, startTime: number }> } | null, articulation?: { __typename?: 'Articulation', fillerWords?: Array<string> | null, fillerWordsCount?: number | null, keywordScore?: number | null, mediaLength?: number | null, overallScore?: number | null, wordsPerMinute?: number | null } | null, contentScore?: { __typename?: 'ContentScore', consistency: number, coherence: number, grammar: number, toneNstyle: number } | null, keywordCheck?: { __typename?: 'AutoEvaluationKeywordCheck', allowedKeywordsMatched?: Array<string> | null, allowedKeywordsNotMatched?: Array<string> | null, incorrectKeywordsMatched?: Array<string> | null, incorrectKeywordsNotMatched?: Array<string> | null, allowedKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, allowedKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null, incorrectKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, incorrectKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null } | null } | null, reviewerCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } | null, mentions?: { __typename?: 'MentionConnection', nodes: Array<{ __typename?: 'CompanyProfile', id: any, externalId: string, emailAddress?: string | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, preferredName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }> } | null, formTransactional?: { __typename?: 'FormTransactional', id: any, prompts: { __typename?: 'PromptTransactionalConnection', nodes: Array<{ __typename?: 'PromptTransactional', id: any, choices?: { __typename?: 'ChoiceTransactionalConnection', nodes: Array<{ __typename?: 'ChoiceTransactional', id: any, isSelected?: boolean | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, description?: string | null } | null }> } | null }> } } | null }> } }> }, companyProfileSkill: { __typename?: 'CompanyProfileSkill', id: string, assignmentSkill?: { __typename?: 'AssignmentSkill', id: any, learningPlan: { __typename?: 'LearningPlan', name: string, learningPlanFolderId?: any | null, learningPlanLocalized: { __typename?: 'LearningPlanLocalized', description?: string | null, learningPlanFolderName?: string | null } } } | null } } | null };

export type SocialRepAssignmentsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<Array<RepAssignmentSort> | RepAssignmentSort>;
  conditions?: InputMaybe<SocialRepAssignmentConditions>;
}>;


export type SocialRepAssignmentsQuery = { __typename?: 'Query', socialReps: { __typename?: 'PaginatedSocialRepAssignmentResponse', totalCount?: number | null, pageInfo: { __typename?: 'SocialRepAssignmentPageInfo', afterCursor?: string | null, beforeCursor?: string | null }, nodes: Array<{ __typename?: 'RepAssignment', id: any, repAssignmentStatus: RepAssignmentStatus, points: number, lastActivityAt?: any | null, createdAt: any, learnerCompanyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }, skill: { __typename?: 'Skill', id: any, externalId: string, name: string, updatedAt: any, repPoints?: number | null, freestylePoints?: number | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', language: Language, description: string } | null }, repPrompt?: { __typename?: 'RepPrompt', id: any, repPromptLocalized: { __typename?: 'RepPromptLocalized', id: any, language: Language, promptType: RepResponseKind, title?: string | null, content: string, caption?: string | null } } | null, repSubmissions: { __typename?: 'RepSubmissionConnection', nodes: Array<{ __typename?: 'RepSubmission', id: any, title?: string | null, content: string, responseType: RepResponseKind, coachReviewStatus?: ReviewStatus | null, error?: { __typename?: 'ErrorMsg', error?: string | null, statusCode?: string | null } | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> } }> } };

export type SocialRepAssignmentsByPromptQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<Array<RepAssignmentSort> | RepAssignmentSort>;
  conditions?: InputMaybe<SocialRepAssignmentByPromptConditions>;
  assignmentsPaginates: Array<SocialRepAssignmentByPromptListArgs> | SocialRepAssignmentByPromptListArgs;
}>;


export type SocialRepAssignmentsByPromptQuery = { __typename?: 'Query', socialRepsByPrompt: { __typename?: 'PaginatedSocialRepAssignmentByPromptResponse', totalCount?: number | null, pageInfo: { __typename?: 'SocialRepPromptPageInfo', afterCursor?: string | null, beforeCursor?: string | null }, nodes: Array<{ __typename?: 'SocialRepPrompt', id: any, repAssignmentId?: string | null, isRepeatable: boolean, repPromptLocalized: { __typename?: 'RepPromptLocalized', id: any, content: string, language: Language }, skill: { __typename?: 'Skill', id: any, skillLocalized?: { __typename?: 'SkillLocalized', id: any, description: string } | null }, paginatedAssignments: { __typename?: 'PaginatedSocialRepAssignmentResponse', totalCount?: number | null, pageInfo: { __typename?: 'SocialRepAssignmentPageInfo', afterCursor?: string | null, beforeCursor?: string | null }, nodes: Array<{ __typename?: 'RepAssignment', id: any, points: number, repAssignmentStatus: RepAssignmentStatus, lastActivityAt?: any | null, repSubmissions: { __typename?: 'RepSubmissionConnection', nodes: Array<{ __typename?: 'RepSubmission', id: any, content: string, responseType: RepResponseKind, createdAt?: any | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, streamMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null }> }, learnerCompanyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } }> } }> } };

export type SocialRepAssignmentsListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<RepAssignmentListConditions>;
}>;


export type SocialRepAssignmentsListQuery = { __typename?: 'Query', socialRepAssignments: { __typename?: 'PaginatedSocialRepAssignmentResponse', totalCount?: number | null, pageInfo: { __typename?: 'SocialRepAssignmentPageInfo', afterCursor?: string | null, beforeCursor?: string | null }, nodes: Array<{ __typename?: 'RepAssignment', id: any, repSubmissionCount: number, repAssignmentStatus: RepAssignmentStatus, points: number, lastActivityAt?: any | null, createdAt: any, learnerCompanyProfile: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }, assignorCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } | null, skill: { __typename?: 'Skill', id: any, externalId: string, name: string, updatedAt: any, repPoints?: number | null, freestylePoints?: number | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, skillLocalized?: { __typename?: 'SkillLocalized', language: Language, description: string } | null }, repPrompt?: { __typename?: 'RepPrompt', id: any, selfPracticeEnabled: boolean, keywordAnalysisEnabled: boolean, allResponseTypeEnabled: boolean, isCoached: boolean, repType: RepType, autoEvaluationCriteria?: { __typename?: 'AutoEvaluationCriteria', keywordCheck?: { __typename?: 'AutoEvaluationCriteriaKeywordCheck', incorrectKeywords?: Array<string> | null, allowedKeywords?: Array<string> | null } | null } | null, interjectionsHandling?: { __typename?: 'InterjectionsHandling', interjections?: Array<{ __typename?: 'Interjection', index?: string | null, start?: string | null, duration?: string | null, author?: string | null, message?: Array<{ __typename?: 'InterjectionMessage', translatedText?: string | null, language: Language }> | null }> | null } | null, formConfig?: { __typename?: 'Form', id: any, type: FormType, prompts: { __typename?: 'PromptConnection', nodes: Array<{ __typename?: 'Prompt', id: any, isRubric: boolean, isMultiple: boolean, promptLocalized?: { __typename?: 'PromptLocalized', id: any, description: string } | null, choices: { __typename?: 'ChoiceConnection', nodes: Array<{ __typename?: 'Choice', id: any, type: ChoiceType, isCorrect?: boolean | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, description?: string | null } | null }> } }> } } | null, repPromptLocalized: { __typename?: 'RepPromptLocalized', id: any, language: Language, promptType: RepResponseKind, title?: string | null, content: string, caption?: string | null }, repPromptResponseTypes: { __typename?: 'RepPromptResponseTypeConnection', nodes: Array<{ __typename?: 'RepPromptResponseType', responseType?: RepResponseKind | null }> } } | null, repSubmissions: { __typename?: 'RepSubmissionConnection', nodes: Array<{ __typename?: 'RepSubmission', id: any, repAssignmentId?: any | null, title?: string | null, content: string, caption?: string | null, responseType: RepResponseKind, createdAt?: any | null, aiReviewStatus?: ReviewStatus | null, coachReviewStatus?: ReviewStatus | null, error?: { __typename?: 'ErrorMsg', error?: string | null, statusCode?: string | null } | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, streamMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, posterMedia?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null, transcriptionMedia?: { __typename?: 'Media', id: any, status: MediaStatus, error?: string | null } | null, reactions: { __typename?: 'ReactionsConnection', nodes: Array<{ __typename?: 'Reaction', id: any, type: ReactionType, companyProfileId: any }> }, repSubmissionFeedbacks: { __typename?: 'RepSubmissionFeedbackConnection', nodes: Array<{ __typename?: 'RepSubmissionFeedback', id: any, createdAt?: any | null, feedbackType: RepFeedbackType, responseType: RepResponseKind, content?: string | null, caption?: string | null, reviewerRole: ReviewerRoleType, previewUrl?: string | null, mediaUrl?: string | null, rawMediaUrl?: string | null, autoEvaluationOutcome?: { __typename?: 'AutoEvaluationOutcome', isArticulationPass?: boolean | null, isKeywordPass?: boolean | null, sentiment?: number | null, conversationMetrics?: { __typename?: 'ConversationMetrics', conversationType: string, noOfSubmitterQuestions?: number | null, overallFeedback?: string | null, questionRate: number, thresholds: { __typename?: 'ConversationMetricsThresholds', stackedQuestionsCount: number, talkRatio: number, questionRate: number, pauseDuration: Array<number>, noOfSubmitterQuestions: number }, needsIdentificationScore: { __typename?: 'NeedsIdentificationScore', identificationScore: number, needCaptured: boolean, needExpressed: boolean, problemClarity: number }, nonVerbalSkillScore: { __typename?: 'NonVerbalSkillScore', confidence: number, listening: number, patience: number, pauseDuration: number }, openEndedQuestions: Array<{ __typename?: 'OpenEndedQuestion', question: string, speaker: string, startTime: number }>, speakerLabels?: Array<{ __typename?: 'SpeakerLabel', speakerId?: string | null, speakerLabel?: string | null, speakerName?: string | null, speakerRole?: string | null, speakerRoleDisplayed?: string | null, talkRatio?: number | null, isPresenter?: boolean | null }> | null, stackedQuestions: Array<{ __typename?: 'StackedQuestion', questions: Array<string>, speaker: string, startTime: number }> } | null, articulation?: { __typename?: 'Articulation', fillerWords?: Array<string> | null, fillerWordsCount?: number | null, keywordScore?: number | null, mediaLength?: number | null, overallScore?: number | null, wordsPerMinute?: number | null } | null, contentScore?: { __typename?: 'ContentScore', consistency: number, coherence: number, grammar: number, toneNstyle: number } | null, keywordCheck?: { __typename?: 'AutoEvaluationKeywordCheck', allowedKeywordsMatched?: Array<string> | null, allowedKeywordsNotMatched?: Array<string> | null, incorrectKeywordsMatched?: Array<string> | null, incorrectKeywordsNotMatched?: Array<string> | null, allowedKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, allowedKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null, incorrectKeywordsMatchedV2?: Array<{ __typename?: 'KeywordsMatch', expectedKeyword?: string | null, actualKeyword?: string | null }> | null, incorrectKeywordsFuzzyMatched?: Array<{ __typename?: 'FuzzyMatch', expectedKeyword?: string | null, actualKeyword?: string | null, fuzzyIndex?: number | null }> | null } | null } | null, reviewerCompanyProfile?: { __typename?: 'CompanyProfile', id: any, externalId: string, language?: Language | null, profile: { __typename?: 'Profile', id: string, preferredName?: string | null, displayName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } } | null, mentions?: { __typename?: 'MentionConnection', nodes: Array<{ __typename?: 'CompanyProfile', id: any, externalId: string, emailAddress?: string | null, profile: { __typename?: 'Profile', id: string, displayName?: string | null, preferredName?: string | null, media?: { __typename?: 'Media', id: any, mediaUrl?: string | null } | null } }> } | null, formTransactional?: { __typename?: 'FormTransactional', id: any, prompts: { __typename?: 'PromptTransactionalConnection', nodes: Array<{ __typename?: 'PromptTransactional', id: any, choices?: { __typename?: 'ChoiceTransactionalConnection', nodes: Array<{ __typename?: 'ChoiceTransactional', id: any, isSelected?: boolean | null, choiceLocalized?: { __typename?: 'ChoiceLocalized', id: any, description?: string | null } | null }> } | null }> } } | null }> } }> }, companyProfileSkill: { __typename?: 'CompanyProfileSkill', id: string, assignmentSkill?: { __typename?: 'AssignmentSkill', id: any, learningPlan: { __typename?: 'LearningPlan', name: string, learningPlanFolderId?: any | null, learningPlanLocalized: { __typename?: 'LearningPlanLocalized', description?: string | null, learningPlanFolderName?: string | null } } } | null } }> } };

export type RepAssignmentsCountQueryVariables = Exact<{
  statuses?: InputMaybe<Array<RepAssignmentStatus> | RepAssignmentStatus>;
}>;


export type RepAssignmentsCountQuery = { __typename?: 'Query', repAssignments: { __typename?: 'PaginatedRepAssignmentResponse', totalCount?: number | null } };

export const LearningCardFragmentDoc = gql`
    fragment LearningCard on LearningCard {
  id
  position
  experimentConfig
  resetLpIfFail
  learningCardLocalized {
    ... on LearningCardLocalizedFlashCard {
      id
      type
      title
      description
      media {
        id
        mediaUrl: mediaUrlV2
      }
    }
    ... on LearningCardLocalizedFile {
      id
      type
      language
      title
      media {
        id
        mediaUrl: mediaUrlV2
      }
    }
    ... on LearningCardLocalizedVideo {
      id
      type
      language
      title
      media {
        id
        mimeType
        location
        playbackId: path
        mediaUrl: mediaUrlV2
      }
      posterMedia {
        id
        mediaUrl: mediaUrlV2
      }
      textTrackMedia {
        id
        mediaUrl: mediaUrlV2
      }
    }
    ... on LearningCardLocalizedLinkout {
      id
      type
      title
      url
      description
      ctaTitle
    }
    ... on LearningCardForm {
      id
      type
      formId
      form {
        id
        maxTries
      }
    }
  }
}
    `;
export const FeedbackFragmentDoc = gql`
    fragment Feedback on Feedback {
  id
  rating
}
    `;
export const LearningPlanFragmentDoc = gql`
    fragment LearningPlanFragment on LearningPlan {
  id
  externalId
  photoUrl: transformedMediaUrl(
    isPreview: true
    transformations: {fetch_format: "auto", quality: "auto", dpr: "auto", width: "100"}
  )
  learningPlanLocalized {
    description
  }
}
    `;
export const AssignmentFragmentDoc = gql`
    fragment AssignmentFragment on AssignmentLP {
  id
  isLocked
  completedAt
  skillCount
  repCount
  progress
  learningPlan {
    ...LearningPlanFragment
  }
}
    ${LearningPlanFragmentDoc}`;
export const SkillFragmentDoc = gql`
    fragment SkillFragment on Skill {
  id
  name
  externalId
  type
  duration
  repType
  media {
    id
    mediaUrl: mediaUrlV2
    thumbnailUrl: mediaUrlV2(imageSize: S)
  }
  skillLocalized {
    description
  }
}
    `;
export const AssignmentSkillCardFragmentDoc = gql`
    fragment AssignmentSkillCardFragment on AssignmentSkillCard {
  id
  repSubmissionCount
  lpCompanySectionExternalId
  skillExternalId
  companyProfileSkillId
  isLocked
  points
  progress
  skillFlow
  repAssignmentId
  repAssignmentStatus
  completedAt
  failedAt
  pointsEarned
  skill {
    ...SkillFragment
  }
}
    ${SkillFragmentDoc}`;
export const ProfilePhotoFragmentDoc = gql`
    fragment ProfilePhotoFragment on Profile {
  media {
    id
    mediaUrl: mediaUrlV2
  }
}
    `;
export const RepUserFragmentDoc = gql`
    fragment RepUser on CompanyProfile {
  id
  externalId
  language
  profile {
    id
    ...ProfilePhotoFragment
    preferredName
    displayName
  }
}
    ${ProfilePhotoFragmentDoc}`;
export const CoachRepAssignmentFragmentDoc = gql`
    fragment CoachRepAssignmentFragment on RepAssignment {
  id
  companyProfileId
  repAssignmentStatus
  lastActivityAt
  points
  learnerCompanyProfile {
    ...RepUser
  }
  skill {
    ...SkillFragment
  }
  repPrompt {
    id
    repPromptLocalized {
      id
      content
      language
    }
  }
  repSubmissions {
    nodes {
      id
      title
      caption
      repAssignmentId
      content
      responseType
      createdAt
      media {
        id
        mediaUrl: mediaUrlV2
      }
      posterMedia {
        id
        mediaUrl: mediaUrlV2
      }
    }
  }
}
    ${RepUserFragmentDoc}
${SkillFragmentDoc}`;
export const FormTransactionalFragmentDoc = gql`
    fragment FormTransactional on FormTransactional {
  id
  type
  passingThreshold
  maxTries
  maxTriesPerPrompt
  showCorrectChoicesAtTheEnd
  learningCardAssignmentCompletionId
  formLocalized {
    description
    id
    language
  }
  learningCardAssignmentCompletion {
    startedAt
    failedAt
    completedAt
  }
  prompts {
    nodes {
      id
      formId
      position
      choicesCountConfig
      minChoicesCountRequired
      maxChoicesCountRequired
      promptLocalized {
        id
        description
      }
      isMultiple
      isFailed
      isCompleted
      choices {
        nodes {
          id
          promptId
          type
          choiceLocalized {
            media {
              mediaUrl: mediaUrlV2
            }
            id
            language
            description
          }
          isFailed
          isCorrect
          isSelected
          answer
        }
      }
    }
  }
}
    `;
export const LearningCardAssignmentCompletionsFragmentDoc = gql`
    fragment LearningCardAssignmentCompletions on LearningCardAssignmentCompletion {
  id
  companyProfileSkillId
  learningCardId
  companyProfileId
  progress
  createdAt
  startedAt
  failedAt
  completedAt
  triesCount
  learningCardCompletionFormSummary {
    nodes {
      id
      promptId
      isFailed
      submittedAt
      learningCardCompletionFormAnswersSummary {
        nodes {
          id
          learningCardCompletionFormId
          isFailed
          choiceId
          answer
        }
      }
    }
  }
}
    `;
export const ProScoreFragmentDoc = gql`
    fragment ProScoreFragment on ProScoreV3 {
  id
  skillsAssignedCount
  skillsCompletedCount
  repsCompletedCount
  repsAssignedCount
  score
  proScore
}
    `;
export const WorkspaceFragmentDoc = gql`
    fragment WorkspaceFragment on Workspace {
  id
  externalId
  companyId
  companyName
  companyExternalId
  companyInternalName
  companyLogo
}
    `;
export const ProfileFragmentDoc = gql`
    fragment ProfileFragment on Profile {
  id
  preferredName
  displayName
  createdAt
  acceptedLegal
  enabledFeatures
  isSuperuser
  hasCoachedReps
  hasSocialReps
  ...ProfilePhotoFragment
  flags(
    appName: $appName
    appVersion: $appVersion
    browserName: $browserName
    browserVersion: $browserVersion
    osName: $osName
    osVersion: $osVersion
    platform: $platform
    platformType: $platformType
    platformVendor: $platformVendor
    platformModel: $platformModel
  ) {
    name
    value
  }
  companyProfile {
    id
    externalId
    companyId
    isCoach
    language
    emailAddress
    phoneNumber
    score
    excludeFromAnalytics
    company {
      id
      externalId
      defaultLanguage
      displayName
      name
      companyLanguages {
        nodes {
          id
          language
        }
      }
    }
  }
  workspaces {
    nodes {
      ...WorkspaceFragment
    }
  }
}
    ${ProfilePhotoFragmentDoc}
${WorkspaceFragmentDoc}`;
export const _RepSkillFragmentDoc = gql`
    fragment _RepSkill on Skill {
  id
  externalId
  name
  media {
    id
    mediaUrl: mediaUrlV2
  }
  updatedAt
  repPoints
  freestylePoints
  skillLocalized {
    language
    description
  }
}
    `;
export const _RepPromptLocalizedFragmentDoc = gql`
    fragment _RepPromptLocalized on RepPromptLocalized {
  id
  language
  promptType
  title
  content
  caption
}
    `;
export const ReactionFragmentDoc = gql`
    fragment ReactionFragment on Reaction {
  id
  type
  companyProfileId
}
    `;
export const _RepSubmissionFeedbackFragmentDoc = gql`
    fragment _RepSubmissionFeedback on RepSubmissionFeedback {
  id
  createdAt
  feedbackType
  responseType
  content
  caption
  autoEvaluationOutcome {
    isArticulationPass
    isKeywordPass
    sentiment
    conversationMetrics {
      conversationType
      noOfSubmitterQuestions
      thresholds {
        stackedQuestionsCount
        talkRatio
        questionRate
        pauseDuration
        noOfSubmitterQuestions
      }
      needsIdentificationScore {
        identificationScore
        needCaptured
        needExpressed
        problemClarity
      }
      nonVerbalSkillScore {
        confidence
        listening
        patience
        pauseDuration
      }
      openEndedQuestions {
        question
        speaker
        startTime
      }
      overallFeedback
      questionRate
      speakerLabels {
        speakerId
        speakerLabel
        speakerName
        speakerRole
        speakerRoleDisplayed
        talkRatio
        isPresenter
      }
      stackedQuestions {
        questions
        speaker
        startTime
      }
    }
    articulation {
      fillerWords
      fillerWordsCount
      keywordScore
      mediaLength
      overallScore
      wordsPerMinute
    }
    contentScore {
      consistency
      coherence
      grammar
      toneNstyle
    }
    keywordCheck {
      allowedKeywordsMatched
      allowedKeywordsMatchedV2 {
        expectedKeyword
        actualKeyword
      }
      allowedKeywordsNotMatched
      allowedKeywordsFuzzyMatched {
        expectedKeyword
        actualKeyword
        fuzzyIndex
      }
      incorrectKeywordsMatched
      incorrectKeywordsMatchedV2 {
        expectedKeyword
        actualKeyword
      }
      incorrectKeywordsNotMatched
      incorrectKeywordsFuzzyMatched {
        expectedKeyword
        actualKeyword
        fuzzyIndex
      }
    }
  }
  previewUrl: transformedMediaUrl(
    isPreview: true
    transformations: {fetch_format: "auto", quality: "auto", dpr: "auto", width: "400"}
  )
  mediaUrl: transformedMediaUrl(
    transformations: {fetch_format: "auto", quality: "auto", dpr: "auto", width: "400"}
  )
  rawMediaUrl: transformedMediaUrl
  reviewerRole
  reviewerCompanyProfile {
    ...RepUser
  }
  mentions {
    nodes {
      id
      externalId
      emailAddress
      profile {
        id
        displayName
        preferredName
        ...ProfilePhotoFragment
      }
    }
  }
  formTransactional {
    id
    prompts {
      nodes {
        id
        choices {
          nodes {
            id
            isSelected
            choiceLocalized {
              id
              description
            }
          }
        }
      }
    }
  }
}
    ${RepUserFragmentDoc}
${ProfilePhotoFragmentDoc}`;
export const _RepSubmissionFragmentDoc = gql`
    fragment _RepSubmission on RepSubmission {
  id
  repAssignmentId
  title
  content
  caption
  responseType
  createdAt
  aiReviewStatus
  error {
    error
    statusCode
  }
  coachReviewStatus
  media {
    id
    mediaUrl: mediaUrlV2
  }
  streamMedia {
    id
    mediaUrl: mediaUrlV2
  }
  posterMedia {
    id
    mediaUrl: mediaUrlV2
  }
  transcriptionMedia {
    id
    status
    error
  }
  reactions {
    nodes {
      ...ReactionFragment
    }
  }
  repSubmissionFeedbacks {
    nodes {
      ..._RepSubmissionFeedback
    }
  }
}
    ${ReactionFragmentDoc}
${_RepSubmissionFeedbackFragmentDoc}`;
export const RepAssignmentFragmentDoc = gql`
    fragment RepAssignmentFragment on RepAssignment {
  id
  repSubmissionCount
  repAssignmentStatus
  points
  lastActivityAt
  createdAt
  learnerCompanyProfile {
    ...RepUser
  }
  assignorCompanyProfile {
    ...RepUser
  }
  skill {
    ..._RepSkill
  }
  repPrompt {
    id
    selfPracticeEnabled
    keywordAnalysisEnabled
    autoEvaluationCriteria {
      keywordCheck {
        incorrectKeywords
        allowedKeywords
      }
    }
    allResponseTypeEnabled
    isCoached
    repType
    interjectionsHandling {
      interjections {
        index
        start
        duration
        author
        message {
          translatedText
          language
        }
      }
    }
    formConfig {
      id
      type
      prompts {
        nodes {
          id
          isRubric
          isMultiple
          promptLocalized {
            id
            description
          }
          choices {
            nodes {
              id
              type
              isCorrect
              choiceLocalized {
                id
                description
              }
            }
          }
        }
      }
    }
    repPromptLocalized {
      ..._RepPromptLocalized
    }
    repPromptResponseTypes {
      nodes {
        responseType
      }
    }
  }
  repSubmissions {
    nodes {
      ..._RepSubmission
    }
  }
  companyProfileSkill {
    id
    assignmentSkill {
      id
      learningPlan {
        name
        learningPlanFolderId
        learningPlanLocalized {
          description
          learningPlanFolderName
        }
      }
    }
  }
}
    ${RepUserFragmentDoc}
${_RepSkillFragmentDoc}
${_RepPromptLocalizedFragmentDoc}
${_RepSubmissionFragmentDoc}`;
export const _RepAssignmentSummaryFragmentDoc = gql`
    fragment _RepAssignmentSummary on RepAssignment {
  id
  repSubmissionCount
  repAssignmentStatus
  createdAt
  learnerCompanyProfile {
    ...RepUser
  }
  assignorCompanyProfile {
    ...RepUser
  }
  skill {
    ..._RepSkill
  }
  repPrompt {
    id
    allResponseTypeEnabled
    isCoached
    repPromptLocalized {
      ..._RepPromptLocalized
    }
    repPromptResponseTypes {
      nodes {
        responseType
      }
    }
  }
}
    ${RepUserFragmentDoc}
${_RepSkillFragmentDoc}
${_RepPromptLocalizedFragmentDoc}`;
export const SocialRepAssignmentFragmentDoc = gql`
    fragment SocialRepAssignmentFragment on RepAssignment {
  id
  repAssignmentStatus
  points
  lastActivityAt
  createdAt
  learnerCompanyProfile {
    ...RepUser
  }
  skill {
    ..._RepSkill
  }
  repPrompt {
    id
    repPromptLocalized {
      ..._RepPromptLocalized
    }
  }
  repSubmissions {
    nodes {
      id
      title
      content
      responseType
      error {
        error
        statusCode
      }
      coachReviewStatus
      media {
        id
        mediaUrl: mediaUrlV2
      }
      posterMedia {
        id
        mediaUrl: mediaUrlV2
      }
    }
  }
}
    ${RepUserFragmentDoc}
${_RepSkillFragmentDoc}
${_RepPromptLocalizedFragmentDoc}`;
export const TopicFragmentDoc = gql`
    fragment TopicFragment on Topic {
  id
  name
  skillCount
  repCount
  media {
    id
    mediaUrl: mediaUrlV2
    thumbnailUrl: mediaUrlV2(imageSize: S)
  }
  topicLocalized {
    id
    description
    language
  }
}
    `;
export const AcceptLegalDocument = gql`
    mutation AcceptLegal {
  acceptLegal {
    id
    acceptedLegal
  }
}
    `;
export type AcceptLegalMutationFn = Apollo.MutationFunction<AcceptLegalMutation, AcceptLegalMutationVariables>;

/**
 * __useAcceptLegalMutation__
 *
 * To run a mutation, you first call `useAcceptLegalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptLegalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptLegalMutation, { data, loading, error }] = useAcceptLegalMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptLegalMutation(baseOptions?: Apollo.MutationHookOptions<AcceptLegalMutation, AcceptLegalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptLegalMutation, AcceptLegalMutationVariables>(AcceptLegalDocument, options);
      }
export type AcceptLegalMutationHookResult = ReturnType<typeof useAcceptLegalMutation>;
export type AcceptLegalMutationResult = Apollo.MutationResult<AcceptLegalMutation>;
export type AcceptLegalMutationOptions = Apollo.BaseMutationOptions<AcceptLegalMutation, AcceptLegalMutationVariables>;
export const AssignmentDocument = gql`
    query Assignment($assignmentInput: AssignmentInput!) {
  assignment(assignmentInput: $assignmentInput) {
    id
    learningPlan {
      learningPlanLocalized {
        description
      }
    }
    assignmentSkillCards {
      nodes {
        id
        repAssignmentId
        repAssignmentStatus
        isLocked
        completedAt
        lpCompanySectionExternalId
        progress
        points
        pointsEarned
        failedAt
        skill {
          id
          type
          repType
          externalId
          skillLocalized {
            id
            description
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAssignmentQuery__
 *
 * To run a query within a React component, call `useAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentQuery({
 *   variables: {
 *      assignmentInput: // value for 'assignmentInput'
 *   },
 * });
 */
export function useAssignmentQuery(baseOptions: Apollo.QueryHookOptions<AssignmentQuery, AssignmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignmentQuery, AssignmentQueryVariables>(AssignmentDocument, options);
      }
export function useAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignmentQuery, AssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignmentQuery, AssignmentQueryVariables>(AssignmentDocument, options);
        }
export type AssignmentQueryHookResult = ReturnType<typeof useAssignmentQuery>;
export type AssignmentLazyQueryHookResult = ReturnType<typeof useAssignmentLazyQuery>;
export type AssignmentQueryResult = Apollo.QueryResult<AssignmentQuery, AssignmentQueryVariables>;
export const AuthByUrlDocument = gql`
    mutation AuthByURL($profileExternalId: String!, $companyExternalId: String!) {
  authByURL(
    profileExternalId: $profileExternalId
    companyExternalId: $companyExternalId
  ) {
    accessToken
    refreshToken
    companyProfileId
    companyExternalId
  }
}
    `;
export type AuthByUrlMutationFn = Apollo.MutationFunction<AuthByUrlMutation, AuthByUrlMutationVariables>;

/**
 * __useAuthByUrlMutation__
 *
 * To run a mutation, you first call `useAuthByUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthByUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authByUrlMutation, { data, loading, error }] = useAuthByUrlMutation({
 *   variables: {
 *      profileExternalId: // value for 'profileExternalId'
 *      companyExternalId: // value for 'companyExternalId'
 *   },
 * });
 */
export function useAuthByUrlMutation(baseOptions?: Apollo.MutationHookOptions<AuthByUrlMutation, AuthByUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthByUrlMutation, AuthByUrlMutationVariables>(AuthByUrlDocument, options);
      }
export type AuthByUrlMutationHookResult = ReturnType<typeof useAuthByUrlMutation>;
export type AuthByUrlMutationResult = Apollo.MutationResult<AuthByUrlMutation>;
export type AuthByUrlMutationOptions = Apollo.BaseMutationOptions<AuthByUrlMutation, AuthByUrlMutationVariables>;
export const AuthChannelDocument = gql`
    query AuthChannel($profileIdentifier: String!) {
  authChannel(profileIdentifier: $profileIdentifier) {
    companyId
    companyExtId
    companyProfileId
    channelType
    ssoChannel {
      idpProxyBaseUrl
      idpProxyPath
      certPath
    }
    localChannel {
      supportedTypes
    }
  }
}
    `;

/**
 * __useAuthChannelQuery__
 *
 * To run a query within a React component, call `useAuthChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthChannelQuery({
 *   variables: {
 *      profileIdentifier: // value for 'profileIdentifier'
 *   },
 * });
 */
export function useAuthChannelQuery(baseOptions: Apollo.QueryHookOptions<AuthChannelQuery, AuthChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthChannelQuery, AuthChannelQueryVariables>(AuthChannelDocument, options);
      }
export function useAuthChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthChannelQuery, AuthChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthChannelQuery, AuthChannelQueryVariables>(AuthChannelDocument, options);
        }
export type AuthChannelQueryHookResult = ReturnType<typeof useAuthChannelQuery>;
export type AuthChannelLazyQueryHookResult = ReturnType<typeof useAuthChannelLazyQuery>;
export type AuthChannelQueryResult = Apollo.QueryResult<AuthChannelQuery, AuthChannelQueryVariables>;
export const AuthInitDocument = gql`
    mutation AuthInit($profileIdentifier: String!, $workspaceId: UUID) {
  authInit(profileIdentifier: $profileIdentifier, workspaceId: $workspaceId)
}
    `;
export type AuthInitMutationFn = Apollo.MutationFunction<AuthInitMutation, AuthInitMutationVariables>;

/**
 * __useAuthInitMutation__
 *
 * To run a mutation, you first call `useAuthInitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthInitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authInitMutation, { data, loading, error }] = useAuthInitMutation({
 *   variables: {
 *      profileIdentifier: // value for 'profileIdentifier'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useAuthInitMutation(baseOptions?: Apollo.MutationHookOptions<AuthInitMutation, AuthInitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthInitMutation, AuthInitMutationVariables>(AuthInitDocument, options);
      }
export type AuthInitMutationHookResult = ReturnType<typeof useAuthInitMutation>;
export type AuthInitMutationResult = Apollo.MutationResult<AuthInitMutation>;
export type AuthInitMutationOptions = Apollo.BaseMutationOptions<AuthInitMutation, AuthInitMutationVariables>;
export const AuthInitV2Document = gql`
    mutation AuthInitV2($profileIdentifier: String!, $companyId: UUID!) {
  authInitV2(profileIdentifier: $profileIdentifier, companyId: $companyId)
}
    `;
export type AuthInitV2MutationFn = Apollo.MutationFunction<AuthInitV2Mutation, AuthInitV2MutationVariables>;

/**
 * __useAuthInitV2Mutation__
 *
 * To run a mutation, you first call `useAuthInitV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthInitV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authInitV2Mutation, { data, loading, error }] = useAuthInitV2Mutation({
 *   variables: {
 *      profileIdentifier: // value for 'profileIdentifier'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAuthInitV2Mutation(baseOptions?: Apollo.MutationHookOptions<AuthInitV2Mutation, AuthInitV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthInitV2Mutation, AuthInitV2MutationVariables>(AuthInitV2Document, options);
      }
export type AuthInitV2MutationHookResult = ReturnType<typeof useAuthInitV2Mutation>;
export type AuthInitV2MutationResult = Apollo.MutationResult<AuthInitV2Mutation>;
export type AuthInitV2MutationOptions = Apollo.BaseMutationOptions<AuthInitV2Mutation, AuthInitV2MutationVariables>;
export const AuthLogoutDocument = gql`
    mutation AuthLogout($logoutInput: LogoutInput) {
  authLogout(logoutInput: $logoutInput)
}
    `;
export type AuthLogoutMutationFn = Apollo.MutationFunction<AuthLogoutMutation, AuthLogoutMutationVariables>;

/**
 * __useAuthLogoutMutation__
 *
 * To run a mutation, you first call `useAuthLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authLogoutMutation, { data, loading, error }] = useAuthLogoutMutation({
 *   variables: {
 *      logoutInput: // value for 'logoutInput'
 *   },
 * });
 */
export function useAuthLogoutMutation(baseOptions?: Apollo.MutationHookOptions<AuthLogoutMutation, AuthLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthLogoutMutation, AuthLogoutMutationVariables>(AuthLogoutDocument, options);
      }
export type AuthLogoutMutationHookResult = ReturnType<typeof useAuthLogoutMutation>;
export type AuthLogoutMutationResult = Apollo.MutationResult<AuthLogoutMutation>;
export type AuthLogoutMutationOptions = Apollo.BaseMutationOptions<AuthLogoutMutation, AuthLogoutMutationVariables>;
export const AuthOverrideDocument = gql`
    mutation AuthOverride($profileIdentifier: String!, $source: AuthenticationSource) {
  authOverride(profileIdentifier: $profileIdentifier, app: $source) {
    accessToken
    refreshToken
    companyProfileId
    companyExternalId
  }
}
    `;
export type AuthOverrideMutationFn = Apollo.MutationFunction<AuthOverrideMutation, AuthOverrideMutationVariables>;

/**
 * __useAuthOverrideMutation__
 *
 * To run a mutation, you first call `useAuthOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authOverrideMutation, { data, loading, error }] = useAuthOverrideMutation({
 *   variables: {
 *      profileIdentifier: // value for 'profileIdentifier'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useAuthOverrideMutation(baseOptions?: Apollo.MutationHookOptions<AuthOverrideMutation, AuthOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthOverrideMutation, AuthOverrideMutationVariables>(AuthOverrideDocument, options);
      }
export type AuthOverrideMutationHookResult = ReturnType<typeof useAuthOverrideMutation>;
export type AuthOverrideMutationResult = Apollo.MutationResult<AuthOverrideMutation>;
export type AuthOverrideMutationOptions = Apollo.BaseMutationOptions<AuthOverrideMutation, AuthOverrideMutationVariables>;
export const AuthOverrideLogoutDocument = gql`
    mutation AuthOverrideLogout {
  authOverrideLogout
}
    `;
export type AuthOverrideLogoutMutationFn = Apollo.MutationFunction<AuthOverrideLogoutMutation, AuthOverrideLogoutMutationVariables>;

/**
 * __useAuthOverrideLogoutMutation__
 *
 * To run a mutation, you first call `useAuthOverrideLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthOverrideLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authOverrideLogoutMutation, { data, loading, error }] = useAuthOverrideLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useAuthOverrideLogoutMutation(baseOptions?: Apollo.MutationHookOptions<AuthOverrideLogoutMutation, AuthOverrideLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthOverrideLogoutMutation, AuthOverrideLogoutMutationVariables>(AuthOverrideLogoutDocument, options);
      }
export type AuthOverrideLogoutMutationHookResult = ReturnType<typeof useAuthOverrideLogoutMutation>;
export type AuthOverrideLogoutMutationResult = Apollo.MutationResult<AuthOverrideLogoutMutation>;
export type AuthOverrideLogoutMutationOptions = Apollo.BaseMutationOptions<AuthOverrideLogoutMutation, AuthOverrideLogoutMutationVariables>;
export const AuthRefreshDocument = gql`
    mutation AuthRefresh($refreshToken: String, $source: AuthenticationSource) {
  authRefresh(refreshToken: $refreshToken, source: $source) {
    accessToken
    refreshToken
  }
}
    `;
export type AuthRefreshMutationFn = Apollo.MutationFunction<AuthRefreshMutation, AuthRefreshMutationVariables>;

/**
 * __useAuthRefreshMutation__
 *
 * To run a mutation, you first call `useAuthRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authRefreshMutation, { data, loading, error }] = useAuthRefreshMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useAuthRefreshMutation(baseOptions?: Apollo.MutationHookOptions<AuthRefreshMutation, AuthRefreshMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthRefreshMutation, AuthRefreshMutationVariables>(AuthRefreshDocument, options);
      }
export type AuthRefreshMutationHookResult = ReturnType<typeof useAuthRefreshMutation>;
export type AuthRefreshMutationResult = Apollo.MutationResult<AuthRefreshMutation>;
export type AuthRefreshMutationOptions = Apollo.BaseMutationOptions<AuthRefreshMutation, AuthRefreshMutationVariables>;
export const AuthVerifyDocument = gql`
    mutation AuthVerify($authInitId: String!, $code: String!) {
  authVerify(authInitId: $authInitId, code: $code) {
    accessToken
    refreshToken
    companyProfileId
    companyExternalId
    profileExternalId
  }
}
    `;
export type AuthVerifyMutationFn = Apollo.MutationFunction<AuthVerifyMutation, AuthVerifyMutationVariables>;

/**
 * __useAuthVerifyMutation__
 *
 * To run a mutation, you first call `useAuthVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authVerifyMutation, { data, loading, error }] = useAuthVerifyMutation({
 *   variables: {
 *      authInitId: // value for 'authInitId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useAuthVerifyMutation(baseOptions?: Apollo.MutationHookOptions<AuthVerifyMutation, AuthVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthVerifyMutation, AuthVerifyMutationVariables>(AuthVerifyDocument, options);
      }
export type AuthVerifyMutationHookResult = ReturnType<typeof useAuthVerifyMutation>;
export type AuthVerifyMutationResult = Apollo.MutationResult<AuthVerifyMutation>;
export type AuthVerifyMutationOptions = Apollo.BaseMutationOptions<AuthVerifyMutation, AuthVerifyMutationVariables>;
export const ChangeLanguageDocument = gql`
    mutation ChangeLanguage($language: Language!) {
  companyProfileChangeLanguage(language: $language) {
    id
    language
  }
}
    `;
export type ChangeLanguageMutationFn = Apollo.MutationFunction<ChangeLanguageMutation, ChangeLanguageMutationVariables>;

/**
 * __useChangeLanguageMutation__
 *
 * To run a mutation, you first call `useChangeLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeLanguageMutation, { data, loading, error }] = useChangeLanguageMutation({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useChangeLanguageMutation(baseOptions?: Apollo.MutationHookOptions<ChangeLanguageMutation, ChangeLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeLanguageMutation, ChangeLanguageMutationVariables>(ChangeLanguageDocument, options);
      }
export type ChangeLanguageMutationHookResult = ReturnType<typeof useChangeLanguageMutation>;
export type ChangeLanguageMutationResult = Apollo.MutationResult<ChangeLanguageMutation>;
export type ChangeLanguageMutationOptions = Apollo.BaseMutationOptions<ChangeLanguageMutation, ChangeLanguageMutationVariables>;
export const CompleteLearningCardV2Document = gql`
    mutation completeLearningCardV2($learningCardId: UUID!, $skillId: UUID!) {
  completeLearningCardV2(learningCardId: $learningCardId, skillId: $skillId) {
    ...LearningCardAssignmentCompletions
    skillCompletedAt
    pointsEarned
  }
}
    ${LearningCardAssignmentCompletionsFragmentDoc}`;
export type CompleteLearningCardV2MutationFn = Apollo.MutationFunction<CompleteLearningCardV2Mutation, CompleteLearningCardV2MutationVariables>;

/**
 * __useCompleteLearningCardV2Mutation__
 *
 * To run a mutation, you first call `useCompleteLearningCardV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteLearningCardV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeLearningCardV2Mutation, { data, loading, error }] = useCompleteLearningCardV2Mutation({
 *   variables: {
 *      learningCardId: // value for 'learningCardId'
 *      skillId: // value for 'skillId'
 *   },
 * });
 */
export function useCompleteLearningCardV2Mutation(baseOptions?: Apollo.MutationHookOptions<CompleteLearningCardV2Mutation, CompleteLearningCardV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteLearningCardV2Mutation, CompleteLearningCardV2MutationVariables>(CompleteLearningCardV2Document, options);
      }
export type CompleteLearningCardV2MutationHookResult = ReturnType<typeof useCompleteLearningCardV2Mutation>;
export type CompleteLearningCardV2MutationResult = Apollo.MutationResult<CompleteLearningCardV2Mutation>;
export type CompleteLearningCardV2MutationOptions = Apollo.BaseMutationOptions<CompleteLearningCardV2Mutation, CompleteLearningCardV2MutationVariables>;
export const CreateLccFormDocument = gql`
    mutation CreateLCCForm($learningCardId: UUID!, $promptId: UUID!, $answers: [LearningCardCompletionFormAnswerArg!]!) {
  learningCardCompletionFormCreate(
    learningCardId: $learningCardId
    promptId: $promptId
    answers: $answers
  ) {
    id
    learningCardAssignmentCompletionId
    promptId
    isFailed
    learningCardAssignmentCompletion {
      id
      companyProfileSkillId
      learningCardId
      progress
      failedAt
      completedAt
      triesCount
      formTransactional {
        ...FormTransactional
      }
    }
  }
}
    ${FormTransactionalFragmentDoc}`;
export type CreateLccFormMutationFn = Apollo.MutationFunction<CreateLccFormMutation, CreateLccFormMutationVariables>;

/**
 * __useCreateLccFormMutation__
 *
 * To run a mutation, you first call `useCreateLccFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLccFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLccFormMutation, { data, loading, error }] = useCreateLccFormMutation({
 *   variables: {
 *      learningCardId: // value for 'learningCardId'
 *      promptId: // value for 'promptId'
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useCreateLccFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateLccFormMutation, CreateLccFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLccFormMutation, CreateLccFormMutationVariables>(CreateLccFormDocument, options);
      }
export type CreateLccFormMutationHookResult = ReturnType<typeof useCreateLccFormMutation>;
export type CreateLccFormMutationResult = Apollo.MutationResult<CreateLccFormMutation>;
export type CreateLccFormMutationOptions = Apollo.BaseMutationOptions<CreateLccFormMutation, CreateLccFormMutationVariables>;
export const CreateReactionDocument = gql`
    mutation CreateReaction($objectType: ReactionObjectType!, $objectId: UUID!, $type: ReactionType!) {
  createReaction(objectType: $objectType, objectId: $objectId, type: $type) {
    ...ReactionFragment
  }
}
    ${ReactionFragmentDoc}`;
export type CreateReactionMutationFn = Apollo.MutationFunction<CreateReactionMutation, CreateReactionMutationVariables>;

/**
 * __useCreateReactionMutation__
 *
 * To run a mutation, you first call `useCreateReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReactionMutation, { data, loading, error }] = useCreateReactionMutation({
 *   variables: {
 *      objectType: // value for 'objectType'
 *      objectId: // value for 'objectId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateReactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateReactionMutation, CreateReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReactionMutation, CreateReactionMutationVariables>(CreateReactionDocument, options);
      }
export type CreateReactionMutationHookResult = ReturnType<typeof useCreateReactionMutation>;
export type CreateReactionMutationResult = Apollo.MutationResult<CreateReactionMutation>;
export type CreateReactionMutationOptions = Apollo.BaseMutationOptions<CreateReactionMutation, CreateReactionMutationVariables>;
export const DashboardDocument = gql`
    query Dashboard {
  assignments {
    nodes {
      id
      dueDate
      orderAssignedAt
      learningPlan {
        id
        externalId
        mandatory
        dueSoon
        learningPlanLocalized {
          id
          description
          learningPlanFolderName
        }
      }
      assignmentSkillCards {
        nodes {
          id
          lpCompanySectionExternalId
          skillExternalId
          companyProfileSkillId
          isLocked
          points
          progress
          skillId
          skillFlow
          pointsEarned
          completedAt
          failedAt
          repAssignmentId
          repAssignmentStatus
          repLastActivityAt
          skill {
            id
            name
            externalId
            type
            repType
            duration
            media {
              id
              mediaUrl: mediaUrlV2
            }
            skillLocalized {
              id
              language
              description
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDashboardQuery__
 *
 * To run a query within a React component, call `useDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardQuery(baseOptions?: Apollo.QueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
      }
export function useDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
        }
export type DashboardQueryHookResult = ReturnType<typeof useDashboardQuery>;
export type DashboardLazyQueryHookResult = ReturnType<typeof useDashboardLazyQuery>;
export type DashboardQueryResult = Apollo.QueryResult<DashboardQuery, DashboardQueryVariables>;
export const RemoveReactionDocument = gql`
    mutation RemoveReaction($id: UUID!) {
  removeReaction(id: $id) {
    ...ReactionFragment
  }
}
    ${ReactionFragmentDoc}`;
export type RemoveReactionMutationFn = Apollo.MutationFunction<RemoveReactionMutation, RemoveReactionMutationVariables>;

/**
 * __useRemoveReactionMutation__
 *
 * To run a mutation, you first call `useRemoveReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeReactionMutation, { data, loading, error }] = useRemoveReactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveReactionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveReactionMutation, RemoveReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveReactionMutation, RemoveReactionMutationVariables>(RemoveReactionDocument, options);
      }
export type RemoveReactionMutationHookResult = ReturnType<typeof useRemoveReactionMutation>;
export type RemoveReactionMutationResult = Apollo.MutationResult<RemoveReactionMutation>;
export type RemoveReactionMutationOptions = Apollo.BaseMutationOptions<RemoveReactionMutation, RemoveReactionMutationVariables>;
export const RemoveSkillProgressDocument = gql`
    mutation RemoveSkillProgress($skillExternalId: String!, $profileExternalId: String!) {
  deleteSkillProgress(
    skillExternalId: $skillExternalId
    profileExternalId: $profileExternalId
  ) {
    nodes {
      id
    }
  }
}
    `;
export type RemoveSkillProgressMutationFn = Apollo.MutationFunction<RemoveSkillProgressMutation, RemoveSkillProgressMutationVariables>;

/**
 * __useRemoveSkillProgressMutation__
 *
 * To run a mutation, you first call `useRemoveSkillProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSkillProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSkillProgressMutation, { data, loading, error }] = useRemoveSkillProgressMutation({
 *   variables: {
 *      skillExternalId: // value for 'skillExternalId'
 *      profileExternalId: // value for 'profileExternalId'
 *   },
 * });
 */
export function useRemoveSkillProgressMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSkillProgressMutation, RemoveSkillProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSkillProgressMutation, RemoveSkillProgressMutationVariables>(RemoveSkillProgressDocument, options);
      }
export type RemoveSkillProgressMutationHookResult = ReturnType<typeof useRemoveSkillProgressMutation>;
export type RemoveSkillProgressMutationResult = Apollo.MutationResult<RemoveSkillProgressMutation>;
export type RemoveSkillProgressMutationOptions = Apollo.BaseMutationOptions<RemoveSkillProgressMutation, RemoveSkillProgressMutationVariables>;
export const EmbeddedContextDocument = gql`
    mutation EmbeddedContext($groupExternalId: String!, $profileExternalId: String!, $companyExternalId: String!, $profileEmailAddress: String, $profilePhoneNumber: String, $memberType: String, $fullName: String, $language: Language) {
  createOrReturnUser(
    groupExternalId: $groupExternalId
    profileExternalId: $profileExternalId
    companyExternalId: $companyExternalId
    profileEmailAddress: $profileEmailAddress
    profilePhoneNumber: $profilePhoneNumber
    memberType: $memberType
    language: $language
    fullName: $fullName
  ) {
    assignments {
      assignmentSkillCards {
        nodes {
          repAssignmentId
          skill {
            id
            externalId
            type
          }
        }
      }
      learningPlan {
        id
        lpSections {
          nodes {
            externalId
          }
        }
      }
    }
  }
}
    `;
export type EmbeddedContextMutationFn = Apollo.MutationFunction<EmbeddedContextMutation, EmbeddedContextMutationVariables>;

/**
 * __useEmbeddedContextMutation__
 *
 * To run a mutation, you first call `useEmbeddedContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmbeddedContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [embeddedContextMutation, { data, loading, error }] = useEmbeddedContextMutation({
 *   variables: {
 *      groupExternalId: // value for 'groupExternalId'
 *      profileExternalId: // value for 'profileExternalId'
 *      companyExternalId: // value for 'companyExternalId'
 *      profileEmailAddress: // value for 'profileEmailAddress'
 *      profilePhoneNumber: // value for 'profilePhoneNumber'
 *      memberType: // value for 'memberType'
 *      fullName: // value for 'fullName'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useEmbeddedContextMutation(baseOptions?: Apollo.MutationHookOptions<EmbeddedContextMutation, EmbeddedContextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmbeddedContextMutation, EmbeddedContextMutationVariables>(EmbeddedContextDocument, options);
      }
export type EmbeddedContextMutationHookResult = ReturnType<typeof useEmbeddedContextMutation>;
export type EmbeddedContextMutationResult = Apollo.MutationResult<EmbeddedContextMutation>;
export type EmbeddedContextMutationOptions = Apollo.BaseMutationOptions<EmbeddedContextMutation, EmbeddedContextMutationVariables>;
export const FailCompanyProfileSkillDocument = gql`
    mutation FailCompanyProfileSkill($id: UUID!) {
  failCompanyProfileSkill(id: $id) {
    id
    failedAt
  }
}
    `;
export type FailCompanyProfileSkillMutationFn = Apollo.MutationFunction<FailCompanyProfileSkillMutation, FailCompanyProfileSkillMutationVariables>;

/**
 * __useFailCompanyProfileSkillMutation__
 *
 * To run a mutation, you first call `useFailCompanyProfileSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFailCompanyProfileSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [failCompanyProfileSkillMutation, { data, loading, error }] = useFailCompanyProfileSkillMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFailCompanyProfileSkillMutation(baseOptions?: Apollo.MutationHookOptions<FailCompanyProfileSkillMutation, FailCompanyProfileSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FailCompanyProfileSkillMutation, FailCompanyProfileSkillMutationVariables>(FailCompanyProfileSkillDocument, options);
      }
export type FailCompanyProfileSkillMutationHookResult = ReturnType<typeof useFailCompanyProfileSkillMutation>;
export type FailCompanyProfileSkillMutationResult = Apollo.MutationResult<FailCompanyProfileSkillMutation>;
export type FailCompanyProfileSkillMutationOptions = Apollo.BaseMutationOptions<FailCompanyProfileSkillMutation, FailCompanyProfileSkillMutationVariables>;
export const FormTransactionalDocument = gql`
    query FormTransactional($learningCardId: UUID!) {
  formTransactionalGet(learningCardId: $learningCardId) {
    ...FormTransactional
  }
}
    ${FormTransactionalFragmentDoc}`;

/**
 * __useFormTransactionalQuery__
 *
 * To run a query within a React component, call `useFormTransactionalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormTransactionalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormTransactionalQuery({
 *   variables: {
 *      learningCardId: // value for 'learningCardId'
 *   },
 * });
 */
export function useFormTransactionalQuery(baseOptions: Apollo.QueryHookOptions<FormTransactionalQuery, FormTransactionalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormTransactionalQuery, FormTransactionalQueryVariables>(FormTransactionalDocument, options);
      }
export function useFormTransactionalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormTransactionalQuery, FormTransactionalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormTransactionalQuery, FormTransactionalQueryVariables>(FormTransactionalDocument, options);
        }
export type FormTransactionalQueryHookResult = ReturnType<typeof useFormTransactionalQuery>;
export type FormTransactionalLazyQueryHookResult = ReturnType<typeof useFormTransactionalLazyQuery>;
export type FormTransactionalQueryResult = Apollo.QueryResult<FormTransactionalQuery, FormTransactionalQueryVariables>;
export const GetNextSkillV2Document = gql`
    query GetNextSkillV2($skillExternalId: String!) {
  companyProfileSkillGetNext(skillExternalId: $skillExternalId) {
    id
    lpCompanySectionExternalId
    skillId
    skillName
    skillExternalId
    skillType
    skillFlow
    repAssignmentId
    repType
  }
}
    `;

/**
 * __useGetNextSkillV2Query__
 *
 * To run a query within a React component, call `useGetNextSkillV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetNextSkillV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextSkillV2Query({
 *   variables: {
 *      skillExternalId: // value for 'skillExternalId'
 *   },
 * });
 */
export function useGetNextSkillV2Query(baseOptions: Apollo.QueryHookOptions<GetNextSkillV2Query, GetNextSkillV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNextSkillV2Query, GetNextSkillV2QueryVariables>(GetNextSkillV2Document, options);
      }
export function useGetNextSkillV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNextSkillV2Query, GetNextSkillV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNextSkillV2Query, GetNextSkillV2QueryVariables>(GetNextSkillV2Document, options);
        }
export type GetNextSkillV2QueryHookResult = ReturnType<typeof useGetNextSkillV2Query>;
export type GetNextSkillV2LazyQueryHookResult = ReturnType<typeof useGetNextSkillV2LazyQuery>;
export type GetNextSkillV2QueryResult = Apollo.QueryResult<GetNextSkillV2Query, GetNextSkillV2QueryVariables>;
export const GetNextSkillV3Document = gql`
    query GetNextSkillV3 {
  assignmentSkillGetNext {
    id
    companyId
    lpCompanySectionExternalId
    repAssignmentId
    status
    skill {
      id
      externalId
      type
      media {
        id
        mediaUrl: mediaUrlV2
      }
      repType
      skillLocalized {
        id
        description
      }
    }
    learningPlan {
      id
      learningPlanLocalized {
        id
        description
      }
    }
  }
}
    `;

/**
 * __useGetNextSkillV3Query__
 *
 * To run a query within a React component, call `useGetNextSkillV3Query` and pass it any options that fit your needs.
 * When your component renders, `useGetNextSkillV3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextSkillV3Query({
 *   variables: {
 *   },
 * });
 */
export function useGetNextSkillV3Query(baseOptions?: Apollo.QueryHookOptions<GetNextSkillV3Query, GetNextSkillV3QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNextSkillV3Query, GetNextSkillV3QueryVariables>(GetNextSkillV3Document, options);
      }
export function useGetNextSkillV3LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNextSkillV3Query, GetNextSkillV3QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNextSkillV3Query, GetNextSkillV3QueryVariables>(GetNextSkillV3Document, options);
        }
export type GetNextSkillV3QueryHookResult = ReturnType<typeof useGetNextSkillV3Query>;
export type GetNextSkillV3LazyQueryHookResult = ReturnType<typeof useGetNextSkillV3LazyQuery>;
export type GetNextSkillV3QueryResult = Apollo.QueryResult<GetNextSkillV3Query, GetNextSkillV3QueryVariables>;
export const GetTranscriptionMediaObjectByIdDocument = gql`
    query GetTranscriptionMediaObjectById($mediaId: String!) {
  getTranscriptionMediaObjectById(mediaId: $mediaId) {
    awsOutcome {
      jobName
      accountId
      status
      results {
        transcripts {
          transcript
          language
        }
        timeline {
          sentence
          speaker
          start_time
          end_time
        }
        speakerLabels {
          speakerId
          speakerLabel
          speakerName
          speakerRole
          speakerRoleDisplayed
          talkRatio
          isPresenter
        }
      }
    }
  }
}
    `;

/**
 * __useGetTranscriptionMediaObjectByIdQuery__
 *
 * To run a query within a React component, call `useGetTranscriptionMediaObjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranscriptionMediaObjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranscriptionMediaObjectByIdQuery({
 *   variables: {
 *      mediaId: // value for 'mediaId'
 *   },
 * });
 */
export function useGetTranscriptionMediaObjectByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTranscriptionMediaObjectByIdQuery, GetTranscriptionMediaObjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranscriptionMediaObjectByIdQuery, GetTranscriptionMediaObjectByIdQueryVariables>(GetTranscriptionMediaObjectByIdDocument, options);
      }
export function useGetTranscriptionMediaObjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranscriptionMediaObjectByIdQuery, GetTranscriptionMediaObjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranscriptionMediaObjectByIdQuery, GetTranscriptionMediaObjectByIdQueryVariables>(GetTranscriptionMediaObjectByIdDocument, options);
        }
export type GetTranscriptionMediaObjectByIdQueryHookResult = ReturnType<typeof useGetTranscriptionMediaObjectByIdQuery>;
export type GetTranscriptionMediaObjectByIdLazyQueryHookResult = ReturnType<typeof useGetTranscriptionMediaObjectByIdLazyQuery>;
export type GetTranscriptionMediaObjectByIdQueryResult = Apollo.QueryResult<GetTranscriptionMediaObjectByIdQuery, GetTranscriptionMediaObjectByIdQueryVariables>;
export const GoogleAuthVerifyDocument = gql`
    mutation GoogleAuthVerify($idToken: String!, $source: AuthenticationSource) {
  googleAuthVerify(token: $idToken, source: $source) {
    accessToken
    refreshToken
    companyProfileId
    companyExternalId
    socialPhotoUpdateStatus
    socialPhotoUpdateErrorMessage
  }
}
    `;
export type GoogleAuthVerifyMutationFn = Apollo.MutationFunction<GoogleAuthVerifyMutation, GoogleAuthVerifyMutationVariables>;

/**
 * __useGoogleAuthVerifyMutation__
 *
 * To run a mutation, you first call `useGoogleAuthVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleAuthVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleAuthVerifyMutation, { data, loading, error }] = useGoogleAuthVerifyMutation({
 *   variables: {
 *      idToken: // value for 'idToken'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useGoogleAuthVerifyMutation(baseOptions?: Apollo.MutationHookOptions<GoogleAuthVerifyMutation, GoogleAuthVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GoogleAuthVerifyMutation, GoogleAuthVerifyMutationVariables>(GoogleAuthVerifyDocument, options);
      }
export type GoogleAuthVerifyMutationHookResult = ReturnType<typeof useGoogleAuthVerifyMutation>;
export type GoogleAuthVerifyMutationResult = Apollo.MutationResult<GoogleAuthVerifyMutation>;
export type GoogleAuthVerifyMutationOptions = Apollo.BaseMutationOptions<GoogleAuthVerifyMutation, GoogleAuthVerifyMutationVariables>;
export const IsNewAuthDocument = gql`
    query IsNewAuth($email: String) {
  isNewAuth(email: $email)
}
    `;

/**
 * __useIsNewAuthQuery__
 *
 * To run a query within a React component, call `useIsNewAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsNewAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsNewAuthQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useIsNewAuthQuery(baseOptions?: Apollo.QueryHookOptions<IsNewAuthQuery, IsNewAuthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsNewAuthQuery, IsNewAuthQueryVariables>(IsNewAuthDocument, options);
      }
export function useIsNewAuthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsNewAuthQuery, IsNewAuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsNewAuthQuery, IsNewAuthQueryVariables>(IsNewAuthDocument, options);
        }
export type IsNewAuthQueryHookResult = ReturnType<typeof useIsNewAuthQuery>;
export type IsNewAuthLazyQueryHookResult = ReturnType<typeof useIsNewAuthLazyQuery>;
export type IsNewAuthQueryResult = Apollo.QueryResult<IsNewAuthQuery, IsNewAuthQueryVariables>;
export const LeaderboardDocument = gql`
    query Leaderboard {
  leaderboard {
    totalAssignments
    completedAssignments
    score
    position
    scores
  }
}
    `;

/**
 * __useLeaderboardQuery__
 *
 * To run a query within a React component, call `useLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaderboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeaderboardQuery(baseOptions?: Apollo.QueryHookOptions<LeaderboardQuery, LeaderboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaderboardQuery, LeaderboardQueryVariables>(LeaderboardDocument, options);
      }
export function useLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaderboardQuery, LeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaderboardQuery, LeaderboardQueryVariables>(LeaderboardDocument, options);
        }
export type LeaderboardQueryHookResult = ReturnType<typeof useLeaderboardQuery>;
export type LeaderboardLazyQueryHookResult = ReturnType<typeof useLeaderboardLazyQuery>;
export type LeaderboardQueryResult = Apollo.QueryResult<LeaderboardQuery, LeaderboardQueryVariables>;
export const LeaderboardV2Document = gql`
    query LeaderboardV2 {
  leaderboardV2 {
    leaderBoards {
      groupName
      groupScores {
        rowIconURL
        rowName
        rowScore
      }
    }
  }
}
    `;

/**
 * __useLeaderboardV2Query__
 *
 * To run a query within a React component, call `useLeaderboardV2Query` and pass it any options that fit your needs.
 * When your component renders, `useLeaderboardV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaderboardV2Query({
 *   variables: {
 *   },
 * });
 */
export function useLeaderboardV2Query(baseOptions?: Apollo.QueryHookOptions<LeaderboardV2Query, LeaderboardV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaderboardV2Query, LeaderboardV2QueryVariables>(LeaderboardV2Document, options);
      }
export function useLeaderboardV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaderboardV2Query, LeaderboardV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaderboardV2Query, LeaderboardV2QueryVariables>(LeaderboardV2Document, options);
        }
export type LeaderboardV2QueryHookResult = ReturnType<typeof useLeaderboardV2Query>;
export type LeaderboardV2LazyQueryHookResult = ReturnType<typeof useLeaderboardV2LazyQuery>;
export type LeaderboardV2QueryResult = Apollo.QueryResult<LeaderboardV2Query, LeaderboardV2QueryVariables>;
export const LeaderboardV3Document = gql`
    query LeaderboardV3 {
  leaderboardV3 {
    leaderBoard {
      groupScores {
        rowIconURL
        rowName
        rowScore
      }
      name
      iconURL
      score: score
      position
    }
  }
}
    `;

/**
 * __useLeaderboardV3Query__
 *
 * To run a query within a React component, call `useLeaderboardV3Query` and pass it any options that fit your needs.
 * When your component renders, `useLeaderboardV3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaderboardV3Query({
 *   variables: {
 *   },
 * });
 */
export function useLeaderboardV3Query(baseOptions?: Apollo.QueryHookOptions<LeaderboardV3Query, LeaderboardV3QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaderboardV3Query, LeaderboardV3QueryVariables>(LeaderboardV3Document, options);
      }
export function useLeaderboardV3LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaderboardV3Query, LeaderboardV3QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaderboardV3Query, LeaderboardV3QueryVariables>(LeaderboardV3Document, options);
        }
export type LeaderboardV3QueryHookResult = ReturnType<typeof useLeaderboardV3Query>;
export type LeaderboardV3LazyQueryHookResult = ReturnType<typeof useLeaderboardV3LazyQuery>;
export type LeaderboardV3QueryResult = Apollo.QueryResult<LeaderboardV3Query, LeaderboardV3QueryVariables>;
export const LearningPlanAssignmentDocument = gql`
    mutation LearningPlanAssignment($profileExternalId: String!, $companyExternalId: String!, $learningPlanExternalId: String!, $profileEmailAddress: String, $profilePhoneNumber: String) {
  learningPlanAssignment(
    profileExternalId: $profileExternalId
    companyExternalId: $companyExternalId
    learningPlanExternalId: $learningPlanExternalId
    profileEmailAddress: $profileEmailAddress
    profilePhoneNumber: $profilePhoneNumber
  ) {
    success
    details {
      skillExternalId
      success
      details
    }
  }
}
    `;
export type LearningPlanAssignmentMutationFn = Apollo.MutationFunction<LearningPlanAssignmentMutation, LearningPlanAssignmentMutationVariables>;

/**
 * __useLearningPlanAssignmentMutation__
 *
 * To run a mutation, you first call `useLearningPlanAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearningPlanAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learningPlanAssignmentMutation, { data, loading, error }] = useLearningPlanAssignmentMutation({
 *   variables: {
 *      profileExternalId: // value for 'profileExternalId'
 *      companyExternalId: // value for 'companyExternalId'
 *      learningPlanExternalId: // value for 'learningPlanExternalId'
 *      profileEmailAddress: // value for 'profileEmailAddress'
 *      profilePhoneNumber: // value for 'profilePhoneNumber'
 *   },
 * });
 */
export function useLearningPlanAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<LearningPlanAssignmentMutation, LearningPlanAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearningPlanAssignmentMutation, LearningPlanAssignmentMutationVariables>(LearningPlanAssignmentDocument, options);
      }
export type LearningPlanAssignmentMutationHookResult = ReturnType<typeof useLearningPlanAssignmentMutation>;
export type LearningPlanAssignmentMutationResult = Apollo.MutationResult<LearningPlanAssignmentMutation>;
export type LearningPlanAssignmentMutationOptions = Apollo.BaseMutationOptions<LearningPlanAssignmentMutation, LearningPlanAssignmentMutationVariables>;
export const MeDocument = gql`
    query Me($appName: String, $appVersion: String, $browserName: String, $browserVersion: String, $osName: String, $osVersion: String, $platform: String, $platformType: String, $platformVendor: String, $platformModel: String) {
  meV2 {
    id
    externalId
    companyId
    isCoach
    language
    emailAddress
    phoneNumber
    score
    excludeFromAnalytics
    hasCoachedReps
    hasSocialReps
    profile {
      id
      preferredName
      displayName
      createdAt
      acceptedLegal
      enabledFeatures
      isSuperuser
      ...ProfilePhotoFragment
      flags(
        appName: $appName
        appVersion: $appVersion
        browserName: $browserName
        browserVersion: $browserVersion
        osName: $osName
        osVersion: $osVersion
        platform: $platform
        platformType: $platformType
        platformVendor: $platformVendor
        platformModel: $platformModel
      ) {
        name
        value
      }
      workspaces {
        nodes {
          ...WorkspaceFragment
        }
      }
    }
    company {
      id
      externalId
      defaultLanguage
      displayName
      name
      logoMedia {
        id
        path: mediaUrlV2
      }
      companyLanguages {
        nodes {
          id
          language
        }
      }
    }
  }
}
    ${ProfilePhotoFragmentDoc}
${WorkspaceFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *      appName: // value for 'appName'
 *      appVersion: // value for 'appVersion'
 *      browserName: // value for 'browserName'
 *      browserVersion: // value for 'browserVersion'
 *      osName: // value for 'osName'
 *      osVersion: // value for 'osVersion'
 *      platform: // value for 'platform'
 *      platformType: // value for 'platformType'
 *      platformVendor: // value for 'platformVendor'
 *      platformModel: // value for 'platformModel'
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const ProScoreDocument = gql`
    query ProScore {
  proScoreGetV3 {
    ...ProScoreFragment
  }
}
    ${ProScoreFragmentDoc}`;

/**
 * __useProScoreQuery__
 *
 * To run a query within a React component, call `useProScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useProScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProScoreQuery({
 *   variables: {
 *   },
 * });
 */
export function useProScoreQuery(baseOptions?: Apollo.QueryHookOptions<ProScoreQuery, ProScoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProScoreQuery, ProScoreQueryVariables>(ProScoreDocument, options);
      }
export function useProScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProScoreQuery, ProScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProScoreQuery, ProScoreQueryVariables>(ProScoreDocument, options);
        }
export type ProScoreQueryHookResult = ReturnType<typeof useProScoreQuery>;
export type ProScoreLazyQueryHookResult = ReturnType<typeof useProScoreLazyQuery>;
export type ProScoreQueryResult = Apollo.QueryResult<ProScoreQuery, ProScoreQueryVariables>;
export const ProfilePhotoEditDocument = gql`
    mutation ProfilePhotoEdit($photoUrl: String) {
  profilePhotoEdit(photoUrl: $photoUrl) {
    id
    ...ProfilePhotoFragment
  }
}
    ${ProfilePhotoFragmentDoc}`;
export type ProfilePhotoEditMutationFn = Apollo.MutationFunction<ProfilePhotoEditMutation, ProfilePhotoEditMutationVariables>;

/**
 * __useProfilePhotoEditMutation__
 *
 * To run a mutation, you first call `useProfilePhotoEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfilePhotoEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profilePhotoEditMutation, { data, loading, error }] = useProfilePhotoEditMutation({
 *   variables: {
 *      photoUrl: // value for 'photoUrl'
 *   },
 * });
 */
export function useProfilePhotoEditMutation(baseOptions?: Apollo.MutationHookOptions<ProfilePhotoEditMutation, ProfilePhotoEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfilePhotoEditMutation, ProfilePhotoEditMutationVariables>(ProfilePhotoEditDocument, options);
      }
export type ProfilePhotoEditMutationHookResult = ReturnType<typeof useProfilePhotoEditMutation>;
export type ProfilePhotoEditMutationResult = Apollo.MutationResult<ProfilePhotoEditMutation>;
export type ProfilePhotoEditMutationOptions = Apollo.BaseMutationOptions<ProfilePhotoEditMutation, ProfilePhotoEditMutationVariables>;
export const ProfileSearchFilteredByGroupDocument = gql`
    query ProfileSearchFilteredByGroup($paginate: BaseClassicPaginate, $conditions: CompanyProfileSearchFilteredByGroupConditions) {
  profileSearchFilteredByGroup(paginate: $paginate, conditions: $conditions) {
    nodes {
      id
      emailAddress
      phoneNumber
      profile {
        id
        displayName
        preferredName
        media {
          id
          mediaUrl: mediaUrlV2
        }
      }
    }
  }
}
    `;

/**
 * __useProfileSearchFilteredByGroupQuery__
 *
 * To run a query within a React component, call `useProfileSearchFilteredByGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileSearchFilteredByGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileSearchFilteredByGroupQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useProfileSearchFilteredByGroupQuery(baseOptions?: Apollo.QueryHookOptions<ProfileSearchFilteredByGroupQuery, ProfileSearchFilteredByGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileSearchFilteredByGroupQuery, ProfileSearchFilteredByGroupQueryVariables>(ProfileSearchFilteredByGroupDocument, options);
      }
export function useProfileSearchFilteredByGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileSearchFilteredByGroupQuery, ProfileSearchFilteredByGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileSearchFilteredByGroupQuery, ProfileSearchFilteredByGroupQueryVariables>(ProfileSearchFilteredByGroupDocument, options);
        }
export type ProfileSearchFilteredByGroupQueryHookResult = ReturnType<typeof useProfileSearchFilteredByGroupQuery>;
export type ProfileSearchFilteredByGroupLazyQueryHookResult = ReturnType<typeof useProfileSearchFilteredByGroupLazyQuery>;
export type ProfileSearchFilteredByGroupQueryResult = Apollo.QueryResult<ProfileSearchFilteredByGroupQuery, ProfileSearchFilteredByGroupQueryVariables>;
export const RepPromptSearchWithoutFilterQueryDocument = gql`
    query RepPromptSearchWithoutFilterQuery($paginate: BaseClassicPaginate, $conditions: RepPromptSearchWithoutFilterCondition) {
  repPromptSearchSocial(paginate: $paginate, conditions: $conditions) {
    nodes {
      id
      skillName
      skillLocalizedName
    }
  }
}
    `;

/**
 * __useRepPromptSearchWithoutFilterQuery__
 *
 * To run a query within a React component, call `useRepPromptSearchWithoutFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepPromptSearchWithoutFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepPromptSearchWithoutFilterQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useRepPromptSearchWithoutFilterQuery(baseOptions?: Apollo.QueryHookOptions<RepPromptSearchWithoutFilterQuery, RepPromptSearchWithoutFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepPromptSearchWithoutFilterQuery, RepPromptSearchWithoutFilterQueryVariables>(RepPromptSearchWithoutFilterQueryDocument, options);
      }
export function useRepPromptSearchWithoutFilterQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepPromptSearchWithoutFilterQuery, RepPromptSearchWithoutFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepPromptSearchWithoutFilterQuery, RepPromptSearchWithoutFilterQueryVariables>(RepPromptSearchWithoutFilterQueryDocument, options);
        }
export type RepPromptSearchWithoutFilterQueryHookResult = ReturnType<typeof useRepPromptSearchWithoutFilterQuery>;
export type RepPromptSearchWithoutFilterQueryLazyQueryHookResult = ReturnType<typeof useRepPromptSearchWithoutFilterQueryLazyQuery>;
export type RepPromptSearchWithoutFilterQueryQueryResult = Apollo.QueryResult<RepPromptSearchWithoutFilterQuery, RepPromptSearchWithoutFilterQueryVariables>;
export const RepPromptSearchFilteredByCoachRepAssignmentsDocument = gql`
    query RepPromptSearchFilteredByCoachRepAssignments($paginate: BaseClassicPaginate, $conditions: RepPromptSearchFilteredByCoachRepAssignmentsConditions) {
  repPromptSearchFilteredByCoachRepAssignments(
    paginate: $paginate
    conditions: $conditions
  ) {
    nodes {
      id
      skillName
      skillLocalizedName
    }
  }
}
    `;

/**
 * __useRepPromptSearchFilteredByCoachRepAssignmentsQuery__
 *
 * To run a query within a React component, call `useRepPromptSearchFilteredByCoachRepAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepPromptSearchFilteredByCoachRepAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepPromptSearchFilteredByCoachRepAssignmentsQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useRepPromptSearchFilteredByCoachRepAssignmentsQuery(baseOptions?: Apollo.QueryHookOptions<RepPromptSearchFilteredByCoachRepAssignmentsQuery, RepPromptSearchFilteredByCoachRepAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepPromptSearchFilteredByCoachRepAssignmentsQuery, RepPromptSearchFilteredByCoachRepAssignmentsQueryVariables>(RepPromptSearchFilteredByCoachRepAssignmentsDocument, options);
      }
export function useRepPromptSearchFilteredByCoachRepAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepPromptSearchFilteredByCoachRepAssignmentsQuery, RepPromptSearchFilteredByCoachRepAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepPromptSearchFilteredByCoachRepAssignmentsQuery, RepPromptSearchFilteredByCoachRepAssignmentsQueryVariables>(RepPromptSearchFilteredByCoachRepAssignmentsDocument, options);
        }
export type RepPromptSearchFilteredByCoachRepAssignmentsQueryHookResult = ReturnType<typeof useRepPromptSearchFilteredByCoachRepAssignmentsQuery>;
export type RepPromptSearchFilteredByCoachRepAssignmentsLazyQueryHookResult = ReturnType<typeof useRepPromptSearchFilteredByCoachRepAssignmentsLazyQuery>;
export type RepPromptSearchFilteredByCoachRepAssignmentsQueryResult = Apollo.QueryResult<RepPromptSearchFilteredByCoachRepAssignmentsQuery, RepPromptSearchFilteredByCoachRepAssignmentsQueryVariables>;
export const RepSubmissionFinalizeMultipartUploadDocument = gql`
    mutation RepSubmissionFinalizeMultipartUpload($mediaId: UUID!, $fileId: String!, $fileKey: String!, $parts: [FinalizeMultipartUploadPart!]!) {
  repSubmissionFinalizeMultipartUpload(
    mediaId: $mediaId
    fileId: $fileId
    fileKey: $fileKey
    parts: $parts
  ) {
    id
    mimeType
    location
    playbackId: path
    mediaUrl: mediaUrlV2
  }
}
    `;
export type RepSubmissionFinalizeMultipartUploadMutationFn = Apollo.MutationFunction<RepSubmissionFinalizeMultipartUploadMutation, RepSubmissionFinalizeMultipartUploadMutationVariables>;

/**
 * __useRepSubmissionFinalizeMultipartUploadMutation__
 *
 * To run a mutation, you first call `useRepSubmissionFinalizeMultipartUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRepSubmissionFinalizeMultipartUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [repSubmissionFinalizeMultipartUploadMutation, { data, loading, error }] = useRepSubmissionFinalizeMultipartUploadMutation({
 *   variables: {
 *      mediaId: // value for 'mediaId'
 *      fileId: // value for 'fileId'
 *      fileKey: // value for 'fileKey'
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useRepSubmissionFinalizeMultipartUploadMutation(baseOptions?: Apollo.MutationHookOptions<RepSubmissionFinalizeMultipartUploadMutation, RepSubmissionFinalizeMultipartUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RepSubmissionFinalizeMultipartUploadMutation, RepSubmissionFinalizeMultipartUploadMutationVariables>(RepSubmissionFinalizeMultipartUploadDocument, options);
      }
export type RepSubmissionFinalizeMultipartUploadMutationHookResult = ReturnType<typeof useRepSubmissionFinalizeMultipartUploadMutation>;
export type RepSubmissionFinalizeMultipartUploadMutationResult = Apollo.MutationResult<RepSubmissionFinalizeMultipartUploadMutation>;
export type RepSubmissionFinalizeMultipartUploadMutationOptions = Apollo.BaseMutationOptions<RepSubmissionFinalizeMultipartUploadMutation, RepSubmissionFinalizeMultipartUploadMutationVariables>;
export const RepSubmissionGetMultipartUploadDataDocument = gql`
    mutation RepSubmissionGetMultipartUploadData($mimeType: String!, $mediaType: MediaType!, $fileSize: Int!, $numberOfParts: Int!) {
  repSubmissionGetMultipartUploadData(
    mimeType: $mimeType
    mediaType: $mediaType
    fileSize: $fileSize
    numberOfParts: $numberOfParts
  ) {
    mediaId
    fileId
    fileKey
    parts {
      partNumber
      signedUrl
    }
  }
}
    `;
export type RepSubmissionGetMultipartUploadDataMutationFn = Apollo.MutationFunction<RepSubmissionGetMultipartUploadDataMutation, RepSubmissionGetMultipartUploadDataMutationVariables>;

/**
 * __useRepSubmissionGetMultipartUploadDataMutation__
 *
 * To run a mutation, you first call `useRepSubmissionGetMultipartUploadDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRepSubmissionGetMultipartUploadDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [repSubmissionGetMultipartUploadDataMutation, { data, loading, error }] = useRepSubmissionGetMultipartUploadDataMutation({
 *   variables: {
 *      mimeType: // value for 'mimeType'
 *      mediaType: // value for 'mediaType'
 *      fileSize: // value for 'fileSize'
 *      numberOfParts: // value for 'numberOfParts'
 *   },
 * });
 */
export function useRepSubmissionGetMultipartUploadDataMutation(baseOptions?: Apollo.MutationHookOptions<RepSubmissionGetMultipartUploadDataMutation, RepSubmissionGetMultipartUploadDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RepSubmissionGetMultipartUploadDataMutation, RepSubmissionGetMultipartUploadDataMutationVariables>(RepSubmissionGetMultipartUploadDataDocument, options);
      }
export type RepSubmissionGetMultipartUploadDataMutationHookResult = ReturnType<typeof useRepSubmissionGetMultipartUploadDataMutation>;
export type RepSubmissionGetMultipartUploadDataMutationResult = Apollo.MutationResult<RepSubmissionGetMultipartUploadDataMutation>;
export type RepSubmissionGetMultipartUploadDataMutationOptions = Apollo.BaseMutationOptions<RepSubmissionGetMultipartUploadDataMutation, RepSubmissionGetMultipartUploadDataMutationVariables>;
export const ResetLearningPlanProgressDocument = gql`
    mutation ResetLearningPlanProgress($resetLearningPlanProgressInput: ResetLearningPlanProgressInput!) {
  resetLearningPlanProgress(
    resetLearningPlanProgressInput: $resetLearningPlanProgressInput
  ) {
    id
    assignmentSkillCards {
      nodes {
        skill {
          externalId
          id
          type
        }
        repAssignmentId
      }
    }
  }
}
    `;
export type ResetLearningPlanProgressMutationFn = Apollo.MutationFunction<ResetLearningPlanProgressMutation, ResetLearningPlanProgressMutationVariables>;

/**
 * __useResetLearningPlanProgressMutation__
 *
 * To run a mutation, you first call `useResetLearningPlanProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetLearningPlanProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetLearningPlanProgressMutation, { data, loading, error }] = useResetLearningPlanProgressMutation({
 *   variables: {
 *      resetLearningPlanProgressInput: // value for 'resetLearningPlanProgressInput'
 *   },
 * });
 */
export function useResetLearningPlanProgressMutation(baseOptions?: Apollo.MutationHookOptions<ResetLearningPlanProgressMutation, ResetLearningPlanProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetLearningPlanProgressMutation, ResetLearningPlanProgressMutationVariables>(ResetLearningPlanProgressDocument, options);
      }
export type ResetLearningPlanProgressMutationHookResult = ReturnType<typeof useResetLearningPlanProgressMutation>;
export type ResetLearningPlanProgressMutationResult = Apollo.MutationResult<ResetLearningPlanProgressMutation>;
export type ResetLearningPlanProgressMutationOptions = Apollo.BaseMutationOptions<ResetLearningPlanProgressMutation, ResetLearningPlanProgressMutationVariables>;
export const RetryLccFormDocument = gql`
    mutation RetryLCCForm($learningCardId: UUID!) {
  learningCardCompletionRetry(learningCardId: $learningCardId) {
    id
    learningCardId
    progress
    createdAt
    startedAt
    failedAt
    completedAt
    learningCardCompletionFormSummary {
      nodes {
        id
        promptId
        isFailed
        submittedAt
        learningCardCompletionFormAnswersSummary {
          nodes {
            id
            learningCardCompletionFormId
            isFailed
            choiceId
            answer
          }
        }
      }
    }
  }
}
    `;
export type RetryLccFormMutationFn = Apollo.MutationFunction<RetryLccFormMutation, RetryLccFormMutationVariables>;

/**
 * __useRetryLccFormMutation__
 *
 * To run a mutation, you first call `useRetryLccFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryLccFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryLccFormMutation, { data, loading, error }] = useRetryLccFormMutation({
 *   variables: {
 *      learningCardId: // value for 'learningCardId'
 *   },
 * });
 */
export function useRetryLccFormMutation(baseOptions?: Apollo.MutationHookOptions<RetryLccFormMutation, RetryLccFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryLccFormMutation, RetryLccFormMutationVariables>(RetryLccFormDocument, options);
      }
export type RetryLccFormMutationHookResult = ReturnType<typeof useRetryLccFormMutation>;
export type RetryLccFormMutationResult = Apollo.MutationResult<RetryLccFormMutation>;
export type RetryLccFormMutationOptions = Apollo.BaseMutationOptions<RetryLccFormMutation, RetryLccFormMutationVariables>;
export const SearchQueryDocument = gql`
    query SearchQuery {
  assignments {
    nodes {
      id
      learningPlan {
        lpSections {
          nodes {
            externalId
            lpSectionSkills {
              nodes {
                skill {
                  type
                  id
                  name
                  externalId
                  skillLocalized {
                    id
                    description
                  }
                  skillSkillSection {
                    nodes {
                      learningCards {
                        nodes {
                          id
                          learningCardLocalized {
                            ... on LearningCardLocalizedFlashCard {
                              id
                              title
                            }
                            ... on LearningCardLocalizedVideo {
                              id
                              title
                            }
                            ... on LearningCardLocalizedFile {
                              id
                              title
                            }
                            ... on LearningCardLocalizedLinkout {
                              id
                              title
                              description
                            }
                            ... on LearningCardForm {
                              id
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  transactional: assignments {
    nodes {
      id
      isLocked
      assignmentSkills {
        nodes {
          id
          isLocked
          companyProfileSkill {
            skillId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchQuery(baseOptions?: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchQueryDocument, options);
      }
export function useSearchQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchQueryDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchQueryLazyQueryHookResult = ReturnType<typeof useSearchQueryLazyQuery>;
export type SearchQueryQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const SkillConfigDocument = gql`
    query SkillConfig($skillExternalId: String!, $lpCompanySectionExternalId: String!) {
  skill(skillExternalId: $skillExternalId) {
    id
    name
    flow
    externalId
    photoUrl
    duration
    skillLocalized {
      id
      description
    }
    media {
      id
      mediaUrl: mediaUrlV2
    }
    skillSkillSection {
      nodes {
        id
        skillId
        skillSectionId
        position
        skillSection {
          id
          name
          skillSectionLocalized {
            id
            description
            language
          }
        }
        learningCards {
          nodes {
            ...LearningCard
          }
        }
      }
    }
    lpSectionSkill(lpCompanySectionExternalId: $lpCompanySectionExternalId) {
      id
      points
      lpSection {
        id
        learningPlan {
          id
          learningPlanLocalized {
            id
            description
          }
        }
      }
    }
  }
}
    ${LearningCardFragmentDoc}`;

/**
 * __useSkillConfigQuery__
 *
 * To run a query within a React component, call `useSkillConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillConfigQuery({
 *   variables: {
 *      skillExternalId: // value for 'skillExternalId'
 *      lpCompanySectionExternalId: // value for 'lpCompanySectionExternalId'
 *   },
 * });
 */
export function useSkillConfigQuery(baseOptions: Apollo.QueryHookOptions<SkillConfigQuery, SkillConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillConfigQuery, SkillConfigQueryVariables>(SkillConfigDocument, options);
      }
export function useSkillConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillConfigQuery, SkillConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillConfigQuery, SkillConfigQueryVariables>(SkillConfigDocument, options);
        }
export type SkillConfigQueryHookResult = ReturnType<typeof useSkillConfigQuery>;
export type SkillConfigLazyQueryHookResult = ReturnType<typeof useSkillConfigLazyQuery>;
export type SkillConfigQueryResult = Apollo.QueryResult<SkillConfigQuery, SkillConfigQueryVariables>;
export const SkillTransactionalDocument = gql`
    query SkillTransactional($skillExternalId: String!) {
  companyProfileSkill(skillExternalId: $skillExternalId) {
    id
    skillId
    companyProfileId
    type
    completedAt
    failedAt
    pointsEarned
    progress
    companyProfile {
      externalId
    }
    feedback {
      ...Feedback
    }
    repAssignment {
      id
      repPromptId
    }
    learningCardAssignmentCompletions {
      nodes {
        ...LearningCardAssignmentCompletions
        feedback {
          ...Feedback
        }
      }
    }
  }
}
    ${FeedbackFragmentDoc}
${LearningCardAssignmentCompletionsFragmentDoc}`;

/**
 * __useSkillTransactionalQuery__
 *
 * To run a query within a React component, call `useSkillTransactionalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillTransactionalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillTransactionalQuery({
 *   variables: {
 *      skillExternalId: // value for 'skillExternalId'
 *   },
 * });
 */
export function useSkillTransactionalQuery(baseOptions: Apollo.QueryHookOptions<SkillTransactionalQuery, SkillTransactionalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillTransactionalQuery, SkillTransactionalQueryVariables>(SkillTransactionalDocument, options);
      }
export function useSkillTransactionalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillTransactionalQuery, SkillTransactionalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillTransactionalQuery, SkillTransactionalQueryVariables>(SkillTransactionalDocument, options);
        }
export type SkillTransactionalQueryHookResult = ReturnType<typeof useSkillTransactionalQuery>;
export type SkillTransactionalLazyQueryHookResult = ReturnType<typeof useSkillTransactionalLazyQuery>;
export type SkillTransactionalQueryResult = Apollo.QueryResult<SkillTransactionalQuery, SkillTransactionalQueryVariables>;
export const SocialRepSubmissionContentEditDocument = gql`
    mutation SocialRepSubmissionContentEdit($repSubmissionId: UUID!, $content: String!) {
  socialRepSubmissionContentEdit(
    repSubmissionId: $repSubmissionId
    content: $content
  ) {
    title
    id
    createdAt
    content
    caption
    transformedMediaUrl
    repAssignmentId
  }
}
    `;
export type SocialRepSubmissionContentEditMutationFn = Apollo.MutationFunction<SocialRepSubmissionContentEditMutation, SocialRepSubmissionContentEditMutationVariables>;

/**
 * __useSocialRepSubmissionContentEditMutation__
 *
 * To run a mutation, you first call `useSocialRepSubmissionContentEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialRepSubmissionContentEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialRepSubmissionContentEditMutation, { data, loading, error }] = useSocialRepSubmissionContentEditMutation({
 *   variables: {
 *      repSubmissionId: // value for 'repSubmissionId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useSocialRepSubmissionContentEditMutation(baseOptions?: Apollo.MutationHookOptions<SocialRepSubmissionContentEditMutation, SocialRepSubmissionContentEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SocialRepSubmissionContentEditMutation, SocialRepSubmissionContentEditMutationVariables>(SocialRepSubmissionContentEditDocument, options);
      }
export type SocialRepSubmissionContentEditMutationHookResult = ReturnType<typeof useSocialRepSubmissionContentEditMutation>;
export type SocialRepSubmissionContentEditMutationResult = Apollo.MutationResult<SocialRepSubmissionContentEditMutation>;
export type SocialRepSubmissionContentEditMutationOptions = Apollo.BaseMutationOptions<SocialRepSubmissionContentEditMutation, SocialRepSubmissionContentEditMutationVariables>;
export const SocialRepSubmissionDeleteDocument = gql`
    mutation SocialRepSubmissionDelete($repSubmissionId: UUID!) {
  socialRepSubmissionDelete(repSubmissionId: $repSubmissionId) {
    id
    repAssignmentStatus
  }
}
    `;
export type SocialRepSubmissionDeleteMutationFn = Apollo.MutationFunction<SocialRepSubmissionDeleteMutation, SocialRepSubmissionDeleteMutationVariables>;

/**
 * __useSocialRepSubmissionDeleteMutation__
 *
 * To run a mutation, you first call `useSocialRepSubmissionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialRepSubmissionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialRepSubmissionDeleteMutation, { data, loading, error }] = useSocialRepSubmissionDeleteMutation({
 *   variables: {
 *      repSubmissionId: // value for 'repSubmissionId'
 *   },
 * });
 */
export function useSocialRepSubmissionDeleteMutation(baseOptions?: Apollo.MutationHookOptions<SocialRepSubmissionDeleteMutation, SocialRepSubmissionDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SocialRepSubmissionDeleteMutation, SocialRepSubmissionDeleteMutationVariables>(SocialRepSubmissionDeleteDocument, options);
      }
export type SocialRepSubmissionDeleteMutationHookResult = ReturnType<typeof useSocialRepSubmissionDeleteMutation>;
export type SocialRepSubmissionDeleteMutationResult = Apollo.MutationResult<SocialRepSubmissionDeleteMutation>;
export type SocialRepSubmissionDeleteMutationOptions = Apollo.BaseMutationOptions<SocialRepSubmissionDeleteMutation, SocialRepSubmissionDeleteMutationVariables>;
export const RepSubmissionSubmitToCoachDocument = gql`
    mutation RepSubmissionSubmitToCoach($repSubmissionId: UUID!) {
  repSubmissionSubmitToCoach(repSubmissionId: $repSubmissionId) {
    id
  }
}
    `;
export type RepSubmissionSubmitToCoachMutationFn = Apollo.MutationFunction<RepSubmissionSubmitToCoachMutation, RepSubmissionSubmitToCoachMutationVariables>;

/**
 * __useRepSubmissionSubmitToCoachMutation__
 *
 * To run a mutation, you first call `useRepSubmissionSubmitToCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRepSubmissionSubmitToCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [repSubmissionSubmitToCoachMutation, { data, loading, error }] = useRepSubmissionSubmitToCoachMutation({
 *   variables: {
 *      repSubmissionId: // value for 'repSubmissionId'
 *   },
 * });
 */
export function useRepSubmissionSubmitToCoachMutation(baseOptions?: Apollo.MutationHookOptions<RepSubmissionSubmitToCoachMutation, RepSubmissionSubmitToCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RepSubmissionSubmitToCoachMutation, RepSubmissionSubmitToCoachMutationVariables>(RepSubmissionSubmitToCoachDocument, options);
      }
export type RepSubmissionSubmitToCoachMutationHookResult = ReturnType<typeof useRepSubmissionSubmitToCoachMutation>;
export type RepSubmissionSubmitToCoachMutationResult = Apollo.MutationResult<RepSubmissionSubmitToCoachMutation>;
export type RepSubmissionSubmitToCoachMutationOptions = Apollo.BaseMutationOptions<RepSubmissionSubmitToCoachMutation, RepSubmissionSubmitToCoachMutationVariables>;
export const TodaysPracticeDocument = gql`
    query TodaysPractice {
  todaysPractice {
    nodes {
      id
      dueDate
      lpCompanySectionExternalId
      skillExternalId
      companyProfileSkillId
      points
      progress
      skillId
      skillFlow
      pointsEarned
      repAssignmentId
      repAssignmentStatus
      countOfLearningCards
      countOfLearningCardsAssignmentCompletions
      learningPlan {
        name
        mandatory
        learningPlanLocalized {
          learningPlanFolderName
          description
        }
      }
      skill {
        id
        name
        externalId
        type
        repType
        media {
          mediaUrl: mediaUrlV2
        }
        skillLocalized {
          language
          description
        }
      }
    }
  }
}
    `;

/**
 * __useTodaysPracticeQuery__
 *
 * To run a query within a React component, call `useTodaysPracticeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTodaysPracticeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTodaysPracticeQuery({
 *   variables: {
 *   },
 * });
 */
export function useTodaysPracticeQuery(baseOptions?: Apollo.QueryHookOptions<TodaysPracticeQuery, TodaysPracticeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TodaysPracticeQuery, TodaysPracticeQueryVariables>(TodaysPracticeDocument, options);
      }
export function useTodaysPracticeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TodaysPracticeQuery, TodaysPracticeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TodaysPracticeQuery, TodaysPracticeQueryVariables>(TodaysPracticeDocument, options);
        }
export type TodaysPracticeQueryHookResult = ReturnType<typeof useTodaysPracticeQuery>;
export type TodaysPracticeLazyQueryHookResult = ReturnType<typeof useTodaysPracticeLazyQuery>;
export type TodaysPracticeQueryResult = Apollo.QueryResult<TodaysPracticeQuery, TodaysPracticeQueryVariables>;
export const TopicDetailsDocument = gql`
    query TopicDetails($conditions: TopicConditions) {
  topicsPaginated(conditions: $conditions) {
    nodes {
      ...TopicFragment
      assignmentSkillCards {
        nodes {
          ...AssignmentSkillCardFragment
        }
        __typename
      }
    }
  }
}
    ${TopicFragmentDoc}
${AssignmentSkillCardFragmentDoc}`;

/**
 * __useTopicDetailsQuery__
 *
 * To run a query within a React component, call `useTopicDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicDetailsQuery({
 *   variables: {
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useTopicDetailsQuery(baseOptions?: Apollo.QueryHookOptions<TopicDetailsQuery, TopicDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopicDetailsQuery, TopicDetailsQueryVariables>(TopicDetailsDocument, options);
      }
export function useTopicDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopicDetailsQuery, TopicDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopicDetailsQuery, TopicDetailsQueryVariables>(TopicDetailsDocument, options);
        }
export type TopicDetailsQueryHookResult = ReturnType<typeof useTopicDetailsQuery>;
export type TopicDetailsLazyQueryHookResult = ReturnType<typeof useTopicDetailsLazyQuery>;
export type TopicDetailsQueryResult = Apollo.QueryResult<TopicDetailsQuery, TopicDetailsQueryVariables>;
export const TopicsListDocument = gql`
    query TopicsList($paginate: BaseClassicPaginate) {
  topicsPaginated(paginate: $paginate) {
    nodes {
      ...TopicFragment
    }
    pageInfo {
      afterCursor
      beforeCursor
    }
    totalCount
  }
}
    ${TopicFragmentDoc}`;

/**
 * __useTopicsListQuery__
 *
 * To run a query within a React component, call `useTopicsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicsListQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *   },
 * });
 */
export function useTopicsListQuery(baseOptions?: Apollo.QueryHookOptions<TopicsListQuery, TopicsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopicsListQuery, TopicsListQueryVariables>(TopicsListDocument, options);
      }
export function useTopicsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopicsListQuery, TopicsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopicsListQuery, TopicsListQueryVariables>(TopicsListDocument, options);
        }
export type TopicsListQueryHookResult = ReturnType<typeof useTopicsListQuery>;
export type TopicsListLazyQueryHookResult = ReturnType<typeof useTopicsListLazyQuery>;
export type TopicsListQueryResult = Apollo.QueryResult<TopicsListQuery, TopicsListQueryVariables>;
export const UpdateOrCreateFeedbackDocument = gql`
    mutation UpdateOrCreateFeedback($id: UUID, $objectType: FeedbackObjectType!, $objectId: UUID!, $ratingType: FeedbackRatingType!, $rating: Int, $response: String) {
  updateOrCreateFeedback(
    id: $id
    objectType: $objectType
    objectId: $objectId
    ratingType: $ratingType
    rating: $rating
    response: $response
  ) {
    id
    rating
    response
    objectType
  }
}
    `;
export type UpdateOrCreateFeedbackMutationFn = Apollo.MutationFunction<UpdateOrCreateFeedbackMutation, UpdateOrCreateFeedbackMutationVariables>;

/**
 * __useUpdateOrCreateFeedbackMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrCreateFeedbackMutation, { data, loading, error }] = useUpdateOrCreateFeedbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *      objectType: // value for 'objectType'
 *      objectId: // value for 'objectId'
 *      ratingType: // value for 'ratingType'
 *      rating: // value for 'rating'
 *      response: // value for 'response'
 *   },
 * });
 */
export function useUpdateOrCreateFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrCreateFeedbackMutation, UpdateOrCreateFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrCreateFeedbackMutation, UpdateOrCreateFeedbackMutationVariables>(UpdateOrCreateFeedbackDocument, options);
      }
export type UpdateOrCreateFeedbackMutationHookResult = ReturnType<typeof useUpdateOrCreateFeedbackMutation>;
export type UpdateOrCreateFeedbackMutationResult = Apollo.MutationResult<UpdateOrCreateFeedbackMutation>;
export type UpdateOrCreateFeedbackMutationOptions = Apollo.BaseMutationOptions<UpdateOrCreateFeedbackMutation, UpdateOrCreateFeedbackMutationVariables>;
export const CoachRepAssignmentDocument = gql`
    query CoachRepAssignment($id: UUID!) {
  coachRepAssignment(id: $id) {
    ...RepAssignmentFragment
  }
}
    ${RepAssignmentFragmentDoc}`;

/**
 * __useCoachRepAssignmentQuery__
 *
 * To run a query within a React component, call `useCoachRepAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachRepAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachRepAssignmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCoachRepAssignmentQuery(baseOptions: Apollo.QueryHookOptions<CoachRepAssignmentQuery, CoachRepAssignmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoachRepAssignmentQuery, CoachRepAssignmentQueryVariables>(CoachRepAssignmentDocument, options);
      }
export function useCoachRepAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoachRepAssignmentQuery, CoachRepAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoachRepAssignmentQuery, CoachRepAssignmentQueryVariables>(CoachRepAssignmentDocument, options);
        }
export type CoachRepAssignmentQueryHookResult = ReturnType<typeof useCoachRepAssignmentQuery>;
export type CoachRepAssignmentLazyQueryHookResult = ReturnType<typeof useCoachRepAssignmentLazyQuery>;
export type CoachRepAssignmentQueryResult = Apollo.QueryResult<CoachRepAssignmentQuery, CoachRepAssignmentQueryVariables>;
export const CoachRepAssignmentsDocument = gql`
    query CoachRepAssignments($paginate: BaseClassicPaginate, $sorts: [RepAssignmentSort!], $conditions: RepAssignmentConditions) {
  coachRepAssignments(paginate: $paginate, sorts: $sorts, conditions: $conditions) {
    totalCount
    pageInfo {
      afterCursor
      beforeCursor
    }
    nodes {
      ...CoachRepAssignmentFragment
    }
  }
}
    ${CoachRepAssignmentFragmentDoc}`;

/**
 * __useCoachRepAssignmentsQuery__
 *
 * To run a query within a React component, call `useCoachRepAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachRepAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachRepAssignmentsQuery({
 *   variables: {
 *      paginate: // value for 'paginate'
 *      sorts: // value for 'sorts'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useCoachRepAssignmentsQuery(baseOptions?: Apollo.QueryHookOptions<CoachRepAssignmentsQuery, CoachRepAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoachRepAssignmentsQuery, CoachRepAssignmentsQueryVariables>(CoachRepAssignmentsDocument, options);
      }
export function useCoachRepAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoachRepAssignmentsQuery, CoachRepAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoachRepAssignmentsQuery, CoachRepAssignmentsQueryVariables>(CoachRepAssignmentsDocument, options);
        }
export type CoachRepAssignmentsQueryHookResult = ReturnType<typeof useCoachRepAssignmentsQuery>;
export type CoachRepAssignmentsLazyQueryHookResult = ReturnType<typeof useCoachRepAssignmentsLazyQuery>;
export type CoachRepAssignmentsQueryResult = Apollo.QueryResult<CoachRepAssignmentsQuery, CoachRepAssignmentsQueryVariables>;
export const RepAssignmentDocument = gql`
    query RepAssignment($id: UUID!) {
  repAssignment(id: $id) {
    ...RepAssignmentFragment
  }
}
    ${RepAssignmentFragmentDoc}`;

/**
 * __useRepAssignmentQuery__
 *
 * To run a query within a React component, call `useRepAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepAssignmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRepAssignmentQuery(baseOptions: Apollo.QueryHookOptions<RepAssignmentQuery, RepAssignmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepAssignmentQuery, RepAssignmentQueryVariables>(RepAssignmentDocument, options);
      }
export function useRepAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepAssignmentQuery, RepAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepAssignmentQuery, RepAssignmentQueryVariables>(RepAssignmentDocument, options);
        }
export type RepAssignmentQueryHookResult = ReturnType<typeof useRepAssignmentQuery>;
export type RepAssignmentLazyQueryHookResult = ReturnType<typeof useRepAssignmentLazyQuery>;
export type RepAssignmentQueryResult = Apollo.QueryResult<RepAssignmentQuery, RepAssignmentQueryVariables>;
export const RepAssignmentSummariesDocument = gql`
    query RepAssignmentSummaries($statuses: [RepAssignmentStatus!] = [NEW, SUBMITTED, REVIEWED, APPROVED], $limit: Int!, $cursor: String, $sorts: [RepAssignmentSort!] = [CREATED_AT_ASC]) {
  repAssignments(
    paginate: {limit: $limit, cursor: $cursor}
    sorts: $sorts
    conditions: {repAssignmentStatus: {in: $statuses}}
  ) {
    totalCount
    pageInfo {
      afterCursor
      beforeCursor
    }
    nodes {
      ..._RepAssignmentSummary
    }
  }
}
    ${_RepAssignmentSummaryFragmentDoc}`;

/**
 * __useRepAssignmentSummariesQuery__
 *
 * To run a query within a React component, call `useRepAssignmentSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepAssignmentSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepAssignmentSummariesQuery({
 *   variables: {
 *      statuses: // value for 'statuses'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useRepAssignmentSummariesQuery(baseOptions: Apollo.QueryHookOptions<RepAssignmentSummariesQuery, RepAssignmentSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepAssignmentSummariesQuery, RepAssignmentSummariesQueryVariables>(RepAssignmentSummariesDocument, options);
      }
export function useRepAssignmentSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepAssignmentSummariesQuery, RepAssignmentSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepAssignmentSummariesQuery, RepAssignmentSummariesQueryVariables>(RepAssignmentSummariesDocument, options);
        }
export type RepAssignmentSummariesQueryHookResult = ReturnType<typeof useRepAssignmentSummariesQuery>;
export type RepAssignmentSummariesLazyQueryHookResult = ReturnType<typeof useRepAssignmentSummariesLazyQuery>;
export type RepAssignmentSummariesQueryResult = Apollo.QueryResult<RepAssignmentSummariesQuery, RepAssignmentSummariesQueryVariables>;
export const RepAssignmentsDocument = gql`
    query RepAssignments($statuses: [RepAssignmentStatus!] = [NEW, SUBMITTED, REVIEWED, APPROVED], $limit: Int!, $cursor: String, $sorts: [RepAssignmentSort!] = [UPDATED_AT_DESC, CREATED_AT_DESC]) {
  repAssignments(
    paginate: {limit: $limit, cursor: $cursor}
    sorts: $sorts
    conditions: {repAssignmentStatus: {in: $statuses}}
  ) {
    totalCount
    pageInfo {
      afterCursor
      beforeCursor
    }
    nodes {
      ...RepAssignmentFragment
    }
  }
}
    ${RepAssignmentFragmentDoc}`;

/**
 * __useRepAssignmentsQuery__
 *
 * To run a query within a React component, call `useRepAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepAssignmentsQuery({
 *   variables: {
 *      statuses: // value for 'statuses'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useRepAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<RepAssignmentsQuery, RepAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepAssignmentsQuery, RepAssignmentsQueryVariables>(RepAssignmentsDocument, options);
      }
export function useRepAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepAssignmentsQuery, RepAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepAssignmentsQuery, RepAssignmentsQueryVariables>(RepAssignmentsDocument, options);
        }
export type RepAssignmentsQueryHookResult = ReturnType<typeof useRepAssignmentsQuery>;
export type RepAssignmentsLazyQueryHookResult = ReturnType<typeof useRepAssignmentsLazyQuery>;
export type RepAssignmentsQueryResult = Apollo.QueryResult<RepAssignmentsQuery, RepAssignmentsQueryVariables>;
export const RepSubmissionCreateV2Document = gql`
    mutation RepSubmissionCreateV2($repAssignmentId: UUID!, $responseType: String!, $content: String, $masterMediaId: UUID) {
  repSubmissionCreateV2(
    repAssignmentId: $repAssignmentId
    responseType: $responseType
    masterMediaId: $masterMediaId
    content: $content
  ) {
    ..._RepSubmission
  }
}
    ${_RepSubmissionFragmentDoc}`;
export type RepSubmissionCreateV2MutationFn = Apollo.MutationFunction<RepSubmissionCreateV2Mutation, RepSubmissionCreateV2MutationVariables>;

/**
 * __useRepSubmissionCreateV2Mutation__
 *
 * To run a mutation, you first call `useRepSubmissionCreateV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRepSubmissionCreateV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [repSubmissionCreateV2Mutation, { data, loading, error }] = useRepSubmissionCreateV2Mutation({
 *   variables: {
 *      repAssignmentId: // value for 'repAssignmentId'
 *      responseType: // value for 'responseType'
 *      content: // value for 'content'
 *      masterMediaId: // value for 'masterMediaId'
 *   },
 * });
 */
export function useRepSubmissionCreateV2Mutation(baseOptions?: Apollo.MutationHookOptions<RepSubmissionCreateV2Mutation, RepSubmissionCreateV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RepSubmissionCreateV2Mutation, RepSubmissionCreateV2MutationVariables>(RepSubmissionCreateV2Document, options);
      }
export type RepSubmissionCreateV2MutationHookResult = ReturnType<typeof useRepSubmissionCreateV2Mutation>;
export type RepSubmissionCreateV2MutationResult = Apollo.MutationResult<RepSubmissionCreateV2Mutation>;
export type RepSubmissionCreateV2MutationOptions = Apollo.BaseMutationOptions<RepSubmissionCreateV2Mutation, RepSubmissionCreateV2MutationVariables>;
export const RepSubmissionFeedbackCreateDocument = gql`
    mutation RepSubmissionFeedbackCreate($repSubmissionId: UUID!, $responseType: RepResponseKind!, $reviewerRole: String!, $feedbackType: RepFeedbackType!, $content: String!, $tempContentWithoutTags: String, $caption: String, $mentions: [Mention!], $rubricForm: RubricFormV1) {
  repSubmissionFeedbackCreate(
    repSubmissionId: $repSubmissionId
    responseType: $responseType
    reviewerRole: $reviewerRole
    feedbackType: $feedbackType
    content: $content
    tempContentWithoutTags: $tempContentWithoutTags
    caption: $caption
    mentions: $mentions
    rubricForm: $rubricForm
  ) {
    ..._RepSubmissionFeedback
  }
}
    ${_RepSubmissionFeedbackFragmentDoc}`;
export type RepSubmissionFeedbackCreateMutationFn = Apollo.MutationFunction<RepSubmissionFeedbackCreateMutation, RepSubmissionFeedbackCreateMutationVariables>;

/**
 * __useRepSubmissionFeedbackCreateMutation__
 *
 * To run a mutation, you first call `useRepSubmissionFeedbackCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRepSubmissionFeedbackCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [repSubmissionFeedbackCreateMutation, { data, loading, error }] = useRepSubmissionFeedbackCreateMutation({
 *   variables: {
 *      repSubmissionId: // value for 'repSubmissionId'
 *      responseType: // value for 'responseType'
 *      reviewerRole: // value for 'reviewerRole'
 *      feedbackType: // value for 'feedbackType'
 *      content: // value for 'content'
 *      tempContentWithoutTags: // value for 'tempContentWithoutTags'
 *      caption: // value for 'caption'
 *      mentions: // value for 'mentions'
 *      rubricForm: // value for 'rubricForm'
 *   },
 * });
 */
export function useRepSubmissionFeedbackCreateMutation(baseOptions?: Apollo.MutationHookOptions<RepSubmissionFeedbackCreateMutation, RepSubmissionFeedbackCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RepSubmissionFeedbackCreateMutation, RepSubmissionFeedbackCreateMutationVariables>(RepSubmissionFeedbackCreateDocument, options);
      }
export type RepSubmissionFeedbackCreateMutationHookResult = ReturnType<typeof useRepSubmissionFeedbackCreateMutation>;
export type RepSubmissionFeedbackCreateMutationResult = Apollo.MutationResult<RepSubmissionFeedbackCreateMutation>;
export type RepSubmissionFeedbackCreateMutationOptions = Apollo.BaseMutationOptions<RepSubmissionFeedbackCreateMutation, RepSubmissionFeedbackCreateMutationVariables>;
export const SocialRepAssignmentDocument = gql`
    query SocialRepAssignment($id: UUID!) {
  socialRepAssignment(id: $id) {
    ...RepAssignmentFragment
  }
}
    ${RepAssignmentFragmentDoc}`;

/**
 * __useSocialRepAssignmentQuery__
 *
 * To run a query within a React component, call `useSocialRepAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialRepAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialRepAssignmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSocialRepAssignmentQuery(baseOptions: Apollo.QueryHookOptions<SocialRepAssignmentQuery, SocialRepAssignmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialRepAssignmentQuery, SocialRepAssignmentQueryVariables>(SocialRepAssignmentDocument, options);
      }
export function useSocialRepAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialRepAssignmentQuery, SocialRepAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialRepAssignmentQuery, SocialRepAssignmentQueryVariables>(SocialRepAssignmentDocument, options);
        }
export type SocialRepAssignmentQueryHookResult = ReturnType<typeof useSocialRepAssignmentQuery>;
export type SocialRepAssignmentLazyQueryHookResult = ReturnType<typeof useSocialRepAssignmentLazyQuery>;
export type SocialRepAssignmentQueryResult = Apollo.QueryResult<SocialRepAssignmentQuery, SocialRepAssignmentQueryVariables>;
export const SocialRepAssignmentsDocument = gql`
    query SocialRepAssignments($limit: Int = 10, $cursor: String, $sorts: [RepAssignmentSort!] = [CREATED_AT_ASC], $conditions: SocialRepAssignmentConditions) {
  socialReps(
    paginate: {limit: $limit, cursor: $cursor}
    sorts: $sorts
    conditions: $conditions
  ) {
    totalCount
    pageInfo {
      afterCursor
      beforeCursor
    }
    nodes {
      ...SocialRepAssignmentFragment
    }
  }
}
    ${SocialRepAssignmentFragmentDoc}`;

/**
 * __useSocialRepAssignmentsQuery__
 *
 * To run a query within a React component, call `useSocialRepAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialRepAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialRepAssignmentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      sorts: // value for 'sorts'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useSocialRepAssignmentsQuery(baseOptions?: Apollo.QueryHookOptions<SocialRepAssignmentsQuery, SocialRepAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialRepAssignmentsQuery, SocialRepAssignmentsQueryVariables>(SocialRepAssignmentsDocument, options);
      }
export function useSocialRepAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialRepAssignmentsQuery, SocialRepAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialRepAssignmentsQuery, SocialRepAssignmentsQueryVariables>(SocialRepAssignmentsDocument, options);
        }
export type SocialRepAssignmentsQueryHookResult = ReturnType<typeof useSocialRepAssignmentsQuery>;
export type SocialRepAssignmentsLazyQueryHookResult = ReturnType<typeof useSocialRepAssignmentsLazyQuery>;
export type SocialRepAssignmentsQueryResult = Apollo.QueryResult<SocialRepAssignmentsQuery, SocialRepAssignmentsQueryVariables>;
export const SocialRepAssignmentsByPromptDocument = gql`
    query SocialRepAssignmentsByPrompt($limit: Int = 3, $cursor: String, $sorts: [RepAssignmentSort!], $conditions: SocialRepAssignmentByPromptConditions, $assignmentsPaginates: [SocialRepAssignmentByPromptListArgs!]!) {
  socialRepsByPrompt(
    paginate: {limit: $limit, cursor: $cursor}
    sorts: $sorts
    conditions: $conditions
  ) {
    totalCount
    pageInfo {
      afterCursor
      beforeCursor
    }
    nodes {
      id
      repAssignmentId
      isRepeatable
      repPromptLocalized {
        id
        content
        language
      }
      skill {
        id
        skillLocalized {
          id
          description
        }
      }
      paginatedAssignments(paginates: $assignmentsPaginates) {
        totalCount
        pageInfo {
          afterCursor
          beforeCursor
        }
        nodes {
          id
          points
          repAssignmentStatus
          lastActivityAt
          repSubmissions {
            nodes {
              id
              content
              responseType
              createdAt
              media {
                id
                mediaUrl: mediaUrlV2
              }
              streamMedia {
                id
                mediaUrl: mediaUrlV2
              }
              posterMedia {
                id
                mediaUrl: mediaUrlV2
              }
            }
          }
          learnerCompanyProfile {
            id
            externalId
            language
            profile {
              id
              preferredName
              displayName
              ...ProfilePhotoFragment
            }
          }
        }
      }
    }
  }
}
    ${ProfilePhotoFragmentDoc}`;

/**
 * __useSocialRepAssignmentsByPromptQuery__
 *
 * To run a query within a React component, call `useSocialRepAssignmentsByPromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialRepAssignmentsByPromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialRepAssignmentsByPromptQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      sorts: // value for 'sorts'
 *      conditions: // value for 'conditions'
 *      assignmentsPaginates: // value for 'assignmentsPaginates'
 *   },
 * });
 */
export function useSocialRepAssignmentsByPromptQuery(baseOptions: Apollo.QueryHookOptions<SocialRepAssignmentsByPromptQuery, SocialRepAssignmentsByPromptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialRepAssignmentsByPromptQuery, SocialRepAssignmentsByPromptQueryVariables>(SocialRepAssignmentsByPromptDocument, options);
      }
export function useSocialRepAssignmentsByPromptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialRepAssignmentsByPromptQuery, SocialRepAssignmentsByPromptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialRepAssignmentsByPromptQuery, SocialRepAssignmentsByPromptQueryVariables>(SocialRepAssignmentsByPromptDocument, options);
        }
export type SocialRepAssignmentsByPromptQueryHookResult = ReturnType<typeof useSocialRepAssignmentsByPromptQuery>;
export type SocialRepAssignmentsByPromptLazyQueryHookResult = ReturnType<typeof useSocialRepAssignmentsByPromptLazyQuery>;
export type SocialRepAssignmentsByPromptQueryResult = Apollo.QueryResult<SocialRepAssignmentsByPromptQuery, SocialRepAssignmentsByPromptQueryVariables>;
export const SocialRepAssignmentsListDocument = gql`
    query SocialRepAssignmentsList($limit: Int = 10, $cursor: String, $conditions: RepAssignmentListConditions) {
  socialRepAssignments(
    paginate: {limit: $limit, cursor: $cursor}
    conditions: $conditions
  ) {
    totalCount
    pageInfo {
      afterCursor
      beforeCursor
    }
    nodes {
      ...RepAssignmentFragment
    }
  }
}
    ${RepAssignmentFragmentDoc}`;

/**
 * __useSocialRepAssignmentsListQuery__
 *
 * To run a query within a React component, call `useSocialRepAssignmentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialRepAssignmentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialRepAssignmentsListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      conditions: // value for 'conditions'
 *   },
 * });
 */
export function useSocialRepAssignmentsListQuery(baseOptions?: Apollo.QueryHookOptions<SocialRepAssignmentsListQuery, SocialRepAssignmentsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialRepAssignmentsListQuery, SocialRepAssignmentsListQueryVariables>(SocialRepAssignmentsListDocument, options);
      }
export function useSocialRepAssignmentsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialRepAssignmentsListQuery, SocialRepAssignmentsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialRepAssignmentsListQuery, SocialRepAssignmentsListQueryVariables>(SocialRepAssignmentsListDocument, options);
        }
export type SocialRepAssignmentsListQueryHookResult = ReturnType<typeof useSocialRepAssignmentsListQuery>;
export type SocialRepAssignmentsListLazyQueryHookResult = ReturnType<typeof useSocialRepAssignmentsListLazyQuery>;
export type SocialRepAssignmentsListQueryResult = Apollo.QueryResult<SocialRepAssignmentsListQuery, SocialRepAssignmentsListQueryVariables>;
export const RepAssignmentsCountDocument = gql`
    query RepAssignmentsCount($statuses: [RepAssignmentStatus!]) {
  repAssignments(
    paginate: {limit: 1}
    conditions: {repAssignmentStatus: {in: $statuses}}
  ) {
    totalCount
  }
}
    `;

/**
 * __useRepAssignmentsCountQuery__
 *
 * To run a query within a React component, call `useRepAssignmentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepAssignmentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepAssignmentsCountQuery({
 *   variables: {
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useRepAssignmentsCountQuery(baseOptions?: Apollo.QueryHookOptions<RepAssignmentsCountQuery, RepAssignmentsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepAssignmentsCountQuery, RepAssignmentsCountQueryVariables>(RepAssignmentsCountDocument, options);
      }
export function useRepAssignmentsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepAssignmentsCountQuery, RepAssignmentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepAssignmentsCountQuery, RepAssignmentsCountQueryVariables>(RepAssignmentsCountDocument, options);
        }
export type RepAssignmentsCountQueryHookResult = ReturnType<typeof useRepAssignmentsCountQuery>;
export type RepAssignmentsCountLazyQueryHookResult = ReturnType<typeof useRepAssignmentsCountLazyQuery>;
export type RepAssignmentsCountQueryResult = Apollo.QueryResult<RepAssignmentsCountQuery, RepAssignmentsCountQueryVariables>;